// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: `${string}://${string}` | (string & {});
};

export enum ActivityType {
    CREATION = 'creation',
    UPDATE = 'update',
    DELETION = 'deletion',
    ARCHIVAL = 'archival',
    CANCELLATION = 'cancellation',
}

export type AgebandCapacityData = {
    infants_on_lap?: number;
    infants?: number;
    children?: number;
    youth?: number;
    adults?: number;
    seniors?: number;
    students?: number;
    eu_citizens?: number;
    eu_citizen_students?: number;
    military?: number;
    groups?: number;
    collectives?: number;
    total_in_collectives?: number;
    type: 'ageband';
};

export type AgebandPricingData = {
    type: 'per_ageband';
    base_amount?: number;
    infants?: number;
    children?: number;
    youth?: number;
    adults?: number;
    seniors?: number;
};

export type ApplicationMetadata = {
    environment: EnvironmentName;
    name: string;
    version: string;
};

export type AssetPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export enum AttendanceType {
    PRESENCE = 'presence',
    ABSENCE = 'absence',
}

export type BaseIntegrationManifestData = {
    otas?: Array<GetYourGuideManifestData>;
};

export type BaseManifestData = {
    app: ApplicationMetadata;
    destinations?: Array<SupportedDestination>;
    integrations?: BaseIntegrationManifestData;
};

export type BaseSubscriptionProductFeaturesData = {
    autoscaled?: boolean;
};

export type BaseSubscriptionUserCalendarFeaturesData = {
    multi_timezone: boolean;
    workweek: WorkWeekFeature;
    daily: DailyConfigurationFeature;
};

export type BaseSubscriptionUserCollaborationFeaturesData = {
    team?: TeamCollaborationFeature;
};

export type BaseSubscriptionUserFinancialFeaturesData = {
    multi_currency: boolean;
};

export type BirthDetailsData = {
    date?: number;
    place?: LocationDataModel;
    nationality?: Nationality;
};

export type BookingHoldExpiryConfig = {
    duration: TimeOffset;
};

export enum BookingItemCategory {
    ADULT = 'ADULT',
    CHILD = 'CHILD',
    INFANT = 'INFANT',
    YOUTH = 'YOUTH',
    SENIOR = 'SENIOR',
    STUDENT = 'STUDENT',
    EU_CITIZEN = 'EU_CITIZEN',
    MILITARY = 'MILITARY',
    EU_CITIZEN_STUDENT = 'EU_CITIZEN_STUDENT',
    GROUP = 'GROUP',
    COLLECTIVE = 'COLLECTIVE',
}

export type BookingPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type BookingReport = {
    report_type: 'booking';
    filetype?: 'xlsx';
    filename: string;
    action?: 'created' | 'last_updated' | 'deleted';
    at_start?: number;
    at_end?: number;
    by_id?: string;
    by_name?: string;
    product_types?: Array<string>;
    statuses?: Array<BookingStatus>;
    order_number?: string;
    event_id?: string;
    start_ts?: number;
    end_ts?: number;
    source_type?: BookingSourceType;
    source_name?: string;
    source_email?: string;
    text_search?: string;
    page_number?: number;
    page_size?: number;
    start_at_id?: string;
};

export type BookingSourceSummary = {
    period: Period;
    confirmed: number;
    cancelled: number;
    draft: number;
    hold: number;
    total: number;
    source: string;
    revenue: number;
};

export enum BookingSourceType {
    DIRECT = 'direct',
    REFERRAL = 'referral',
}

export type BookingStats = {
    revenue_chart: Array<RevenueChart>;
    product_summary: Array<ProductSummary>;
    product_type_summary: Array<ProductTypeSummary>;
    booking_source_summary: Array<BookingSourceSummary>;
    bookings_count: Array<BookingsCount>;
};

export enum BookingStatsGranularity {
    DAYS = 'days',
    MONTHS = 'months',
    YEARS = 'years',
}

export enum BookingStatus {
    DRAFT = 'draft',
    HOLD = 'hold',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled',
}

export type BookingsCount = {
    period: Period;
    confirmed: number;
    cancelled: number;
    draft: number;
    hold: number;
    total: number;
};

export type CapacityPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export enum CapacityType {
    VEHICLE = 'vehicle',
}

export type CityData = {
    name: string;
    un_locode: string;
};

export enum ContentType {
    APPLICATION_PDF = 'application/pdf',
    IMAGE_JPEG = 'image/jpeg',
    IMAGE_JPG = 'image/jpg',
    IMAGE_PNG = 'image/png',
    IMAGE_AVIF = 'image/avif',
    APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export enum Country {
    ALBANIA = 'albania',
    ALGERIA = 'algeria',
    ANDORRA = 'andorra',
    ANGOLA = 'angola',
    ANTIGUA_AND_BARBUDA = 'antigua and barbuda',
    ARGENTINA = 'argentina',
    ARMENIA = 'armenia',
    AUSTRALIA = 'australia',
    AUSTRIA = 'austria',
    AZERBAIJAN = 'azerbaijan',
    BAHAMAS = 'bahamas',
    BAHRAIN = 'bahrain',
    BANGLADESH = 'bangladesh',
    BARBADOS = 'barbados',
    BELARUS = 'belarus',
    BELGIUM = 'belgium',
    BELIZE = 'belize',
    BENIN = 'benin',
    BHUTAN = 'bhutan',
    BOLIVIA = 'bolivia',
    BOSNIA_AND_HERZEGOVINA = 'bosnia and herzegovina',
    BOTSWANA = 'botswana',
    BRAZIL = 'brazil',
    BRUNEI = 'brunei',
    BULGARIA = 'bulgaria',
    BURKINA_FASO = 'burkina faso',
    BURUNDI = 'burundi',
    CÔTE_D_IVOIRE = 'côte d_ivoire',
    CABO_VERDE = 'cabo verde',
    CAMBODIA = 'cambodia',
    CAMEROON = 'cameroon',
    CANADA = 'canada',
    CENTRAL_AFRICAN_REPUBLIC = 'central african republic',
    CHAD = 'chad',
    CHILE = 'chile',
    CHINA = 'china',
    COLOMBIA = 'colombia',
    COMOROS = 'comoros',
    'CONGO (CONGO_BRAZZAVILLE)' = 'congo (congo-brazzaville)',
    COSTA_RICA = 'costa rica',
    CROATIA = 'croatia',
    CUBA = 'cuba',
    CYPRUS = 'cyprus',
    CZECH_REPUBLIC = 'czech republic',
    DEMOCRATIC_REPUBLIC_OF_THE_CONGO = 'democratic republic of the congo',
    DENMARK = 'denmark',
    DJIBOUTI = 'djibouti',
    DOMINICA = 'dominica',
    DOMINICAN_REPUBLIC = 'dominican republic',
    ECUADOR = 'ecuador',
    EGYPT = 'egypt',
    EL_SALVADOR = 'el salvador',
    EQUATORIAL_GUINEA = 'equatorial guinea',
    ERITREA = 'eritrea',
    ESTONIA = 'estonia',
    ESWATINI = 'eswatini',
    ETHIOPIA = 'ethiopia',
    FIJI = 'fiji',
    FINLAND = 'finland',
    FRANCE = 'france',
    GABON = 'gabon',
    GAMBIA = 'gambia',
    GEORGIA = 'georgia',
    GERMANY = 'germany',
    GHANA = 'ghana',
    GREECE = 'greece',
    GRENADA = 'grenada',
    GUATEMALA = 'guatemala',
    GUINEA = 'guinea',
    GUINEA_BISSAU = 'guinea-bissau',
    GUYANA = 'guyana',
    HAITI = 'haiti',
    HOLY_SEE = 'holy see',
    HONDURAS = 'honduras',
    HUNGARY = 'hungary',
    ICELAND = 'iceland',
    INDIA = 'india',
    INDONESIA = 'indonesia',
    IRAN = 'iran',
    IRAQ = 'iraq',
    IRELAND = 'ireland',
    ISRAEL = 'israel',
    ITALY = 'italy',
    JAMAICA = 'jamaica',
    JAPAN = 'japan',
    JORDAN = 'jordan',
    KAZAKHSTAN = 'kazakhstan',
    KENYA = 'kenya',
    KIRIBATI = 'kiribati',
    KUWAIT = 'kuwait',
    KYRGYZSTAN = 'kyrgyzstan',
    LAOS = 'laos',
    LATVIA = 'latvia',
    LEBANON = 'lebanon',
    LESOTHO = 'lesotho',
    LIBERIA = 'liberia',
    LIBYA = 'libya',
    LIECHTENSTEIN = 'liechtenstein',
    LITHUANIA = 'lithuania',
    LUXEMBOURG = 'luxembourg',
    MADAGASCAR = 'madagascar',
    MALAWI = 'malawi',
    MALAYSIA = 'malaysia',
    MALDIVES = 'maldives',
    MALI = 'mali',
    MALTA = 'malta',
    MARSHALL_ISLANDS = 'marshall islands',
    MAURITANIA = 'mauritania',
    MAURITIUS = 'mauritius',
    MEXICO = 'mexico',
    MICRONESIA = 'micronesia',
    MOLDOVA = 'moldova',
    MONACO = 'monaco',
    MONGOLIA = 'mongolia',
    MONTENEGRO = 'montenegro',
    MOROCCO = 'morocco',
    MOZAMBIQUE = 'mozambique',
    MYANMAR = 'myanmar',
    NAMIBIA = 'namibia',
    NAURU = 'nauru',
    NEPAL = 'nepal',
    NETHERLANDS = 'netherlands',
    NEW_ZEALAND = 'new zealand',
    NICARAGUA = 'nicaragua',
    NIGER = 'niger',
    NIGERIA = 'nigeria',
    NORTH_KOREA = 'north korea',
    NORTH_MACEDONIA = 'north macedonia',
    NORWAY = 'norway',
    OMAN = 'oman',
    PAKISTAN = 'pakistan',
    PALAU = 'palau',
    PALESTINE_STATE = 'palestine state',
    PANAMA = 'panama',
    PAPUA_NEW_GUINEA = 'papua new guinea',
    PARAGUAY = 'paraguay',
    PERU = 'peru',
    PHILIPPINES = 'philippines',
    POLAND = 'poland',
    PORTUGAL = 'portugal',
    QATAR = 'qatar',
    ROMANIA = 'romania',
    RUSSIA = 'russia',
    RWANDA = 'rwanda',
    SAINT_KITTS_AND_NEVIS = 'saint kitts and nevis',
    SAINT_LUCIA = 'saint lucia',
    SAINT_VINCENT_AND_THE_GRENADINES = 'saint vincent and the grenadines',
    SAMOA = 'samoa',
    SAN_MARINO = 'san marino',
    SAO_TOME_AND_PRINCIPE = 'sao tome and principe',
    SAUDI_ARABIA = 'saudi arabia',
    SENEGAL = 'senegal',
    SERBIA = 'serbia',
    SEYCHELLES = 'seychelles',
    SIERRA_LEONE = 'sierra leone',
    SINGAPORE = 'singapore',
    SLOVAKIA = 'slovakia',
    SLOVENIA = 'slovenia',
    SOLOMON_ISLANDS = 'solomon islands',
    SOMALIA = 'somalia',
    SOUTH_AFRICA = 'south africa',
    SOUTH_KOREA = 'south korea',
    SOUTH_SUDAN = 'south sudan',
    SPAIN = 'spain',
    SRI_LANKA = 'sri lanka',
    SUDAN = 'sudan',
    SURINAME = 'suriname',
    SWEDEN = 'sweden',
    SWITZERLAND = 'switzerland',
    SYRIA = 'syria',
    TAJIKISTAN = 'tajikistan',
    TANZANIA = 'tanzania',
    THAILAND = 'thailand',
    TIMOR_LESTE = 'timor-leste',
    TOGO = 'togo',
    TONGA = 'tonga',
    TRINIDAD_AND_TOBAGO = 'trinidad and tobago',
    TUNISIA = 'tunisia',
    TURKEY = 'turkey',
    TURKMENISTAN = 'turkmenistan',
    TUVALU = 'tuvalu',
    UGANDA = 'uganda',
    UKRAINE = 'ukraine',
    UNITED_ARAB_EMIRATES = 'united arab emirates',
    UNITED_KINGDOM = 'united kingdom',
    UNITED_STATES_OF_AMERICA = 'united states of america',
    URUGUAY = 'uruguay',
    UZBEKISTAN = 'uzbekistan',
    VANUATU = 'vanuatu',
    VENEZUELA = 'venezuela',
    VIETNAM = 'vietnam',
    YEMEN = 'yemen',
    ZAMBIA = 'zambia',
    ZIMBABWE = 'zimbabwe',
}

export type CountryData = {
    name: string;
    iso3166v1: Iso3166V1;
};

export type CreateReportResponse = {
    id: string;
};

export type Currency = {
    name: string;
    abbr: string;
    rate?: number;
};

export type CurrencySetting = {
    name: string;
    abbr: string;
    rate?: number;
    base?: boolean;
};

export type CustomerPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type DailyConfigurationFeature = {
    max_events?: number;
};

export type DashboardPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type DatePeriodData = {
    timezone?: TimezoneData;
    duration?: TimeOffset;
    start: number;
    end?: number;
};

export enum DayOfWeek {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday',
}

export enum DirectSource {
    WALK_IN = 'walk_in',
    EMAIL = 'email',
    PHONE_CALL = 'phone_call',
    WEBSITE = 'website',
    FACEBOOK_MESSENGER = 'facebook_messenger',
    WHATSAPP = 'whatsapp',
    INSTAGRAM = 'instagram',
    LIVE_CHAT = 'live_chat',
    TELEGRAM = 'telegram',
}

export type DiscountData = {
    type: DiscountType;
    amount: number;
};

export enum DiscountType {
    ABSOLUTE = 'absolute',
    RELATIVE = 'relative',
}

export type DualCurrencyData = {
    original: FlatPricingData | AgebandPricingData | number;
    converted?: FlatPricingData | AgebandPricingData | number;
};

export type EnterpriseSubscriptionData = {
    name?: 'enterprise';
    user?: EnterpriseSubscriptionUserFeaturesData;
    resources?: Array<ResourceType>;
};

export type EnterpriseSubscriptionUserFeaturesData = {
    calendar?: BaseSubscriptionUserCalendarFeaturesData;
    financial?: BaseSubscriptionUserFinancialFeaturesData;
    collaboration?: BaseSubscriptionUserCollaborationFeaturesData;
    product?: BaseSubscriptionProductFeaturesData;
};

export enum EnvironmentName {
    DEV = 'dev',
    STAGING = 'staging',
    PRODUCTION = 'production',
}

export type EventPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export enum EventStatus {
    DRAFT = 'draft',
    UPCOMING = 'upcoming',
    ONGOING = 'ongoing',
    FINISHED = 'finished',
    CANCELLED = 'cancelled',
    UNKNOWN = 'unknown',
}

export type FilePermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    move?: boolean;
};

export enum FileType {
    IMAGE = 'image',
    PDF = 'pdf',
    XLSX = 'xlsx',
}

export type FlatCapacityData = {
    type: 'flat';
    min: number;
    max: number;
};

export type FlatPricingData = {
    type: 'per_person' | 'per_product';
    base_amount?: number;
    unit_amount: number;
};

export type FreeSubscriptionData = {
    name?: 'free';
    user?: FreeSubscriptionUserFeaturesData;
    resources?: Array<ResourceType>;
};

export type FreeSubscriptionUserFeaturesData = {
    calendar?: BaseSubscriptionUserCalendarFeaturesData;
    financial?: BaseSubscriptionUserFinancialFeaturesData;
    collaboration?: BaseSubscriptionUserCollaborationFeaturesData;
    product?: BaseSubscriptionProductFeaturesData;
};

export type GeoData = {
    country: CountryData;
    city: CityData;
    coordinates?: Coordinates;
};

export type GetYourGuideManifestData = {
    name?: 'getyourguide';
    display_name?: string;
};

export type HttpValidationError = {
    detail?: Array<ValidationError>;
};

export type Iso3166V1 = {
    alpha2: string;
    alpha3: string;
};

export enum Language {
    ARMENIAN = 'armenian',
    ENGLISH = 'english',
    RUSSIAN = 'russian',
    MANDARIN = 'mandarin',
    HINDI = 'hindi',
    SPANISH = 'spanish',
    ITALIAN = 'italian',
    FRENCH = 'french',
    ARABIC = 'arabic',
    ESTONIAN = 'estonian',
    BENGALI = 'bengali',
    PORTUGUESE = 'portuguese',
    INDONESIAN = 'indonesian',
    URDU = 'urdu',
    JAPANESE = 'japanese',
    GERMAN = 'german',
    PUNJABI = 'punjabi',
    TURKISH = 'turkish',
    KOREAN = 'korean',
}

export enum ListItemAction {
    ADD = 'add',
    UPDATE = 'update',
    REMOVE = 'remove',
    REORDER = 'reorder',
}

export type LocationDataModel = {
    name: string;
    geo?: GeoData;
};

export type LocationPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    move?: boolean;
};

export type MonthlyRecurrenceData = {
    type: 'monthly';
    days_of_month: Array<number>;
};

export enum Nationality {
    AFGHAN = 'afghan',
    ALBANIAN = 'albanian',
    ALGERIAN = 'algerian',
    AMERICAN = 'american',
    ANDORRAN = 'andorran',
    ANGOLAN = 'angolan',
    ANGUILLAN = 'anguillan',
    CITIZEN_OF_ANTIGUA_AND_BARBUDA = 'citizen of antigua and barbuda',
    ARGENTINE = 'argentine',
    ARMENIAN = 'armenian',
    AUSTRALIAN = 'australian',
    AUSTRIAN = 'austrian',
    AZERBAIJANI = 'azerbaijani',
    BAHAMIAN = 'bahamian',
    BAHRAINI = 'bahraini',
    BANGLADESHI = 'bangladeshi',
    BARBADIAN = 'barbadian',
    BELARUSIAN = 'belarusian',
    BELGIAN = 'belgian',
    BELIZEAN = 'belizean',
    BENINESE = 'beninese',
    BERMUDIAN = 'bermudian',
    BHUTANESE = 'bhutanese',
    BOLIVIAN = 'bolivian',
    CITIZEN_OF_BOSNIA_AND_HERZEGOVINA = 'citizen of bosnia and herzegovina',
    BOTSWANAN = 'botswanan',
    BRAZILIAN = 'brazilian',
    BRITISH = 'british',
    BRITISH_VIRGIN_ISLANDER = 'british_virgin_islander',
    BRUNEIAN = 'bruneian',
    BULGARIAN = 'bulgarian',
    BURKINAN = 'burkinan',
    BURMESE = 'burmese',
    BURUNDIAN = 'burundian',
    CAMBODIAN = 'cambodian',
    CAMEROONIAN = 'cameroonian',
    CANADIAN = 'canadian',
    CAPE = 'cape',
    VERDEAN = 'verdean',
    CAYMAN_ISLANDER = 'cayman islander',
    CENTRAL = 'central',
    AFRICAN = 'african',
    CHADIAN = 'chadian',
    CHILEAN = 'chilean',
    CHINESE = 'chinese',
    COLOMBIAN = 'colombian',
    COMORAN = 'comoran',
    'CONGOLESE(CONGO)' = 'congolese(congo)',
    'CONGOLESE(DRC)' = 'congolese(drc)',
    COOK = 'cook',
    ISLANDER = 'islander',
    COSTA = 'costa',
    RICAN = 'rican',
    CROATIAN = 'croatian',
    CUBAN = 'cuban',
    CYMRAES = 'cymraes',
    CYMRO = 'cymro',
    CYPRIOT = 'cypriot',
    CZECH = 'czech',
    DANISH = 'danish',
    DJIBOUTIAN = 'djiboutian',
    DOMINICAN = 'dominican',
    CITIZEN_OF_THE_DOMINICAN_REPUBLIC = 'citizen of the dominican republic',
    DUTCH = 'dutch',
    EAST = 'east',
    TIMORESE = 'timorese',
    ECUADOREAN = 'ecuadorean',
    EGYPTIAN = 'egyptian',
    EMIRATI = 'emirati',
    ENGLISH = 'english',
    EQUATORIAL_GUINEAN = 'equatorial guinean',
    ERITREAN = 'eritrean',
    ESTONIAN = 'estonian',
    ETHIOPIAN = 'ethiopian',
    FAROESE = 'faroese',
    FIJIAN = 'fijian',
    FILIPINO = 'filipino',
    FINNISH = 'finnish',
    FRENCH = 'french',
    GABONESE = 'gabonese',
    GAMBIAN = 'gambian',
    GEORGIAN = 'georgian',
    GERMAN = 'german',
    GHANAIAN = 'ghanaian',
    GIBRALTARIAN = 'gibraltarian',
    GREEK = 'greek',
    GREENLANDIC = 'greenlandic',
    GRENADIAN = 'grenadian',
    GUAMANIAN = 'guamanian',
    GUATEMALAN = 'guatemalan',
    CITIZEN_OF_GUINEA_BISSAU = 'citizen of guinea - bissau',
    GUINEAN = 'guinean',
    GUYANESE = 'guyanese',
    HAITIAN = 'haitian',
    HONDURAN = 'honduran',
    HONG_KONGER = 'hong konger',
    HUNGARIAN = 'hungarian',
    ICELANDIC = 'icelandic',
    INDIAN = 'indian',
    INDONESIAN = 'indonesian',
    IRANIAN = 'iranian',
    IRAQI = 'iraqi',
    IRISH = 'irish',
    ISRAELI = 'israeli',
    ITALIAN = 'italian',
    IVORIAN = 'ivorian',
    JAMAICAN = 'jamaican',
    JAPANESE = 'japanese',
    JORDANIAN = 'jordanian',
    KAZAKH = 'kazakh',
    KENYAN = 'kenyan',
    KITTITIAN = 'kittitian',
    CITIZEN_OF_KIRIBATI = 'citizen of kiribati',
    KOSOVAN = 'kosovan',
    KUWAITI = 'kuwaiti',
    KYRGYZ = 'kyrgyz',
    LAO = 'lao',
    LATVIAN = 'latvian',
    LEBANESE = 'lebanese',
    LIBERIAN = 'liberian',
    LIBYAN = 'libyan',
    LIECHTENSTEIN_CITIZEN = 'liechtenstein citizen',
    LITHUANIAN = 'lithuanian',
    LUXEMBOURGER = 'luxembourger',
    MACANESE = 'macanese',
    MACEDONIAN = 'macedonian',
    MALAGASY = 'malagasy',
    MALAWIAN = 'malawian',
    MALAYSIAN = 'malaysian',
    MALDIVIAN = 'maldivian',
    MALIAN = 'malian',
    MALTESE = 'maltese',
    MARSHALLESE = 'marshallese',
    MARTINIQUAIS = 'martiniquais',
    MAURITANIAN = 'mauritanian',
    MAURITIAN = 'mauritian',
    MEXICAN = 'mexican',
    MICRONESIAN = 'micronesian',
    MOLDOVAN = 'moldovan',
    MONEGASQUE = 'monegasque',
    MONGOLIAN = 'mongolian',
    MONTENEGRIN = 'montenegrin',
    MONTSERRATIAN = 'montserratian',
    MOROCCAN = 'moroccan',
    MOSOTHO = 'mosotho',
    MOZAMBICAN = 'mozambican',
    NAMIBIAN = 'namibian',
    NAURUAN = 'nauruan',
    NEPALESE = 'nepalese',
    NEW_ZEALANDER = 'new zealander',
    NICARAGUAN = 'nicaraguan',
    NIGERIAN = 'nigerian',
    NIGERIEN = 'nigerien',
    NIUEAN = 'niuean',
    NORTH = 'north',
    KOREAN = 'korean',
    NORTHERN_IRISH = 'northern irish',
    NORWEGIAN = 'norwegian',
    OMANI = 'omani',
    PAKISTANI = 'pakistani',
    PALAUAN = 'palauan',
    PALESTINIAN = 'palestinian',
    PANAMANIAN = 'panamanian',
    PAPUA_NEW_GUINEAN = 'papua new guinean',
    PARAGUAYAN = 'paraguayan',
    PERUVIAN = 'peruvian',
    PITCAIRN_ISLANDER = 'pitcairn islander',
    POLISH = 'polish',
    PORTUGUESE = 'portuguese',
    PRYDEINIG = 'prydeinig',
    PUERTO_RICAN = 'puerto rican',
    QATARI = 'qatari',
    ROMANIAN = 'romanian',
    RUSSIAN = 'russian',
    RWANDAN = 'rwandan',
    SALVADOREAN = 'salvadorean',
    SAMMARINESE = 'sammarinese',
    SAMOAN = 'samoan',
    SAO_TOMEAN = 'sao tomean',
    SAUDI_ARABIAN = 'saudi arabian',
    SCOTTISH = 'scottish',
    SENEGALESE = 'senegalese',
    SERBIAN = 'serbian',
    CITIZEN_OF_SEYCHELLES = 'citizen of seychelles',
    SIERRA_LEONEAN = 'sierra leonean',
    SINGAPOREAN = 'singaporean',
    SLOVAK = 'slovak',
    SLOVENIAN = 'slovenian',
    SOLOMON_ISLANDER = 'solomon islander',
    SOMALI = 'somali',
    SOUTH_AFRICAN = 'south african',
    SOUTH_KOREAN = 'south korean',
    SOUTH_SUDANESE = 'south sudanese',
    SPANISH = 'spanish',
    SRI_LANKAN = 'sri lankan',
    ST_HELENIAN = 'st helenian',
    ST_LUCIAN = 'st lucian',
    SUDANESE = 'sudanese',
    SURINAMESE = 'surinamese',
    SWAZI = 'swazi',
    SWEDISH = 'swedish',
    SWISS = 'swiss',
    SYRIAN = 'syrian',
    TAIWANESE = 'taiwanese',
    TAJIK = 'tajik',
    TANZANIAN = 'tanzanian',
    THAI = 'thai',
    TOGOLESE = 'togolese',
    TONGAN = 'tongan',
    TRINIDADIAN = 'trinidadian',
    TRISTANIAN = 'tristanian',
    TUNISIAN = 'tunisian',
    TURKISH = 'turkish',
    TURKMEN = 'turkmen',
    TURKS_AND_CAICOS_ISLANDER = 'turks and caicos islander',
    TUVALUAN = 'tuvaluan',
    UGANDAN = 'ugandan',
    UKRAINIAN = 'ukrainian',
    URUGUAYAN = 'uruguayan',
    UZBEK = 'uzbek',
    VATICAN_CITIZEN = 'vatican citizen',
    CITIZEN_OF_VANUATU = 'citizen of vanuatu',
    VENEZUELAN = 'venezuelan',
    VIETNAMESE = 'vietnamese',
    VINCENTIAN = 'vincentian',
    WALLISIAN = 'wallisian',
    WELSH = 'welsh',
    YEMENI = 'yemeni',
    ZAMBIAN = 'zambian',
    ZIMBABWEAN = 'zimbabwean',
}

export enum NoteVisibility {
    INTERNAL = 'internal',
    CUSTOMER = 'customer',
}

export enum OtaName {
    GETYOURGUIDE = 'getyourguide',
    VIATOR = 'viator',
}

export type OrderPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export enum OrderStatus {
    OPEN = 'open',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled',
}

export type Passport = {
    number?: string;
    issued_at?: number;
    expires_at?: number;
    authority?: string;
    citizenship?: Country;
};

export type PaxData = {
    infants_on_lap?: number;
    infants?: number;
    children?: number;
    youth?: number;
    adults?: number;
    seniors?: number;
    students?: number;
    eu_citizens?: number;
    eu_citizen_students?: number;
    military?: number;
    groups?: number;
    collectives?: number;
    total_in_collectives?: number;
};

export type PaymentRequirementsData = {
    methods: Array<TransactionMethod>;
    prepayment: PrepaymentRequirements;
};

export type Period = {
    year: number;
    month?: number;
    day?: number;
};

export type PeriodData = {
    timezone?: TimezoneData;
    duration?: TimeOffset;
    start: number;
    end?: number;
};

export type PersonNameData = {
    first: string;
    middle?: string;
    last: string;
};

export type PhoneNumberData = {
    type?: PhoneNumberType;
    calling_code: number;
    number: number;
};

export enum PhoneNumberType {
    HOME = 'home',
    WORK = 'work',
    MOBILE = 'mobile',
}

export type Policy = {
    type: PolicyType;
    enabled?: boolean;
    config: BookingHoldExpiryConfig;
};

export enum PolicyType {
    WIDGET_BOOKING_HOLD_EXPIRY = 'widget_booking_hold_expiry',
    BOOKING_HOLD_EXPIRY = 'booking_hold_expiry',
    PRODUCT_CANCELLATION = 'product_cancellation',
}

export enum PricingType {
    PER_PERSON = 'per_person',
    PER_PRODUCT = 'per_product',
    PER_AGEBAND = 'per_ageband',
}

export type ProductCancellationPolicy = {
    type: PolicyType;
    enabled?: boolean;
    description: string;
};

export enum ProductOptionType {
    SERVICE = 'service',
    GUIDE = 'guide',
    REFRESHMENT = 'refreshment',
    BREAKFAST = 'breakfast',
    LUNCH = 'lunch',
    DINNER = 'dinner',
    ACCOMMODATION = 'accommodation',
    TICKET = 'ticket',
    SKIPPER = 'skipper',
}

export type ProductPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    move?: boolean;
};

export type ProductReferenceProjection = {
    id: string;
    type: string;
    name: string;
    configuration?: {
        [key: string]: unknown;
    };
};

export type ProductReferenceProjectionList = {
    items?: Array<ProductReferenceProjection>;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type ProductSummary = {
    period: Period;
    confirmed: number;
    cancelled: number;
    draft: number;
    hold: number;
    total: number;
    product_id: string;
    product_name: string;
    revenue: number;
};

export type ProductTag = {
    name: string;
    type: ProductTagType;
};

export enum ProductTagType {
    CATEGORY = 'category',
    INTEREST = 'interest',
    ACCESSIBILITY = 'accessibility',
}

export enum ProductType {
    TOUR = 'tour',
    TRANSFER = 'transfer',
    DYNAMIC_PACKAGE = 'dynamic_package',
}

export type ProductTypeSummary = {
    period: Period;
    confirmed: number;
    cancelled: number;
    draft: number;
    hold: number;
    total: number;
    product_type: string;
    revenue: number;
};

export type ProfessionalSubscriptionData = {
    name?: 'professional';
    user?: ProfessionalSubscriptionUserFeaturesData;
    resources?: Array<ResourceType>;
};

export type ProfessionalSubscriptionUserFeaturesData = {
    calendar?: BaseSubscriptionUserCalendarFeaturesData;
    financial?: BaseSubscriptionUserFinancialFeaturesData;
    collaboration?: BaseSubscriptionUserCollaborationFeaturesData;
    product?: BaseSubscriptionProductFeaturesData;
};

export type RatesResponse = {
    base?: string;
    rates: {
        [key: string]: number;
    };
    source: string;
    default: string;
};

export type ReportPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
    move?: boolean;
};

export enum ReportStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export enum ReportType {
    BOOKING = 'booking',
}

export enum ResourceType {
    USER = 'user',
    PRODUCT = 'product',
    CAPACITY = 'capacity',
    SCHEDULE = 'schedule',
    BOOKING = 'booking',
    EVENT = 'event',
    ORDER = 'order',
    CUSTOMER = 'customer',
    ASSET = 'asset',
    TEAM = 'team',
    FILE = 'file',
    REPORT = 'report',
    PRODUCT_VARIANT = 'product_variant',
    DASHBOARD = 'dashboard',
    TASK = 'task',
    NOTIFICATION = 'notification',
    LOCATION = 'location',
    TRANSLATION = 'translation',
    PAYMENT = 'payment',
}

export type RevenueChart = {
    period: Period;
    revenue: number;
};

export enum RouteItemType {
    STARTPOINT = 'startpoint',
    STOP = 'stop',
    ENDPOINT = 'endpoint',
}

export type SchedulePermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export enum ScheduleType {
    RECURRING = 'recurring',
    NON_RECURRING = 'non_recurring',
}

export type SharedProductCount = {
    transfers?: number;
    tours?: number;
};

export type SharedProductInsightData = {
    count?: SharedProductCount;
};

export type StatsData = {
    results: BookingStats;
};

export type SupportedDestination = {
    country: CountryData;
    cities?: Array<CityData>;
};

export type TaskPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type TeamCollaborationFeature = {
    max_count: number;
    max_members: number;
};

export type TeamInsightData = {
    product?: TeamProductInsightData;
};

export type TeamPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type TeamProductInsightData = {
    shared?: SharedProductInsightData;
};

export type TeamSubscriptionData = {
    name?: 'team';
    user?: TeamSubscriptionUserFeaturesData;
    resources?: Array<ResourceType>;
};

export type TeamSubscriptionUserFeaturesData = {
    calendar?: BaseSubscriptionUserCalendarFeaturesData;
    financial?: BaseSubscriptionUserFinancialFeaturesData;
    collaboration?: BaseSubscriptionUserCollaborationFeaturesData;
    product?: BaseSubscriptionProductFeaturesData;
};

export type TimeOffset = {
    days?: number;
    hours: number;
    minutes?: number;
    seconds?: number;
};

export type TimeOffsetRange = {
    start: TimeOffset;
    end: TimeOffset;
};

export type TimezoneData = {
    name: TimezoneName;
    offset?: number;
};

export enum TimezoneName {
    UTC = 'UTC',
    GMT = 'GMT',
    AFRICA_ABIDJAN = 'Africa/Abidjan',
    AFRICA_ACCRA = 'Africa/Accra',
    AFRICA_ADDIS_ABABA = 'Africa/Addis_Ababa',
    AFRICA_ALGIERS = 'Africa/Algiers',
    AFRICA_ASMARA = 'Africa/Asmara',
    AFRICA_BAMAKO = 'Africa/Bamako',
    AFRICA_BANGUI = 'Africa/Bangui',
    AFRICA_BANJUL = 'Africa/Banjul',
    AFRICA_BISSAU = 'Africa/Bissau',
    AFRICA_BLANTYRE = 'Africa/Blantyre',
    AFRICA_BRAZZAVILLE = 'Africa/Brazzaville',
    AFRICA_BUJUMBURA = 'Africa/Bujumbura',
    AFRICA_CAIRO = 'Africa/Cairo',
    AFRICA_CASABLANCA = 'Africa/Casablanca',
    AFRICA_CEUTA = 'Africa/Ceuta',
    AFRICA_CONAKRY = 'Africa/Conakry',
    AFRICA_DAKAR = 'Africa/Dakar',
    AFRICA_DAR_ES_SALAAM = 'Africa/Dar_es_Salaam',
    AFRICA_DJIBOUTI = 'Africa/Djibouti',
    AFRICA_DOUALA = 'Africa/Douala',
    AFRICA_EL_AAIUN = 'Africa/El_Aaiun',
    AFRICA_FREETOWN = 'Africa/Freetown',
    AFRICA_GABORONE = 'Africa/Gaborone',
    AFRICA_HARARE = 'Africa/Harare',
    AFRICA_JOHANNESBURG = 'Africa/Johannesburg',
    AFRICA_JUBA = 'Africa/Juba',
    AFRICA_KAMPALA = 'Africa/Kampala',
    AFRICA_KHARTOUM = 'Africa/Khartoum',
    AFRICA_KIGALI = 'Africa/Kigali',
    AFRICA_KINSHASA = 'Africa/Kinshasa',
    AFRICA_LAGOS = 'Africa/Lagos',
    AFRICA_LIBREVILLE = 'Africa/Libreville',
    AFRICA_LOME = 'Africa/Lome',
    AFRICA_LUANDA = 'Africa/Luanda',
    AFRICA_LUBUMBASHI = 'Africa/Lubumbashi',
    AFRICA_LUSAKA = 'Africa/Lusaka',
    AFRICA_MALABO = 'Africa/Malabo',
    AFRICA_MAPUTO = 'Africa/Maputo',
    AFRICA_MASERU = 'Africa/Maseru',
    AFRICA_MBABANE = 'Africa/Mbabane',
    AFRICA_MOGADISHU = 'Africa/Mogadishu',
    AFRICA_MONROVIA = 'Africa/Monrovia',
    AFRICA_NAIROBI = 'Africa/Nairobi',
    AFRICA_NDJAMENA = 'Africa/Ndjamena',
    AFRICA_NIAMEY = 'Africa/Niamey',
    AFRICA_NOUAKCHOTT = 'Africa/Nouakchott',
    AFRICA_OUAGADOUGOU = 'Africa/Ouagadougou',
    AFRICA_PORTO_NOVO = 'Africa/Porto-Novo',
    AFRICA_SAO_TOME = 'Africa/Sao_Tome',
    AFRICA_TRIPOLI = 'Africa/Tripoli',
    AFRICA_TUNIS = 'Africa/Tunis',
    AFRICA_WINDHOEK = 'Africa/Windhoek',
    AMERICA_ADAK = 'America/Adak',
    AMERICA_ANCHORAGE = 'America/Anchorage',
    AMERICA_ANGUILLA = 'America/Anguilla',
    AMERICA_ANTIGUA = 'America/Antigua',
    AMERICA_ARAGUAINA = 'America/Araguaina',
    AMERICA_ARGENTINA_BUENOS_AIRES = 'America/Argentina/Buenos_Aires',
    AMERICA_ARGENTINA_CATAMARCA = 'America/Argentina/Catamarca',
    AMERICA_ARGENTINA_CORDOBA = 'America/Argentina/Cordoba',
    AMERICA_ARGENTINA_JUJUY = 'America/Argentina/Jujuy',
    AMERICA_ARGENTINA_LA_RIOJA = 'America/Argentina/La_Rioja',
    AMERICA_ARGENTINA_MENDOZA = 'America/Argentina/Mendoza',
    AMERICA_ARGENTINA_RIO_GALLEGOS = 'America/Argentina/Rio_Gallegos',
    AMERICA_ARGENTINA_SALTA = 'America/Argentina/Salta',
    AMERICA_ARGENTINA_SAN_JUAN = 'America/Argentina/San_Juan',
    AMERICA_ARGENTINA_SAN_LUIS = 'America/Argentina/San_Luis',
    AMERICA_ARGENTINA_TUCUMAN = 'America/Argentina/Tucuman',
    AMERICA_ARGENTINA_USHUAIA = 'America/Argentina/Ushuaia',
    AMERICA_ARUBA = 'America/Aruba',
    AMERICA_ASUNCION = 'America/Asuncion',
    AMERICA_ATIKOKAN = 'America/Atikokan',
    AMERICA_BAHIA = 'America/Bahia',
    AMERICA_BAHIA_BANDERAS = 'America/Bahia_Banderas',
    AMERICA_BARBADOS = 'America/Barbados',
    AMERICA_BELEM = 'America/Belem',
    AMERICA_BELIZE = 'America/Belize',
    AMERICA_BLANC_SABLON = 'America/Blanc-Sablon',
    AMERICA_BOA_VISTA = 'America/Boa_Vista',
    AMERICA_BOGOTA = 'America/Bogota',
    AMERICA_BOISE = 'America/Boise',
    AMERICA_CAMBRIDGE_BAY = 'America/Cambridge_Bay',
    AMERICA_CAMPO_GRANDE = 'America/Campo_Grande',
    AMERICA_CANCUN = 'America/Cancun',
    AMERICA_CARACAS = 'America/Caracas',
    AMERICA_CAYENNE = 'America/Cayenne',
    AMERICA_CAYMAN = 'America/Cayman',
    AMERICA_CHICAGO = 'America/Chicago',
    AMERICA_CHIHUAHUA = 'America/Chihuahua',
    AMERICA_CIUDAD_JUAREZ = 'America/Ciudad_Juarez',
    AMERICA_COSTA_RICA = 'America/Costa_Rica',
    AMERICA_CRESTON = 'America/Creston',
    AMERICA_CUIABA = 'America/Cuiaba',
    AMERICA_CURACAO = 'America/Curacao',
    AMERICA_DANMARKSHAVN = 'America/Danmarkshavn',
    AMERICA_DAWSON = 'America/Dawson',
    AMERICA_DAWSON_CREEK = 'America/Dawson_Creek',
    AMERICA_DENVER = 'America/Denver',
    AMERICA_DETROIT = 'America/Detroit',
    AMERICA_DOMINICA = 'America/Dominica',
    AMERICA_EDMONTON = 'America/Edmonton',
    AMERICA_EIRUNEPE = 'America/Eirunepe',
    AMERICA_EL_SALVADOR = 'America/El_Salvador',
    AMERICA_FORT_NELSON = 'America/Fort_Nelson',
    AMERICA_FORTALEZA = 'America/Fortaleza',
    AMERICA_GLACE_BAY = 'America/Glace_Bay',
    AMERICA_GOOSE_BAY = 'America/Goose_Bay',
    AMERICA_GRAND_TURK = 'America/Grand_Turk',
    AMERICA_GRENADA = 'America/Grenada',
    AMERICA_GUADELOUPE = 'America/Guadeloupe',
    AMERICA_GUATEMALA = 'America/Guatemala',
    AMERICA_GUAYAQUIL = 'America/Guayaquil',
    AMERICA_GUYANA = 'America/Guyana',
    AMERICA_HALIFAX = 'America/Halifax',
    AMERICA_HAVANA = 'America/Havana',
    AMERICA_HERMOSILLO = 'America/Hermosillo',
    AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
    AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
    AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
    AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
    AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
    AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
    AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
    AMERICA_INDIANA_WINAMAC = 'America/Indiana/Winamac',
    AMERICA_INUVIK = 'America/Inuvik',
    AMERICA_IQALUIT = 'America/Iqaluit',
    AMERICA_JAMAICA = 'America/Jamaica',
    AMERICA_JUNEAU = 'America/Juneau',
    AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
    AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
    AMERICA_KRALENDIJK = 'America/Kralendijk',
    AMERICA_LA_PAZ = 'America/La_Paz',
    AMERICA_LIMA = 'America/Lima',
    AMERICA_LOS_ANGELES = 'America/Los_Angeles',
    AMERICA_LOWER_PRINCES = 'America/Lower_Princes',
    AMERICA_MACEIO = 'America/Maceio',
    AMERICA_MANAGUA = 'America/Managua',
    AMERICA_MANAUS = 'America/Manaus',
    AMERICA_MARIGOT = 'America/Marigot',
    AMERICA_MARTINIQUE = 'America/Martinique',
    AMERICA_MATAMOROS = 'America/Matamoros',
    AMERICA_MAZATLAN = 'America/Mazatlan',
    AMERICA_MENOMINEE = 'America/Menominee',
    AMERICA_MERIDA = 'America/Merida',
    AMERICA_METLAKATLA = 'America/Metlakatla',
    AMERICA_MEXICO_CITY = 'America/Mexico_City',
    AMERICA_MIQUELON = 'America/Miquelon',
    AMERICA_MONCTON = 'America/Moncton',
    AMERICA_MONTERREY = 'America/Monterrey',
    AMERICA_MONTEVIDEO = 'America/Montevideo',
    AMERICA_MONTSERRAT = 'America/Montserrat',
    AMERICA_NASSAU = 'America/Nassau',
    AMERICA_NEW_YORK = 'America/New_York',
    AMERICA_NOME = 'America/Nome',
    AMERICA_NORONHA = 'America/Noronha',
    AMERICA_NORTH_DAKOTA_BEULAH = 'America/North_Dakota/Beulah',
    AMERICA_NORTH_DAKOTA_CENTER = 'America/North_Dakota/Center',
    AMERICA_NORTH_DAKOTA_NEW_SALEM = 'America/North_Dakota/New_Salem',
    AMERICA_NUUK = 'America/Nuuk',
    AMERICA_OJINAGA = 'America/Ojinaga',
    AMERICA_PANAMA = 'America/Panama',
    AMERICA_PARAMARIBO = 'America/Paramaribo',
    AMERICA_PHOENIX = 'America/Phoenix',
    AMERICA_PORT_AU_PRINCE = 'America/Port-au-Prince',
    AMERICA_PORT_OF_SPAIN = 'America/Port_of_Spain',
    AMERICA_PORTO_VELHO = 'America/Porto_Velho',
    AMERICA_PUERTO_RICO = 'America/Puerto_Rico',
    AMERICA_PUNTA_ARENAS = 'America/Punta_Arenas',
    AMERICA_RANKIN_INLET = 'America/Rankin_Inlet',
    AMERICA_RECIFE = 'America/Recife',
    AMERICA_REGINA = 'America/Regina',
    AMERICA_RESOLUTE = 'America/Resolute',
    AMERICA_RIO_BRANCO = 'America/Rio_Branco',
    AMERICA_SANTAREM = 'America/Santarem',
    AMERICA_SANTIAGO = 'America/Santiago',
    AMERICA_SANTO_DOMINGO = 'America/Santo_Domingo',
    AMERICA_SAO_PAULO = 'America/Sao_Paulo',
    AMERICA_SCORESBYSUND = 'America/Scoresbysund',
    AMERICA_SITKA = 'America/Sitka',
    AMERICA_ST_BARTHELEMY = 'America/St_Barthelemy',
    AMERICA_ST_JOHNS = 'America/St_Johns',
    AMERICA_ST_KITTS = 'America/St_Kitts',
    AMERICA_ST_LUCIA = 'America/St_Lucia',
    AMERICA_ST_THOMAS = 'America/St_Thomas',
    AMERICA_ST_VINCENT = 'America/St_Vincent',
    AMERICA_SWIFT_CURRENT = 'America/Swift_Current',
    AMERICA_TEGUCIGALPA = 'America/Tegucigalpa',
    AMERICA_THULE = 'America/Thule',
    AMERICA_TIJUANA = 'America/Tijuana',
    AMERICA_TORONTO = 'America/Toronto',
    AMERICA_TORTOLA = 'America/Tortola',
    AMERICA_VANCOUVER = 'America/Vancouver',
    AMERICA_WHITEHORSE = 'America/Whitehorse',
    AMERICA_WINNIPEG = 'America/Winnipeg',
    AMERICA_YAKUTAT = 'America/Yakutat',
    ANTARCTICA_CASEY = 'Antarctica/Casey',
    ANTARCTICA_DAVIS = 'Antarctica/Davis',
    ANTARCTICA_DUMONT_D_URVILLE = 'Antarctica/DumontDUrville',
    ANTARCTICA_MACQUARIE = 'Antarctica/Macquarie',
    ANTARCTICA_MAWSON = 'Antarctica/Mawson',
    ANTARCTICA_MC_MURDO = 'Antarctica/McMurdo',
    ANTARCTICA_PALMER = 'Antarctica/Palmer',
    ANTARCTICA_ROTHERA = 'Antarctica/Rothera',
    ANTARCTICA_SYOWA = 'Antarctica/Syowa',
    ANTARCTICA_TROLL = 'Antarctica/Troll',
    ANTARCTICA_VOSTOK = 'Antarctica/Vostok',
    ARCTIC_LONGYEARBYEN = 'Arctic/Longyearbyen',
    ASIA_ADEN = 'Asia/Aden',
    ASIA_ALMATY = 'Asia/Almaty',
    ASIA_AMMAN = 'Asia/Amman',
    ASIA_ANADYR = 'Asia/Anadyr',
    ASIA_AQTAU = 'Asia/Aqtau',
    ASIA_AQTOBE = 'Asia/Aqtobe',
    ASIA_ASHGABAT = 'Asia/Ashgabat',
    ASIA_ATYRAU = 'Asia/Atyrau',
    ASIA_BAGHDAD = 'Asia/Baghdad',
    ASIA_BAHRAIN = 'Asia/Bahrain',
    ASIA_BAKU = 'Asia/Baku',
    ASIA_BANGKOK = 'Asia/Bangkok',
    ASIA_BARNAUL = 'Asia/Barnaul',
    ASIA_BEIRUT = 'Asia/Beirut',
    ASIA_BISHKEK = 'Asia/Bishkek',
    ASIA_BRUNEI = 'Asia/Brunei',
    ASIA_CHITA = 'Asia/Chita',
    ASIA_CHOIBALSAN = 'Asia/Choibalsan',
    ASIA_COLOMBO = 'Asia/Colombo',
    ASIA_DAMASCUS = 'Asia/Damascus',
    ASIA_DHAKA = 'Asia/Dhaka',
    ASIA_DILI = 'Asia/Dili',
    ASIA_DUBAI = 'Asia/Dubai',
    ASIA_DUSHANBE = 'Asia/Dushanbe',
    ASIA_FAMAGUSTA = 'Asia/Famagusta',
    ASIA_GAZA = 'Asia/Gaza',
    ASIA_HEBRON = 'Asia/Hebron',
    ASIA_HO_CHI_MINH = 'Asia/Ho_Chi_Minh',
    ASIA_HONG_KONG = 'Asia/Hong_Kong',
    ASIA_HOVD = 'Asia/Hovd',
    ASIA_IRKUTSK = 'Asia/Irkutsk',
    ASIA_JAKARTA = 'Asia/Jakarta',
    ASIA_JAYAPURA = 'Asia/Jayapura',
    ASIA_JERUSALEM = 'Asia/Jerusalem',
    ASIA_KABUL = 'Asia/Kabul',
    ASIA_KAMCHATKA = 'Asia/Kamchatka',
    ASIA_KARACHI = 'Asia/Karachi',
    ASIA_KATHMANDU = 'Asia/Kathmandu',
    ASIA_KHANDYGA = 'Asia/Khandyga',
    ASIA_KOLKATA = 'Asia/Kolkata',
    ASIA_KRASNOYARSK = 'Asia/Krasnoyarsk',
    ASIA_KUALA_LUMPUR = 'Asia/Kuala_Lumpur',
    ASIA_KUCHING = 'Asia/Kuching',
    ASIA_KUWAIT = 'Asia/Kuwait',
    ASIA_MACAU = 'Asia/Macau',
    ASIA_MAGADAN = 'Asia/Magadan',
    ASIA_MAKASSAR = 'Asia/Makassar',
    ASIA_MANILA = 'Asia/Manila',
    ASIA_MUSCAT = 'Asia/Muscat',
    ASIA_NICOSIA = 'Asia/Nicosia',
    ASIA_NOVOKUZNETSK = 'Asia/Novokuznetsk',
    ASIA_NOVOSIBIRSK = 'Asia/Novosibirsk',
    ASIA_OMSK = 'Asia/Omsk',
    ASIA_ORAL = 'Asia/Oral',
    ASIA_PHNOM_PENH = 'Asia/Phnom_Penh',
    ASIA_PONTIANAK = 'Asia/Pontianak',
    ASIA_PYONGYANG = 'Asia/Pyongyang',
    ASIA_QATAR = 'Asia/Qatar',
    ASIA_QOSTANAY = 'Asia/Qostanay',
    ASIA_QYZYLORDA = 'Asia/Qyzylorda',
    ASIA_RIYADH = 'Asia/Riyadh',
    ASIA_SAKHALIN = 'Asia/Sakhalin',
    ASIA_SAMARKAND = 'Asia/Samarkand',
    ASIA_SEOUL = 'Asia/Seoul',
    ASIA_SHANGHAI = 'Asia/Shanghai',
    ASIA_SINGAPORE = 'Asia/Singapore',
    ASIA_SREDNEKOLYMSK = 'Asia/Srednekolymsk',
    ASIA_TAIPEI = 'Asia/Taipei',
    ASIA_TASHKENT = 'Asia/Tashkent',
    ASIA_TBILISI = 'Asia/Tbilisi',
    ASIA_TEHRAN = 'Asia/Tehran',
    ASIA_THIMPHU = 'Asia/Thimphu',
    ASIA_TOKYO = 'Asia/Tokyo',
    ASIA_TOMSK = 'Asia/Tomsk',
    ASIA_ULAANBAATAR = 'Asia/Ulaanbaatar',
    ASIA_URUMQI = 'Asia/Urumqi',
    ASIA_UST_NERA = 'Asia/Ust-Nera',
    ASIA_VIENTIANE = 'Asia/Vientiane',
    ASIA_VLADIVOSTOK = 'Asia/Vladivostok',
    ASIA_YAKUTSK = 'Asia/Yakutsk',
    ASIA_YANGON = 'Asia/Yangon',
    ASIA_YEKATERINBURG = 'Asia/Yekaterinburg',
    ASIA_YEREVAN = 'Asia/Yerevan',
    ATLANTIC_AZORES = 'Atlantic/Azores',
    ATLANTIC_BERMUDA = 'Atlantic/Bermuda',
    ATLANTIC_CANARY = 'Atlantic/Canary',
    ATLANTIC_CAPE_VERDE = 'Atlantic/Cape_Verde',
    ATLANTIC_FAROE = 'Atlantic/Faroe',
    ATLANTIC_MADEIRA = 'Atlantic/Madeira',
    ATLANTIC_REYKJAVIK = 'Atlantic/Reykjavik',
    ATLANTIC_SOUTH_GEORGIA = 'Atlantic/South_Georgia',
    ATLANTIC_ST_HELENA = 'Atlantic/St_Helena',
    ATLANTIC_STANLEY = 'Atlantic/Stanley',
    AUSTRALIA_ADELAIDE = 'Australia/Adelaide',
    AUSTRALIA_BRISBANE = 'Australia/Brisbane',
    AUSTRALIA_BROKEN_HILL = 'Australia/Broken_Hill',
    AUSTRALIA_DARWIN = 'Australia/Darwin',
    AUSTRALIA_EUCLA = 'Australia/Eucla',
    AUSTRALIA_HOBART = 'Australia/Hobart',
    AUSTRALIA_LINDEMAN = 'Australia/Lindeman',
    AUSTRALIA_LORD_HOWE = 'Australia/Lord_Howe',
    AUSTRALIA_MELBOURNE = 'Australia/Melbourne',
    AUSTRALIA_PERTH = 'Australia/Perth',
    AUSTRALIA_SYDNEY = 'Australia/Sydney',
    CANADA_ATLANTIC = 'Canada/Atlantic',
    CANADA_CENTRAL = 'Canada/Central',
    CANADA_EASTERN = 'Canada/Eastern',
    CANADA_MOUNTAIN = 'Canada/Mountain',
    CANADA_NEWFOUNDLAND = 'Canada/Newfoundland',
    CANADA_PACIFIC = 'Canada/Pacific',
    EUROPE_AMSTERDAM = 'Europe/Amsterdam',
    EUROPE_ANDORRA = 'Europe/Andorra',
    EUROPE_ASTRAKHAN = 'Europe/Astrakhan',
    EUROPE_ATHENS = 'Europe/Athens',
    EUROPE_BELGRADE = 'Europe/Belgrade',
    EUROPE_BERLIN = 'Europe/Berlin',
    EUROPE_BRATISLAVA = 'Europe/Bratislava',
    EUROPE_BRUSSELS = 'Europe/Brussels',
    EUROPE_BUCHAREST = 'Europe/Bucharest',
    EUROPE_BUDAPEST = 'Europe/Budapest',
    EUROPE_BUSINGEN = 'Europe/Busingen',
    EUROPE_CHISINAU = 'Europe/Chisinau',
    EUROPE_COPENHAGEN = 'Europe/Copenhagen',
    EUROPE_DUBLIN = 'Europe/Dublin',
    EUROPE_GIBRALTAR = 'Europe/Gibraltar',
    EUROPE_GUERNSEY = 'Europe/Guernsey',
    EUROPE_HELSINKI = 'Europe/Helsinki',
    EUROPE_ISLE_OF_MAN = 'Europe/Isle_of_Man',
    EUROPE_ISTANBUL = 'Europe/Istanbul',
    EUROPE_JERSEY = 'Europe/Jersey',
    EUROPE_KALININGRAD = 'Europe/Kaliningrad',
    EUROPE_KIROV = 'Europe/Kirov',
    EUROPE_KYIV = 'Europe/Kyiv',
    EUROPE_LISBON = 'Europe/Lisbon',
    EUROPE_LJUBLJANA = 'Europe/Ljubljana',
    EUROPE_LONDON = 'Europe/London',
    EUROPE_LUXEMBOURG = 'Europe/Luxembourg',
    EUROPE_MADRID = 'Europe/Madrid',
    EUROPE_MALTA = 'Europe/Malta',
    EUROPE_MARIEHAMN = 'Europe/Mariehamn',
    EUROPE_MINSK = 'Europe/Minsk',
    EUROPE_MONACO = 'Europe/Monaco',
    EUROPE_MOSCOW = 'Europe/Moscow',
    EUROPE_OSLO = 'Europe/Oslo',
    EUROPE_PARIS = 'Europe/Paris',
    EUROPE_PODGORICA = 'Europe/Podgorica',
    EUROPE_PRAGUE = 'Europe/Prague',
    EUROPE_RIGA = 'Europe/Riga',
    EUROPE_ROME = 'Europe/Rome',
    EUROPE_SAMARA = 'Europe/Samara',
    EUROPE_SAN_MARINO = 'Europe/San_Marino',
    EUROPE_SARAJEVO = 'Europe/Sarajevo',
    EUROPE_SARATOV = 'Europe/Saratov',
    EUROPE_SIMFEROPOL = 'Europe/Simferopol',
    EUROPE_SKOPJE = 'Europe/Skopje',
    EUROPE_SOFIA = 'Europe/Sofia',
    EUROPE_STOCKHOLM = 'Europe/Stockholm',
    EUROPE_TALLINN = 'Europe/Tallinn',
    EUROPE_TIRANE = 'Europe/Tirane',
    EUROPE_ULYANOVSK = 'Europe/Ulyanovsk',
    EUROPE_VADUZ = 'Europe/Vaduz',
    EUROPE_VATICAN = 'Europe/Vatican',
    EUROPE_VIENNA = 'Europe/Vienna',
    EUROPE_VILNIUS = 'Europe/Vilnius',
    EUROPE_VOLGOGRAD = 'Europe/Volgograd',
    EUROPE_WARSAW = 'Europe/Warsaw',
    EUROPE_ZAGREB = 'Europe/Zagreb',
    EUROPE_ZURICH = 'Europe/Zurich',
    INDIAN_ANTANANARIVO = 'Indian/Antananarivo',
    INDIAN_CHAGOS = 'Indian/Chagos',
    INDIAN_CHRISTMAS = 'Indian/Christmas',
    INDIAN_COCOS = 'Indian/Cocos',
    INDIAN_COMORO = 'Indian/Comoro',
    INDIAN_KERGUELEN = 'Indian/Kerguelen',
    INDIAN_MAHE = 'Indian/Mahe',
    INDIAN_MALDIVES = 'Indian/Maldives',
    INDIAN_MAURITIUS = 'Indian/Mauritius',
    INDIAN_MAYOTTE = 'Indian/Mayotte',
    INDIAN_REUNION = 'Indian/Reunion',
    PACIFIC_APIA = 'Pacific/Apia',
    PACIFIC_AUCKLAND = 'Pacific/Auckland',
    PACIFIC_BOUGAINVILLE = 'Pacific/Bougainville',
    PACIFIC_CHATHAM = 'Pacific/Chatham',
    PACIFIC_CHUUK = 'Pacific/Chuuk',
    PACIFIC_EASTER = 'Pacific/Easter',
    PACIFIC_EFATE = 'Pacific/Efate',
    PACIFIC_FAKAOFO = 'Pacific/Fakaofo',
    PACIFIC_FIJI = 'Pacific/Fiji',
    PACIFIC_FUNAFUTI = 'Pacific/Funafuti',
    PACIFIC_GALAPAGOS = 'Pacific/Galapagos',
    PACIFIC_GAMBIER = 'Pacific/Gambier',
    PACIFIC_GUADALCANAL = 'Pacific/Guadalcanal',
    PACIFIC_GUAM = 'Pacific/Guam',
    PACIFIC_HONOLULU = 'Pacific/Honolulu',
    PACIFIC_KANTON = 'Pacific/Kanton',
    PACIFIC_KIRITIMATI = 'Pacific/Kiritimati',
    PACIFIC_KOSRAE = 'Pacific/Kosrae',
    PACIFIC_KWAJALEIN = 'Pacific/Kwajalein',
    PACIFIC_MAJURO = 'Pacific/Majuro',
    PACIFIC_MARQUESAS = 'Pacific/Marquesas',
    PACIFIC_MIDWAY = 'Pacific/Midway',
    PACIFIC_NAURU = 'Pacific/Nauru',
    PACIFIC_NIUE = 'Pacific/Niue',
    PACIFIC_NORFOLK = 'Pacific/Norfolk',
    PACIFIC_NOUMEA = 'Pacific/Noumea',
    PACIFIC_PAGO_PAGO = 'Pacific/Pago_Pago',
    PACIFIC_PALAU = 'Pacific/Palau',
    PACIFIC_PITCAIRN = 'Pacific/Pitcairn',
    PACIFIC_POHNPEI = 'Pacific/Pohnpei',
    PACIFIC_PORT_MORESBY = 'Pacific/Port_Moresby',
    PACIFIC_RAROTONGA = 'Pacific/Rarotonga',
    PACIFIC_SAIPAN = 'Pacific/Saipan',
    PACIFIC_TAHITI = 'Pacific/Tahiti',
    PACIFIC_TARAWA = 'Pacific/Tarawa',
    PACIFIC_TONGATAPU = 'Pacific/Tongatapu',
    PACIFIC_WAKE = 'Pacific/Wake',
    PACIFIC_WALLIS = 'Pacific/Wallis',
    US_ALASKA = 'US/Alaska',
    US_ARIZONA = 'US/Arizona',
    US_CENTRAL = 'US/Central',
    US_EASTERN = 'US/Eastern',
    US_HAWAII = 'US/Hawaii',
    US_MOUNTAIN = 'US/Mountain',
    US_PACIFIC = 'US/Pacific',
}

export enum TourEventAssetType {
    VEHICLE = 'vehicle',
}

export enum TourEventStaffMemberPosition {
    ADMINISTRATOR = 'administrator',
    GUIDE = 'guide',
    DRIVER = 'driver',
    CAPTAIN = 'captain',
    STEWARD = 'steward',
    WAITER = 'waiter',
    COOK = 'cook',
    SECURITY_GUARD = 'security_guard',
    PILOT = 'pilot',
}

export type TransactionDiscardData = {
    message: string;
};

export enum TransactionMethod {
    CASH = 'cash',
    POS_TERMINAL = 'pos_terminal',
    WIRE_TRANSFER = 'wire_transfer',
    PROMO = 'promo',
    GIFT_CARD = 'gift_card',
    PARTNER = 'partner',
    OTA = 'ota',
    WEBSITE = 'website',
}

export enum TransactionType {
    PAYMENT = 'payment',
    REFUND = 'refund',
    WAIVER = 'waiver',
}

export enum TransferEventAssetType {
    VEHICLE = 'vehicle',
}

export enum TransferEventStaffMemberPosition {
    ADMINISTRATOR = 'administrator',
    DRIVER = 'driver',
    CAPTAIN = 'captain',
    WAITER = 'waiter',
    COOK = 'cook',
    SECURITY_GUARD = 'security_guard',
    PILOT = 'pilot',
}

export enum TransportationMedium {
    LAND = 'land',
    WATER = 'water',
    AIR = 'air',
}

export enum UserMembershipStatus {
    ACTIVE = 'active',
    PENDING = 'pending',
    INACTIVE = 'inactive',
}

export enum UserOccupation {
    GUIDE = 'guide',
    DRIVER = 'driver',
    TRAVEL_AGENT = 'travel_agent',
    GENERAL_MANAGER = 'general_manager',
    INTEGRATION = 'integration',
}

export type UserPermissionsData = {
    create?: boolean;
    read?: boolean;
    update?: boolean;
    delete?: boolean;
};

export type ValidationError = {
    loc: Array<string | number>;
    msg: string;
    type: string;
};

export enum VehicleEngineType {
    ELECTRIC = 'electric',
    PETROL = 'petrol',
    DIESEL = 'diesel',
    CNG = 'cng',
    LPG = 'lpg',
}

export enum VehicleType {
    CAR = 'car',
    TRUCK = 'truck',
    BUS = 'bus',
    VAN = 'van',
    SUV = 'suv',
    RV = 'RV',
    MOTORCYCLE = 'motorcycle',
    BICYCLE = 'bicycle',
    SCOOTER = 'scooter',
    HOVERBOARD = 'hoverboard',
    AIRPLANE = 'airplane',
    HELICOPTER = 'helicopter',
    SAILBOAT = 'sailboat',
    MOTORBOAT = 'motorboat',
    CATAMARAN = 'catamaran',
    RIB = 'rib',
    GULET = 'gulet',
    JETSKI = 'jetski',
    HOUSEBOAT = 'houseboat',
    SAILING_YACHT = 'sailing_yacht',
    MOTOR_YACHT = 'motor_yacht',
}

export type WeeklyRecurrenceData = {
    type: 'weekly';
    days_of_week: Array<DayOfWeek>;
};

export enum WidgetName {
    GENERIC = 'generic',
}

export type WorkWeekFeature = {
    customizable?: boolean;
};

export type YearlyRecurrenceData = {
    type: 'yearly';
    dates: Array<number>;
};

export type Coordinates = {
    latitude: number;
    longitude: number;
};

export type PrepaymentRequirements = {
    required: boolean;
    amount?: number;
    type?: DiscountType;
};

export type RegisterUsersReqDto = {
    account: RegisterUsersReqAccountDto;
    profile: RegisterUsersReqProfileDto;
    subscription_key: string;
};

export type RegisterUsersReqAccountDto = {
    settings: RegisterUsersReqAccountSettingsDto;
};

export type RegisterUsersReqAccountSettingsDto = {
    financial: RegisterUsersReqAccountSettingsFinancialDto;
    calendar: RegisterUsersReqAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type RegisterUsersReqAccountSettingsFinancialDto = {
    currencies: Array<CurrencySetting>;
    payment_gateways?: RegisterUsersReqAccountSettingsFinancialPaymentGatewaysDto;
};

export type RegisterUsersReqAccountSettingsFinancialPaymentGatewaysDto = {
    items?: Array<RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemDto = {
    action?: ListItemAction;
    id: string;
    reference?:
        | RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider: 'ameriabank';
        client_id: string;
        username: string;
        password: string;
    };

export type RegisterUsersReqAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider: 'flitt';
        merchant_id: string;
        secret_key: string;
    };

export type RegisterUsersReqAccountSettingsCalendarDto = {
    timezone: TimezoneData;
    workweek?: RegisterUsersReqAccountSettingsCalendarWorkweekDto;
};

export type RegisterUsersReqAccountSettingsCalendarWorkweekDto = {
    monday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    thursday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    friday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    saturday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
    sunday?: RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto;
};

export type RegisterUsersReqAccountSettingsCalendarWorkweekMondayDto = {
    work_hours: Array<TimeOffsetRange>;
};

export type RegisterUsersReqProfileDto = {
    contact_details?: RegisterUsersReqProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: RegisterUsersReqProfileOrganizationDto;
    occupation: UserOccupation;
};

export type RegisterUsersReqProfileContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type RegisterUsersReqProfileOrganizationDto = {
    type?: 'organization';
    id?: string;
    contact_details?: RegisterUsersReqProfileOrganizationContactDetailsDto;
    name: string;
};

export type RegisterUsersReqProfileOrganizationContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
    address?: LocationDataModel;
};

export type RegisterUsersReq1Dto = {
    supplier_id?: number;
};

export type RegisterUsersReq2Dto = {
    [key: string]: unknown;
};

export type RegisterUsersResDto = {
    resource_type: ResourceType;
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: 'human';
    account: RegisterUsersResAccountDto;
    access: RegisterUsersResAccessDto;
    profile: RegisterUsersResProfileDto;
    subscription:
        | FreeSubscriptionData
        | ProfessionalSubscriptionData
        | TeamSubscriptionData
        | EnterpriseSubscriptionData;
};

export type RegisterUsersResCreatedBy4Dto = {
    type: 'widget';
    id: string;
    name: WidgetName;
};

export type RegisterUsersResAccountDto = {
    memberships: RegisterUsersResAccountMembershipsDto;
    workspaces: RegisterUsersResAccountWorkspacesDto;
    settings: RegisterUsersResAccountSettingsDto;
};

export type RegisterUsersResAccountMembershipsDto = {
    items: Array<
        | RegisterUsersResAccountMembershipsItem0Dto
        | RegisterUsersResAccountMembershipsItem1Dto
    >;
};

export type RegisterUsersResAccountMembershipsItem0Dto = {
    role:
        | RegisterUsersResAccountMembershipsItem0Role0Dto
        | RegisterUsersResAccountMembershipsItem0Role1Dto;
    status: UserMembershipStatus;
    action?: ListItemAction;
    id: string;
    group: RegisterUsersResAccountMembershipsItem0GroupDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0Dto = {
    type: 'owner';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessDto = {
    team?: RegisterUsersResAccountMembershipsItem0Role0AccessTeamDto;
    user: RegisterUsersResAccountMembershipsItem0Role0AccessUserDto;
    product: RegisterUsersResAccountMembershipsItem0Role0AccessProductDto;
    booking: RegisterUsersResAccountMembershipsItem0Role0AccessBookingDto;
    event: RegisterUsersResAccountMembershipsItem0Role0AccessEventDto;
    order: RegisterUsersResAccountMembershipsItem0Role0AccessOrderDto;
    asset?: RegisterUsersResAccountMembershipsItem0Role0AccessAssetDto;
    customer: RegisterUsersResAccountMembershipsItem0Role0AccessCustomerDto;
    capacity: RegisterUsersResAccountMembershipsItem0Role0AccessCapacityDto;
    schedule: RegisterUsersResAccountMembershipsItem0Role0AccessScheduleDto;
    report?: RegisterUsersResAccountMembershipsItem0Role0AccessReportDto;
    dashboard?: RegisterUsersResAccountMembershipsItem0Role0AccessDashboardDto;
    product_variant?: RegisterUsersResAccountMembershipsItem0Role0AccessProductDto;
    task?: RegisterUsersResAccountMembershipsItem0Role0AccessTaskDto;
    location?: RegisterUsersResAccountMembershipsItem0Role0AccessLocationDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessTeamDto = {
    permissions: TeamPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessTeamViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessTeamViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessUserDto = {
    permissions: UserPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessUserViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessUserViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessProductDto = {
    permissions: ProductPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessProductViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessProductViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessBookingDto = {
    permissions: BookingPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessBookingViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessBookingViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessEventDto = {
    permissions: EventPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessEventViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessEventViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessOrderDto = {
    permissions: OrderPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessOrderViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessOrderViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessAssetDto = {
    permissions: AssetPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessAssetViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessAssetViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessCustomerDto = {
    permissions: CustomerPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessCustomerViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessCustomerViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type RegisterUsersResAccountMembershipsItem0Role0AccessCapacityDto = {
    permissions: CapacityPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessCapacityViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessCapacityViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type RegisterUsersResAccountMembershipsItem0Role0AccessScheduleDto = {
    permissions: SchedulePermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessScheduleViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessScheduleViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type RegisterUsersResAccountMembershipsItem0Role0AccessReportDto = {
    permissions: ReportPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessReportViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessReportViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessDashboardDto = {
    permissions: DashboardPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessDashboardViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessDashboardViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type RegisterUsersResAccountMembershipsItem0Role0AccessTaskDto = {
    permissions: TaskPermissionsData;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessLocationDto = {
    permissions: LocationPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessLocationViewDto;
};

export type RegisterUsersResAccountMembershipsItem0Role0AccessLocationViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type RegisterUsersResAccountMembershipsItem0Role1Dto = {
    type: 'widget';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem0GroupDto = {
    type: 'individual';
    id: string;
    name?: string;
};

export type RegisterUsersResAccountMembershipsItem1Dto = {
    role:
        | RegisterUsersResAccountMembershipsItem1Role0Dto
        | RegisterUsersResAccountMembershipsItem1Role1Dto
        | RegisterUsersResAccountMembershipsItem1Role2Dto
        | RegisterUsersResAccountMembershipsItem1Role3Dto
        | RegisterUsersResAccountMembershipsItem1Role4Dto
        | RegisterUsersResAccountMembershipsItem0Role0Dto
        | RegisterUsersResAccountMembershipsItem1Role6Dto
        | RegisterUsersResAccountMembershipsItem1Role7Dto
        | RegisterUsersResAccountMembershipsItem0Role1Dto;
    status: UserMembershipStatus;
    action?: ListItemAction;
    id: string;
    group: RegisterUsersResAccountMembershipsItem1GroupDto;
};

export type RegisterUsersResAccountMembershipsItem1Role0Dto = {
    type: 'accountant';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role1Dto = {
    type: 'administrator';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role2Dto = {
    type: 'contributor';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role3Dto = {
    type: 'editor';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role4Dto = {
    type: 'event_staff';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role6Dto = {
    type: 'partner';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1Role7Dto = {
    type: 'viewer';
    access: RegisterUsersResAccountMembershipsItem0Role0AccessDto;
};

export type RegisterUsersResAccountMembershipsItem1GroupDto = {
    type: 'team';
    id: string;
    name?: string;
};

export type RegisterUsersResAccountWorkspacesDto = {
    items: Array<RegisterUsersResAccountWorkspacesItemDto>;
    current: RegisterUsersResAccountWorkspacesItemDto;
};

export type RegisterUsersResAccountWorkspacesItemDto = {
    action?: ListItemAction;
    id: string;
    name: string;
    membership:
        | RegisterUsersResAccountMembershipsItem0Dto
        | RegisterUsersResAccountMembershipsItem1Dto;
};

export type RegisterUsersResAccountSettingsDto = {
    financial: RegisterUsersResAccountSettingsFinancialDto;
    calendar: RegisterUsersResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type RegisterUsersResAccountSettingsFinancialDto = {
    currencies: Array<CurrencySetting>;
    payment_gateways?: RegisterUsersResAccountSettingsFinancialPaymentGatewaysDto;
};

export type RegisterUsersResAccountSettingsFinancialPaymentGatewaysDto = {
    items: Array<RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemDto = {
    action?: ListItemAction;
    id: string;
    reference:
        | RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider?: 'ameriabank';
        client_id?: string;
        username?: string;
    };

export type RegisterUsersResAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider?: 'flitt';
        merchant_id?: string;
    };

export type RegisterUsersResAccountSettingsCalendarDto = {
    timezone: TimezoneData;
    workweek?: RegisterUsersResAccountSettingsCalendarWorkweekDto;
};

export type RegisterUsersResAccountSettingsCalendarWorkweekDto = {
    monday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    thursday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    friday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    saturday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
    sunday?: RegisterUsersResAccountSettingsCalendarWorkweekMondayDto;
};

export type RegisterUsersResAccountSettingsCalendarWorkweekMondayDto = {
    work_hours: Array<TimeOffsetRange>;
};

export type RegisterUsersResAccessDto = {
    permissions: UserPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessUserViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type RegisterUsersResAccessGroupsDto = {
    items: Array<RegisterUsersResAccessGroupsItemDto>;
    primary: RegisterUsersResAccessGroupsItemDto;
};

export type RegisterUsersResAccessGroupsItemDto = {
    action?: ListItemAction;
    id: string;
    reference:
        | RegisterUsersResAccountMembershipsItem0GroupDto
        | RegisterUsersResAccountMembershipsItem1GroupDto;
};

export type RegisterUsersResProfileDto = {
    contact_details?: RegisterUsersResProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: RegisterUsersResProfileOrganizationDto;
    occupation: UserOccupation;
};

export type RegisterUsersResProfileContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type RegisterUsersResProfileOrganizationDto = {
    type: 'organization';
    id?: string;
    contact_details?: RegisterUsersResProfileOrganizationContactDetailsDto;
    name: string;
};

export type RegisterUsersResProfileOrganizationContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
    address?: LocationDataModel;
};

export type RegisterUsersRes1Dto = {
    resource_type: ResourceType;
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: 'ota';
    account: RegisterUsersRes1AccountDto;
    name: OtaName;
    supplier_id?: number;
};

export type RegisterUsersRes1AccountDto = {
    memberships: RegisterUsersResAccountMembershipsDto;
    workspaces: RegisterUsersResAccountWorkspacesDto;
};

export type RegisterUsersRes2Dto = {
    resource_type: ResourceType;
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: 'widget';
    account: RegisterUsersRes1AccountDto;
    name: WidgetName;
    active: boolean;
};

export type GetUserResDto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type: 'human';
    account: GetUserResAccountDto;
    access: GetUserResAccessDto;
    profile: GetUserResProfileDto;
    subscription:
        | FreeSubscriptionData
        | ProfessionalSubscriptionData
        | TeamSubscriptionData
        | EnterpriseSubscriptionData;
};

export type GetUserResAccountDto = {
    memberships: GetUserResAccountMembershipsDto;
    workspaces: GetUserResAccountWorkspacesDto;
    settings: GetUserResAccountSettingsDto;
};

export type GetUserResAccountMembershipsDto = {
    items: Array<
        | GetUserResAccountMembershipsItem0Dto
        | GetUserResAccountMembershipsItem1Dto
    >;
};

export type GetUserResAccountMembershipsItem0Dto = {
    role:
        | GetUserResAccountMembershipsItem0Role0Dto
        | GetUserResAccountMembershipsItem0Role1Dto;
    invited?: Action;
    joined?: Action;
    status: UserMembershipStatus;
    id: string;
    group: GetUserResAccountMembershipsItem0GroupDto;
};

export type GetUserResAccountMembershipsItem0Role0Dto = {
    type: 'owner';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessDto = {
    team?: GetUserResAccountMembershipsItem0Role0AccessTeamDto;
    user: GetUserResAccountMembershipsItem0Role0AccessUserDto;
    product: GetUserResAccountMembershipsItem0Role0AccessProductDto;
    booking: GetUserResAccountMembershipsItem0Role0AccessBookingDto;
    event: GetUserResAccountMembershipsItem0Role0AccessEventDto;
    order: GetUserResAccountMembershipsItem0Role0AccessOrderDto;
    asset?: GetUserResAccountMembershipsItem0Role0AccessAssetDto;
    customer: GetUserResAccountMembershipsItem0Role0AccessCustomerDto;
    capacity: GetUserResAccountMembershipsItem0Role0AccessCapacityDto;
    schedule: GetUserResAccountMembershipsItem0Role0AccessScheduleDto;
    report?: GetUserResAccountMembershipsItem0Role0AccessReportDto;
    dashboard?: GetUserResAccountMembershipsItem0Role0AccessDashboardDto;
    product_variant?: GetUserResAccountMembershipsItem0Role0AccessProductDto;
    task?: GetUserResAccountMembershipsItem0Role0AccessTaskDto;
    location?: GetUserResAccountMembershipsItem0Role0AccessLocationDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessTeamDto = {
    permissions: TeamPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessTeamViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessTeamViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessUserDto = {
    permissions: UserPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessUserViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessUserViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessProductDto = {
    permissions: ProductPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessProductViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessProductViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessBookingDto = {
    permissions: BookingPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessBookingViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessBookingViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessEventDto = {
    permissions: EventPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessEventViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessEventViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessOrderDto = {
    permissions: OrderPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessOrderViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessOrderViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessAssetDto = {
    permissions: AssetPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessAssetViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessAssetViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessCustomerDto = {
    permissions: CustomerPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessCustomerViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessCustomerViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessCapacityDto = {
    permissions: CapacityPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessCapacityViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessCapacityViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessScheduleDto = {
    permissions: SchedulePermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessScheduleViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessScheduleViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessReportDto = {
    permissions: ReportPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessReportViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessReportViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessDashboardDto = {
    permissions: DashboardPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessDashboardViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessDashboardViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role0AccessTaskDto = {
    permissions: TaskPermissionsData;
};

export type GetUserResAccountMembershipsItem0Role0AccessLocationDto = {
    permissions: LocationPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessLocationViewDto;
};

export type GetUserResAccountMembershipsItem0Role0AccessLocationViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetUserResAccountMembershipsItem0Role1Dto = {
    type: 'widget';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem0GroupDto = {
    type: 'individual';
    id: string;
    name?: string;
};

export type GetUserResAccountMembershipsItem1Dto = {
    role:
        | GetUserResAccountMembershipsItem1Role0Dto
        | GetUserResAccountMembershipsItem1Role1Dto
        | GetUserResAccountMembershipsItem1Role2Dto
        | GetUserResAccountMembershipsItem1Role3Dto
        | GetUserResAccountMembershipsItem1Role4Dto
        | GetUserResAccountMembershipsItem0Role0Dto
        | GetUserResAccountMembershipsItem1Role6Dto
        | GetUserResAccountMembershipsItem1Role7Dto
        | GetUserResAccountMembershipsItem0Role1Dto;
    invited?: Action;
    joined?: Action;
    status: UserMembershipStatus;
    id: string;
    group: GetUserResAccountMembershipsItem1GroupDto;
};

export type GetUserResAccountMembershipsItem1Role0Dto = {
    type: 'accountant';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role1Dto = {
    type: 'administrator';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role2Dto = {
    type: 'contributor';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role3Dto = {
    type: 'editor';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role4Dto = {
    type: 'event_staff';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role6Dto = {
    type: 'partner';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1Role7Dto = {
    type: 'viewer';
    access: GetUserResAccountMembershipsItem0Role0AccessDto;
};

export type GetUserResAccountMembershipsItem1GroupDto = {
    type: 'team';
    id: string;
    name?: string;
};

export type GetUserResAccountWorkspacesDto = {
    items: Array<GetUserResAccountWorkspacesItemDto>;
    current: GetUserResAccountWorkspacesItemDto;
};

export type GetUserResAccountWorkspacesItemDto = {
    id: string;
    name: string;
    membership:
        | GetUserResAccountMembershipsItem0Dto
        | GetUserResAccountMembershipsItem1Dto;
};

export type GetUserResAccountSettingsDto = {
    financial: GetUserResAccountSettingsFinancialDto;
    calendar: GetUserResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type GetUserResAccountSettingsFinancialDto = {
    currencies: Array<CurrencySetting>;
    payment_gateways?: GetUserResAccountSettingsFinancialPaymentGatewaysDto;
};

export type GetUserResAccountSettingsFinancialPaymentGatewaysDto = {
    items: Array<GetUserResAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type GetUserResAccountSettingsFinancialPaymentGatewaysItemDto = {
    id: string;
    reference:
        | GetUserResAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | GetUserResAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type GetUserResAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider: 'ameriabank';
        client_id: string;
        username: string;
    };

export type GetUserResAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider: 'flitt';
        merchant_id: string;
    };

export type GetUserResAccountSettingsCalendarDto = {
    timezone: TimezoneData;
    workweek?: GetUserResAccountSettingsCalendarWorkweekDto;
};

export type GetUserResAccountSettingsCalendarWorkweekDto = {
    monday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    thursday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    friday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    saturday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
    sunday?: GetUserResAccountSettingsCalendarWorkweekMondayDto;
};

export type GetUserResAccountSettingsCalendarWorkweekMondayDto = {
    work_hours: Array<TimeOffsetRange>;
};

export type GetUserResAccessDto = {
    permissions: UserPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessUserViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetUserResAccessGroupsDto = {
    items: Array<GetUserResAccessGroupsItemDto>;
    primary: GetUserResAccessGroupsItemDto;
};

export type GetUserResAccessGroupsItemDto = {
    id: string;
    reference:
        | GetUserResAccountMembershipsItem0GroupDto
        | GetUserResAccountMembershipsItem1GroupDto;
};

export type GetUserResProfileDto = {
    contact_details?: GetUserResProfileContactDetailsDto;
    attachments?: GetUserResProfileAttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: GetUserResProfileOrganizationDto;
    occupation: UserOccupation;
    avatar?: GetUserResProfileAttachmentsItemReference0Dto;
};

export type GetUserResProfileContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type GetUserResProfileAttachmentsDto = {
    items: Array<GetUserResProfileAttachmentsItemDto>;
};

export type GetUserResProfileAttachmentsItemDto = {
    id: string;
    reference:
        | GetUserResProfileAttachmentsItemReference0Dto
        | GetUserResProfileAttachmentsItemReference1Dto;
};

export type GetUserResProfileAttachmentsItemReference0Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id: string;
    width: number;
    height: number;
};

export type GetUserResProfileAttachmentsItemReference1Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id: string;
};

export type GetUserResProfileOrganizationDto = {
    type: 'organization';
    id?: string;
    contact_details?: GetUserResProfileOrganizationContactDetailsDto;
    name: string;
};

export type GetUserResProfileOrganizationContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
    address?: LocationDataModel;
};

export type GetUserRes1Dto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type: 'ota';
    account: GetUserRes1AccountDto;
    name: OtaName;
    supplier_id?: number;
};

export type GetUserRes1AccountDto = {
    memberships: GetUserResAccountMembershipsDto;
    workspaces: GetUserResAccountWorkspacesDto;
};

export type GetUserRes2Dto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type: 'widget';
    account: GetUserRes1AccountDto;
    name: WidgetName;
    active?: boolean;
};

export type UpdateUserReqDto = {
    resource_type?: ResourceType;
    type?: 'human';
    account?: UpdateUserReqAccountDto;
    access?: UpdateUserReqAccessDto;
    profile?: UpdateUserReqProfileDto;
};

export type UpdateUserReqAccountDto = {
    memberships?: UpdateUserReqAccountMembershipsDto;
    workspaces?: UpdateUserReqAccountWorkspacesDto;
};

export type UpdateUserReqAccountMembershipsDto = {
    items?: Array<
        | UpdateUserReqAccountMembershipsItem0Dto
        | UpdateUserReqAccountMembershipsItem1Dto
    >;
};

export type UpdateUserReqAccountMembershipsItem0Dto = {
    role?:
        | UpdateUserReqAccountMembershipsItem0Role0Dto
        | UpdateUserReqAccountMembershipsItem0Role1Dto;
    invited?: UpdateUserReqAccountMembershipsItem0InvitedDto;
    joined?: UpdateUserReqAccountMembershipsItem0InvitedDto;
    status?: UserMembershipStatus;
    action: ListItemAction;
    id?: string;
    group?: UpdateUserReqAccountMembershipsItem0GroupDto;
};

export type UpdateUserReqAccountMembershipsItem0Role0Dto = {
    type?: 'owner';
};

export type UpdateUserReqAccountMembershipsItem0Role1Dto = {
    type?: 'widget';
};

export type UpdateUserReqAccountMembershipsItem0InvitedDto = {
    [key: string]: unknown;
};

export type UpdateUserReqAccountMembershipsItem0GroupDto = {
    type?: 'individual';
    id?: string;
    name?: string;
};

export type UpdateUserReqAccountMembershipsItem1Dto = {
    role?:
        | UpdateUserReqAccountMembershipsItem1Role0Dto
        | UpdateUserReqAccountMembershipsItem1Role1Dto
        | UpdateUserReqAccountMembershipsItem1Role2Dto
        | UpdateUserReqAccountMembershipsItem1Role3Dto
        | UpdateUserReqAccountMembershipsItem1Role4Dto
        | UpdateUserReqAccountMembershipsItem0Role0Dto
        | UpdateUserReqAccountMembershipsItem1Role6Dto
        | UpdateUserReqAccountMembershipsItem1Role7Dto
        | UpdateUserReqAccountMembershipsItem0Role1Dto;
    invited?: UpdateUserReqAccountMembershipsItem0InvitedDto;
    joined?: UpdateUserReqAccountMembershipsItem0InvitedDto;
    status?: UserMembershipStatus;
    action: ListItemAction;
    id?: string;
    group?: UpdateUserReqAccountMembershipsItem1GroupDto;
};

export type UpdateUserReqAccountMembershipsItem1Role0Dto = {
    type?: 'accountant';
};

export type UpdateUserReqAccountMembershipsItem1Role1Dto = {
    type?: 'administrator';
};

export type UpdateUserReqAccountMembershipsItem1Role2Dto = {
    type?: 'contributor';
};

export type UpdateUserReqAccountMembershipsItem1Role3Dto = {
    type?: 'editor';
};

export type UpdateUserReqAccountMembershipsItem1Role4Dto = {
    type?: 'event_staff';
};

export type UpdateUserReqAccountMembershipsItem1Role6Dto = {
    type?: 'partner';
};

export type UpdateUserReqAccountMembershipsItem1Role7Dto = {
    type?: 'viewer';
};

export type UpdateUserReqAccountMembershipsItem1GroupDto = {
    type?: 'team';
    id?: string;
    name?: string;
};

export type UpdateUserReqAccountWorkspacesDto = {
    items?: Array<UpdateUserReqAccountWorkspacesItemDto>;
    current?: UpdateUserReqAccountWorkspacesItemDto;
};

export type UpdateUserReqAccountWorkspacesItemDto = {
    action: ListItemAction;
    id?: string;
    name?: string;
    membership?:
        | UpdateUserReqAccountMembershipsItem0Dto
        | UpdateUserReqAccountMembershipsItem1Dto;
};

export type UpdateUserReqAccountSettingsFinancialDto = {
    currencies?: Array<CurrencySetting>;
    payment_gateways?: UpdateUserReqAccountSettingsFinancialPaymentGatewaysDto;
};

export type UpdateUserReqAccountSettingsFinancialPaymentGatewaysDto = {
    items?: Array<UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemDto = {
    action: ListItemAction;
    id?: string;
    reference?:
        | UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider?: 'ameriabank';
        client_id?: string;
        username?: string;
        password?: string;
    };

export type UpdateUserReqAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider?: 'flitt';
        merchant_id?: string;
        secret_key?: string;
    };

export type UpdateUserReqAccountSettingsCalendarDto = {
    timezone?: TimezoneData;
    workweek?: UpdateUserReqAccountSettingsCalendarWorkweekDto;
};

export type UpdateUserReqAccountSettingsCalendarWorkweekDto = {
    monday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    thursday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    friday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    saturday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
    sunday?: UpdateUserReqAccountSettingsCalendarWorkweekMondayDto;
};

export type UpdateUserReqAccountSettingsCalendarWorkweekMondayDto = {
    work_hours?: Array<TimeOffsetRange>;
};

export type UpdateUserReqAccessDto = {
    groups?: UpdateUserReqAccessGroupsDto;
};

export type UpdateUserReqAccessGroupsDto = {
    items?: Array<UpdateUserReqAccessGroupsItemDto>;
};

export type UpdateUserReqAccessGroupsItemDto = {
    action: ListItemAction;
    id?: string;
    reference?:
        | UpdateUserReqAccountMembershipsItem0GroupDto
        | UpdateUserReqAccountMembershipsItem1GroupDto;
};

export type UpdateUserReqProfileDto = {
    contact_details?: UpdateUserReqProfileContactDetailsDto;
    attachments?: UpdateUserReqProfileAttachmentsDto;
    name?: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: UpdateUserReqProfileOrganizationDto;
    occupation?: UserOccupation;
    avatar?: UpdateUserReqProfileAttachmentsItemReference0Dto;
};

export type UpdateUserReqProfileContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type UpdateUserReqProfileAttachmentsDto = {
    items?: Array<UpdateUserReqProfileAttachmentsItemDto>;
};

export type UpdateUserReqProfileAttachmentsItemDto = {
    action: ListItemAction;
    id?: string;
    reference?:
        | UpdateUserReqProfileAttachmentsItemReference0Dto
        | UpdateUserReqProfileAttachmentsItemReference1Dto;
};

export type UpdateUserReqProfileAttachmentsItemReference0Dto = {
    type?: FileType;
    content_type?: ContentType;
    b64_encoded?: boolean;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    content?: string;
    id?: string;
    width?: number;
    height?: number;
};

export type UpdateUserReqProfileAttachmentsItemReference1Dto = {
    type?: FileType;
    content_type?: ContentType;
    b64_encoded?: boolean;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    content?: string;
    id?: string;
};

export type UpdateUserReqProfileOrganizationDto = {
    type?: 'organization';
    id?: string;
    contact_details?: UpdateUserReqProfileOrganizationContactDetailsDto;
    name?: string;
};

export type UpdateUserReqProfileOrganizationContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
    address?: LocationDataModel;
};

export type UpdateUserReq1Dto = {
    resource_type?: ResourceType;
    type?: 'ota';
    account?: UpdateUserReqAccountDto;
    name?: OtaName;
    supplier_id?: number;
};

export type UpdateUserReq2Dto = {
    resource_type?: ResourceType;
    type?: 'widget';
    account?: UpdateUserReqAccountDto;
    name?: WidgetName;
    active?: boolean;
};

export type UpdateUserResDto = {
    resource_type?: ResourceType;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type?: 'human';
    account?: UpdateUserResAccountDto;
    access?: UpdateUserResAccessDto;
    profile?: UpdateUserResProfileDto;
    subscription?:
        | FreeSubscriptionData
        | ProfessionalSubscriptionData
        | TeamSubscriptionData
        | EnterpriseSubscriptionData;
};

export type UpdateUserResAccountDto = {
    memberships?: UpdateUserResAccountMembershipsDto;
    workspaces: UpdateUserResAccountWorkspacesDto;
    settings?: UpdateUserResAccountSettingsDto;
};

export type UpdateUserResAccountMembershipsDto = {
    items?: Array<
        | UpdateUserResAccountMembershipsItem0Dto
        | UpdateUserResAccountMembershipsItem1Dto
    >;
};

export type UpdateUserResAccountMembershipsItem0Dto = {
    role?:
        | UpdateUserResAccountMembershipsItem0Role0Dto
        | UpdateUserResAccountMembershipsItem0Role1Dto;
    invited?: Action;
    joined?: Action;
    status?: UserMembershipStatus;
    id: string;
    group?: UpdateUserResAccountMembershipsItem0GroupDto;
};

export type UpdateUserResAccountMembershipsItem0Role0Dto = {
    type: 'owner';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessDto = {
    team?: UpdateUserResAccountMembershipsItem0Role0AccessTeamDto;
    user: UpdateUserResAccountMembershipsItem0Role0AccessUserDto;
    product: UpdateUserResAccountMembershipsItem0Role0AccessProductDto;
    booking: UpdateUserResAccountMembershipsItem0Role0AccessBookingDto;
    event: UpdateUserResAccountMembershipsItem0Role0AccessEventDto;
    order: UpdateUserResAccountMembershipsItem0Role0AccessOrderDto;
    asset?: UpdateUserResAccountMembershipsItem0Role0AccessAssetDto;
    customer: UpdateUserResAccountMembershipsItem0Role0AccessCustomerDto;
    capacity: UpdateUserResAccountMembershipsItem0Role0AccessCapacityDto;
    schedule: UpdateUserResAccountMembershipsItem0Role0AccessScheduleDto;
    report?: UpdateUserResAccountMembershipsItem0Role0AccessReportDto;
    dashboard?: UpdateUserResAccountMembershipsItem0Role0AccessDashboardDto;
    product_variant?: UpdateUserResAccountMembershipsItem0Role0AccessProductDto;
    task?: UpdateUserResAccountMembershipsItem0Role0AccessTaskDto;
    location?: UpdateUserResAccountMembershipsItem0Role0AccessLocationDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessTeamDto = {
    permissions: TeamPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessTeamViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessTeamViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessUserDto = {
    permissions: UserPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessUserViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessUserViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessProductDto = {
    permissions: ProductPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessProductViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessProductViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessBookingDto = {
    permissions: BookingPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessBookingViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessBookingViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessEventDto = {
    permissions: EventPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessEventViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessEventViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessOrderDto = {
    permissions: OrderPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessOrderViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessOrderViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessAssetDto = {
    permissions: AssetPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessAssetViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessAssetViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessCustomerDto = {
    permissions: CustomerPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessCustomerViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessCustomerViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessCapacityDto = {
    permissions: CapacityPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessCapacityViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessCapacityViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessScheduleDto = {
    permissions: SchedulePermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessScheduleViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessScheduleViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessReportDto = {
    permissions: ReportPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessReportViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessReportViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessDashboardDto = {
    permissions: DashboardPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessDashboardViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessDashboardViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role0AccessTaskDto = {
    permissions: TaskPermissionsData;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessLocationDto = {
    permissions: LocationPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessLocationViewDto;
};

export type UpdateUserResAccountMembershipsItem0Role0AccessLocationViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type UpdateUserResAccountMembershipsItem0Role1Dto = {
    type: 'widget';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem0GroupDto = {
    type?: 'individual';
    id?: string;
    name?: string;
};

export type UpdateUserResAccountMembershipsItem1Dto = {
    role?:
        | UpdateUserResAccountMembershipsItem1Role0Dto
        | UpdateUserResAccountMembershipsItem1Role1Dto
        | UpdateUserResAccountMembershipsItem1Role2Dto
        | UpdateUserResAccountMembershipsItem1Role3Dto
        | UpdateUserResAccountMembershipsItem1Role4Dto
        | UpdateUserResAccountMembershipsItem0Role0Dto
        | UpdateUserResAccountMembershipsItem1Role6Dto
        | UpdateUserResAccountMembershipsItem1Role7Dto
        | UpdateUserResAccountMembershipsItem0Role1Dto;
    invited?: Action;
    joined?: Action;
    status?: UserMembershipStatus;
    id: string;
    group?: UpdateUserResAccountMembershipsItem1GroupDto;
};

export type UpdateUserResAccountMembershipsItem1Role0Dto = {
    type: 'accountant';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role1Dto = {
    type: 'administrator';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role2Dto = {
    type: 'contributor';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role3Dto = {
    type: 'editor';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role4Dto = {
    type: 'event_staff';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role6Dto = {
    type: 'partner';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1Role7Dto = {
    type: 'viewer';
    access: UpdateUserResAccountMembershipsItem0Role0AccessDto;
};

export type UpdateUserResAccountMembershipsItem1GroupDto = {
    type?: 'team';
    id?: string;
    name?: string;
};

export type UpdateUserResAccountWorkspacesDto = {
    items: Array<UpdateUserResAccountWorkspacesItemDto>;
    current: UpdateUserResAccountWorkspacesItemDto;
};

export type UpdateUserResAccountWorkspacesItemDto = {
    id: string;
    name: string;
    membership:
        | UpdateUserResAccountMembershipsItem0Dto
        | UpdateUserResAccountMembershipsItem1Dto;
};

export type UpdateUserResAccountSettingsDto = {
    financial?: UpdateUserResAccountSettingsFinancialDto;
    calendar?: UpdateUserResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type UpdateUserResAccountSettingsFinancialDto = {
    currencies?: Array<CurrencySetting>;
    payment_gateways?: UpdateUserResAccountSettingsFinancialPaymentGatewaysDto;
};

export type UpdateUserResAccountSettingsFinancialPaymentGatewaysDto = {
    items: Array<UpdateUserResAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type UpdateUserResAccountSettingsFinancialPaymentGatewaysItemDto = {
    id: string;
    reference:
        | UpdateUserResAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | UpdateUserResAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type UpdateUserResAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider: 'ameriabank';
        client_id: string;
        username: string;
    };

export type UpdateUserResAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider: 'flitt';
        merchant_id: string;
    };

export type UpdateUserResAccountSettingsCalendarDto = {
    timezone?: TimezoneData;
    workweek?: UpdateUserResAccountSettingsCalendarWorkweekDto;
};

export type UpdateUserResAccountSettingsCalendarWorkweekDto = {
    monday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    thursday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    friday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    saturday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
    sunday?: UpdateUserResAccountSettingsCalendarWorkweekMondayDto;
};

export type UpdateUserResAccountSettingsCalendarWorkweekMondayDto = {
    work_hours?: Array<TimeOffsetRange>;
};

export type UpdateUserResAccessDto = {
    permissions: UserPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessUserViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type UpdateUserResAccessGroupsDto = {
    items: Array<UpdateUserResAccessGroupsItemDto>;
    primary: UpdateUserResAccessGroupsItemDto;
};

export type UpdateUserResAccessGroupsItemDto = {
    id: string;
    reference?:
        | UpdateUserResAccountMembershipsItem0GroupDto
        | UpdateUserResAccountMembershipsItem1GroupDto;
};

export type UpdateUserResProfileDto = {
    contact_details?: UpdateUserResProfileContactDetailsDto;
    attachments?: UpdateUserResProfileAttachmentsDto;
    name?: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: UpdateUserResProfileOrganizationDto;
    occupation?: UserOccupation;
    avatar?: UpdateUserResProfileAttachmentsItemReference0Dto;
};

export type UpdateUserResProfileContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type UpdateUserResProfileAttachmentsDto = {
    items: Array<UpdateUserResProfileAttachmentsItemDto>;
};

export type UpdateUserResProfileAttachmentsItemDto = {
    id: string;
    reference:
        | UpdateUserResProfileAttachmentsItemReference0Dto
        | UpdateUserResProfileAttachmentsItemReference1Dto;
};

export type UpdateUserResProfileAttachmentsItemReference0Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id?: string;
    width: number;
    height: number;
};

export type UpdateUserResProfileAttachmentsItemReference1Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id?: string;
};

export type UpdateUserResProfileOrganizationDto = {
    type?: 'organization';
    id?: string;
    contact_details?: UpdateUserResProfileOrganizationContactDetailsDto;
    name?: string;
};

export type UpdateUserResProfileOrganizationContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
    address?: LocationDataModel;
};

export type UpdateUserRes1Dto = {
    resource_type?: ResourceType;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type?: 'ota';
    account?: UpdateUserRes1AccountDto;
    name?: OtaName;
    supplier_id?: number;
};

export type UpdateUserRes1AccountDto = {
    memberships?: UpdateUserResAccountMembershipsDto;
    workspaces: UpdateUserResAccountWorkspacesDto;
};

export type UpdateUserRes2Dto = {
    resource_type?: ResourceType;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type?: 'widget';
    account?: UpdateUserRes1AccountDto;
    name?: WidgetName;
    active?: boolean;
};

export type SetAvatarUsers1ReqDto = {
    type?: FileType;
    content_type: ContentType;
    b64_encoded?: boolean;
    name: string;
    content: string;
    access?: SetAvatarUsers1ReqAccessDto;
    width: number;
    height: number;
};

export type SetAvatarUsers1ReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type SetAvatarUsers1ReqAccessGroupsDto = {
    items?: Array<SetAvatarUsers1ReqAccessGroupsItemDto>;
};

export type SetAvatarUsers1ReqAccessGroupsItemDto = {
    action?: ListItemAction;
    id: string;
    reference?:
        | SetAvatarUsers1ReqAccessGroupsItemReference0Dto
        | SetAvatarUsers1ReqAccessGroupsItemReference1Dto;
};

export type SetAvatarUsers1ReqAccessGroupsItemReference0Dto = {
    type: 'individual';
    id?: string;
    name?: string;
};

export type SetAvatarUsers1ReqAccessGroupsItemReference1Dto = {
    type: 'team';
    id?: string;
    name?: string;
};

export type SetAvatarUsers1Req1Dto = {
    type?: FileType;
    content_type: ContentType;
    b64_encoded?: boolean;
    name: string;
    content: string;
    access?: SetAvatarUsers1ReqAccessDto;
};

export type SetAvatarUsers1Req2Dto = {
    type?: FileType;
    content_type: ContentType;
    b64_encoded?: boolean;
    name: string;
    content: string;
    access?: SetAvatarUsers1ReqAccessDto;
};

export type GetTeamsResDto = {
    items?: Array<GetTeamsResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetTeamsResItemDto = {
    resource_type: 'team';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    name: string;
    description?: string;
    members: GetTeamsResItemMembersDto;
    insight?: TeamInsightData;
    access: GetTeamsResItemAccessDto;
    account: GetTeamsResItemAccountDto;
};

export type GetTeamsResItemMembersDto = {
    items: Array<
        GetTeamsResItemMembersItem0Dto | GetTeamsResItemMembersItem1Dto
    >;
};

export type GetTeamsResItemMembersItem0Dto = {
    id: string;
    reference?: GetTeamsResItemMembersItem0ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | GetTeamsResItemMembersItem0Membership0Dto
        | GetTeamsResItemMembersItem0Membership1Dto;
};

export type GetTeamsResItemMembersItem0ReferenceDto = {
    type: 'person';
    id?: string;
    contact_details?: GetTeamsResItemMembersItem0ReferenceContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: GetTeamsResItemMembersItem0ReferenceOrganizationDto;
};

export type GetTeamsResItemMembersItem0ReferenceContactDetailsDto = {
    emails?: Array<string>;
    phone_numbers?: Array<PhoneNumberData>;
};

export type GetTeamsResItemMembersItem0ReferenceOrganizationDto = {
    type: 'organization';
    id?: string;
    contact_details?: GetTeamsResItemMembersItem0ReferenceOrganizationContactDetailsDto;
    name: string;
};

export type GetTeamsResItemMembersItem0ReferenceOrganizationContactDetailsDto =
    {
        emails?: Array<string>;
        phone_numbers?: Array<PhoneNumberData>;
        address?: LocationDataModel;
    };

export type GetTeamsResItemMembersItem0Membership0Dto = {
    role:
        | GetTeamsResItemMembersItem0Membership0Role0Dto
        | GetTeamsResItemMembersItem0Membership0Role1Dto;
    invited?: Action;
    joined?: Action;
    status: UserMembershipStatus;
    id: string;
    group: GetTeamsResItemMembersItem0Membership0GroupDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0Dto = {
    type: 'owner';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessDto = {
    team?: GetTeamsResItemMembersItem0Membership0Role0AccessTeamDto;
    user: GetTeamsResItemMembersItem0Membership0Role0AccessUserDto;
    product: GetTeamsResItemMembersItem0Membership0Role0AccessProductDto;
    booking: GetTeamsResItemMembersItem0Membership0Role0AccessBookingDto;
    event: GetTeamsResItemMembersItem0Membership0Role0AccessEventDto;
    order: GetTeamsResItemMembersItem0Membership0Role0AccessOrderDto;
    asset?: GetTeamsResItemMembersItem0Membership0Role0AccessAssetDto;
    customer: GetTeamsResItemMembersItem0Membership0Role0AccessCustomerDto;
    capacity: GetTeamsResItemMembersItem0Membership0Role0AccessCapacityDto;
    schedule: GetTeamsResItemMembersItem0Membership0Role0AccessScheduleDto;
    report?: GetTeamsResItemMembersItem0Membership0Role0AccessReportDto;
    dashboard?: GetTeamsResItemMembersItem0Membership0Role0AccessDashboardDto;
    product_variant?: GetTeamsResItemMembersItem0Membership0Role0AccessProductDto;
    task?: GetTeamsResItemMembersItem0Membership0Role0AccessTaskDto;
    location?: GetTeamsResItemMembersItem0Membership0Role0AccessLocationDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessTeamDto = {
    permissions: TeamPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessTeamViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessTeamViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessUserDto = {
    permissions: UserPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessUserViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessUserViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessProductDto = {
    permissions: ProductPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessProductViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessProductViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessBookingDto = {
    permissions: BookingPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessBookingViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessBookingViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessEventDto = {
    permissions: EventPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessEventViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessEventViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessOrderDto = {
    permissions: OrderPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessOrderViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessOrderViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessAssetDto = {
    permissions: AssetPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessAssetViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessAssetViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessCustomerDto = {
    permissions: CustomerPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessCustomerViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessCustomerViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessCapacityDto = {
    permissions: CapacityPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessCapacityViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessCapacityViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessScheduleDto = {
    permissions: SchedulePermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessScheduleViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessScheduleViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessReportDto = {
    permissions: ReportPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessReportViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessReportViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessDashboardDto = {
    permissions: DashboardPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessDashboardViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessDashboardViewDto =
    {
        projections?: Array<string>;
        exclusions?: {
            [key: string]: unknown;
        };
    };

export type GetTeamsResItemMembersItem0Membership0Role0AccessTaskDto = {
    permissions: TaskPermissionsData;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessLocationDto = {
    permissions: LocationPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessLocationViewDto;
};

export type GetTeamsResItemMembersItem0Membership0Role0AccessLocationViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type GetTeamsResItemMembersItem0Membership0Role1Dto = {
    type: 'widget';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership0GroupDto = {
    type: 'individual';
    id: string;
    name?: string;
};

export type GetTeamsResItemMembersItem0Membership1Dto = {
    role:
        | GetTeamsResItemMembersItem0Membership1Role0Dto
        | GetTeamsResItemMembersItem0Membership1Role1Dto
        | GetTeamsResItemMembersItem0Membership1Role2Dto
        | GetTeamsResItemMembersItem0Membership1Role3Dto
        | GetTeamsResItemMembersItem0Membership1Role4Dto
        | GetTeamsResItemMembersItem0Membership0Role0Dto
        | GetTeamsResItemMembersItem0Membership1Role6Dto
        | GetTeamsResItemMembersItem0Membership1Role7Dto
        | GetTeamsResItemMembersItem0Membership0Role1Dto;
    invited?: Action;
    joined?: Action;
    status: UserMembershipStatus;
    id: string;
    group: GetTeamsResItemMembersItem0Membership1GroupDto;
};

export type GetTeamsResItemMembersItem0Membership1Role0Dto = {
    type: 'accountant';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role1Dto = {
    type: 'administrator';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role2Dto = {
    type: 'contributor';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role3Dto = {
    type: 'editor';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role4Dto = {
    type: 'event_staff';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role6Dto = {
    type: 'partner';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1Role7Dto = {
    type: 'viewer';
    access: GetTeamsResItemMembersItem0Membership0Role0AccessDto;
};

export type GetTeamsResItemMembersItem0Membership1GroupDto = {
    type: 'team';
    id: string;
    name?: string;
};

export type GetTeamsResItemMembersItem1Dto = {
    id: string;
    reference?: GetTeamsResItemMembersItem1ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | GetTeamsResItemMembersItem0Membership0Dto
        | GetTeamsResItemMembersItem0Membership1Dto;
};

export type GetTeamsResItemMembersItem1ReferenceDto = {
    id: string;
    type: 'ota';
    name: OtaName;
};

export type GetTeamsResItemAccessDto = {
    permissions: TeamPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessTeamViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetTeamsResItemAccessGroupsDto = {
    items: Array<GetTeamsResItemAccessGroupsItemDto>;
    primary: GetTeamsResItemAccessGroupsItemDto;
};

export type GetTeamsResItemAccessGroupsItemDto = {
    id: string;
    reference:
        | GetTeamsResItemMembersItem0Membership0GroupDto
        | GetTeamsResItemMembersItem0Membership1GroupDto;
};

export type GetTeamsResItemAccountDto = {
    settings: GetTeamsResItemAccountSettingsDto;
};

export type GetTeamsResItemAccountSettingsDto = {
    financial: GetTeamsResItemAccountSettingsFinancialDto;
    calendar: GetTeamsResItemAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type GetTeamsResItemAccountSettingsFinancialDto = {
    currencies: Array<CurrencySetting>;
    payment_gateways?: GetTeamsResItemAccountSettingsFinancialPaymentGatewaysDto;
};

export type GetTeamsResItemAccountSettingsFinancialPaymentGatewaysDto = {
    items: Array<GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemDto>;
};

export type GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemDto = {
    id: string;
    reference:
        | GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemReference0Dto
        | GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemReference1Dto;
};

export type GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemReference0Dto =
    {
        provider: 'ameriabank';
        client_id: string;
        username: string;
    };

export type GetTeamsResItemAccountSettingsFinancialPaymentGatewaysItemReference1Dto =
    {
        provider: 'flitt';
        merchant_id: string;
    };

export type GetTeamsResItemAccountSettingsCalendarDto = {
    timezone: TimezoneData;
    workweek?: GetTeamsResItemAccountSettingsCalendarWorkweekDto;
};

export type GetTeamsResItemAccountSettingsCalendarWorkweekDto = {
    monday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    tuesday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    wednesday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    thursday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    friday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    saturday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
    sunday?: GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto;
};

export type GetTeamsResItemAccountSettingsCalendarWorkweekMondayDto = {
    work_hours: Array<TimeOffsetRange>;
};

export type CreateTeamReqDto = {
    name: string;
    description?: string;
    access?: CreateTeamReqAccessDto;
    account?: CreateTeamReqAccountDto;
};

export type CreateTeamReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateTeamReqAccountDto = {
    settings: CreateTeamReqAccountSettingsDto;
};

export type CreateTeamReqAccountSettingsDto = {
    financial: RegisterUsersReqAccountSettingsFinancialDto;
    calendar: RegisterUsersReqAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type CreateTeamResDto = {
    resource_type: 'team';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    name: string;
    description?: string;
    members: CreateTeamResMembersDto;
    access: CreateTeamResAccessDto;
    account: CreateTeamResAccountDto;
};

export type CreateTeamResMembersDto = {
    items: Array<CreateTeamResMembersItem0Dto | CreateTeamResMembersItem1Dto>;
};

export type CreateTeamResMembersItem0Dto = {
    action?: ListItemAction;
    id: string;
    reference?: CreateTeamResMembersItem0ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | RegisterUsersResAccountMembershipsItem0Dto
        | RegisterUsersResAccountMembershipsItem1Dto;
};

export type CreateTeamResMembersItem0ReferenceDto = {
    type: 'person';
    id?: string;
    contact_details?: RegisterUsersResProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: RegisterUsersResProfileOrganizationDto;
};

export type CreateTeamResMembersItem1Dto = {
    action?: ListItemAction;
    id: string;
    reference?: CreateTeamResMembersItem1ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | RegisterUsersResAccountMembershipsItem0Dto
        | RegisterUsersResAccountMembershipsItem1Dto;
};

export type CreateTeamResMembersItem1ReferenceDto = {
    id: string;
    type: 'ota';
    name: OtaName;
};

export type CreateTeamResAccessDto = {
    permissions: TeamPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessTeamViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type CreateTeamResAccountDto = {
    settings: CreateTeamResAccountSettingsDto;
};

export type CreateTeamResAccountSettingsDto = {
    financial: RegisterUsersResAccountSettingsFinancialDto;
    calendar: RegisterUsersResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type GetTeamResDto = {
    resource_type: 'team';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name: string;
    description?: string;
    members: GetTeamResMembersDto;
    insight?: TeamInsightData;
    access: GetTeamResAccessDto;
    account: GetTeamResAccountDto;
};

export type GetTeamResMembersDto = {
    items: Array<GetTeamResMembersItem0Dto | GetTeamResMembersItem1Dto>;
};

export type GetTeamResMembersItem0Dto = {
    id: string;
    reference?: GetTeamResMembersItem0ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | GetUserResAccountMembershipsItem0Dto
        | GetUserResAccountMembershipsItem1Dto;
};

export type GetTeamResMembersItem0ReferenceDto = {
    type: 'person';
    id?: string;
    contact_details?: GetUserResProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: GetUserResProfileOrganizationDto;
};

export type GetTeamResMembersItem1Dto = {
    id: string;
    reference?: GetTeamResMembersItem1ReferenceDto;
    occupation?: UserOccupation;
    membership:
        | GetUserResAccountMembershipsItem0Dto
        | GetUserResAccountMembershipsItem1Dto;
};

export type GetTeamResMembersItem1ReferenceDto = {
    id: string;
    type: 'ota';
    name: OtaName;
};

export type GetTeamResAccessDto = {
    permissions: TeamPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessTeamViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetTeamResAccountDto = {
    settings: GetTeamResAccountSettingsDto;
};

export type GetTeamResAccountSettingsDto = {
    financial: GetUserResAccountSettingsFinancialDto;
    calendar: GetUserResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type UpdateMembersTeamsReqDto = {
    items?: Array<
        UpdateMembersTeamsReqItem0Dto | UpdateMembersTeamsReqItem1Dto
    >;
};

export type UpdateMembersTeamsReqItem0Dto = {
    action: ListItemAction;
    id?: string;
    reference?: UpdateMembersTeamsReqItem0ReferenceDto;
    occupation?: UserOccupation;
    membership?:
        | UpdateUserReqAccountMembershipsItem0Dto
        | UpdateUserReqAccountMembershipsItem1Dto;
};

export type UpdateMembersTeamsReqItem0ReferenceDto = {
    type?: 'person';
    id?: string;
    contact_details?: UpdateUserReqProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: UpdateUserReqProfileOrganizationDto;
};

export type UpdateMembersTeamsReqItem1Dto = {
    action: ListItemAction;
    id?: string;
    reference?: UpdateMembersTeamsReqItem1ReferenceDto;
    occupation?: UserOccupation;
    membership?:
        | UpdateUserReqAccountMembershipsItem0Dto
        | UpdateUserReqAccountMembershipsItem1Dto;
};

export type UpdateMembersTeamsReqItem1ReferenceDto = {
    id?: string;
    type?: 'ota';
    name?: OtaName;
};

export type UpdateMembersTeamsResDto = {
    resource_type?: 'team';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name?: string;
    description?: string;
    members?: UpdateMembersTeamsResMembersDto;
    access?: UpdateMembersTeamsResAccessDto;
    account?: UpdateMembersTeamsResAccountDto;
};

export type UpdateMembersTeamsResMembersDto = {
    items?: Array<
        | UpdateMembersTeamsResMembersItem0Dto
        | UpdateMembersTeamsResMembersItem1Dto
    >;
};

export type UpdateMembersTeamsResMembersItem0Dto = {
    id: string;
    reference?: UpdateMembersTeamsResMembersItem0ReferenceDto;
    occupation?: UserOccupation;
    membership?:
        | UpdateUserResAccountMembershipsItem0Dto
        | UpdateUserResAccountMembershipsItem1Dto;
};

export type UpdateMembersTeamsResMembersItem0ReferenceDto = {
    type?: 'person';
    id?: string;
    contact_details?: UpdateUserResProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: UpdateUserResProfileOrganizationDto;
};

export type UpdateMembersTeamsResMembersItem1Dto = {
    id: string;
    reference?: UpdateMembersTeamsResMembersItem1ReferenceDto;
    occupation?: UserOccupation;
    membership?:
        | UpdateUserResAccountMembershipsItem0Dto
        | UpdateUserResAccountMembershipsItem1Dto;
};

export type UpdateMembersTeamsResMembersItem1ReferenceDto = {
    id?: string;
    type?: 'ota';
    name?: OtaName;
};

export type UpdateMembersTeamsResAccessDto = {
    permissions: TeamPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessTeamViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type UpdateMembersTeamsResAccountDto = {
    settings?: UpdateMembersTeamsResAccountSettingsDto;
};

export type UpdateMembersTeamsResAccountSettingsDto = {
    financial?: UpdateUserResAccountSettingsFinancialDto;
    calendar?: UpdateUserResAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type UpdateTeamSettingsReqDto = {
    financial?: UpdateUserReqAccountSettingsFinancialDto;
    calendar?: UpdateUserReqAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type GetTeams1ReqDto = {
    product_id?: string;
    name?: string;
    email?: string;
};

export type ComputeAvailabilityReqDto = {
    user_group?:
        | ComputeAvailabilityReqUserGroup0Dto
        | ComputeAvailabilityReqUserGroup1Dto;
    iso_dates?: boolean;
    date: PeriodData;
    pax: PaxData;
    source?:
        | ComputeAvailabilityReqSource0Dto
        | ComputeAvailabilityReqSource1Dto;
    products?: Array<ComputeAvailabilityReqProductsItemDto>;
    events?: Array<ComputeAvailabilityReqEventsItemDto>;
    allow_start_in_past?: boolean;
    product_id_sub?: string;
};

export type ComputeAvailabilityReqUserGroup0Dto = {
    [key: string]: unknown;
};

export type ComputeAvailabilityReqUserGroup1Dto = {
    [key: string]: unknown;
};

export type ComputeAvailabilityReqSource0Dto = {
    type: 'direct';
    name?: DirectSource;
};

export type ComputeAvailabilityReqSource1Dto = {
    type: 'referral';
    member_id?: string;
    reference?:
        | ComputeAvailabilityReqSource1Reference0Dto
        | ComputeAvailabilityReqSource1Reference1Dto;
};

export type ComputeAvailabilityReqSource1Reference0Dto = {
    id: string;
    type: 'ota';
    name: OtaName;
};

export type ComputeAvailabilityReqSource1Reference1Dto = {
    [key: string]: unknown;
};

export type ComputeAvailabilityReqProductsItemDto = {
    type?: ProductType;
    id?: string;
    name?: string;
    variant_id?: string;
    timestamps?: Array<number>;
    description?: string;
    options?: Array<ComputeAvailabilityReqProductsItemOptionsItemDto>;
    capacity?: ComputeAvailabilityReqProductsItemCapacityDto;
    schedule?: ComputeAvailabilityReqProductsItemScheduleDto;
};

export type ComputeAvailabilityReqProductsItemOptionsItemDto = {
    type?: ProductOptionType;
    id: string;
    name?: string;
    pax?: PaxData;
};

export type ComputeAvailabilityReqProductsItemCapacityDto = {
    items: Array<string>;
};

export type ComputeAvailabilityReqProductsItemScheduleDto = {
    items: Array<string>;
};

export type ComputeAvailabilityReqEventsItemDto = {
    type?: ProductType;
    id: string;
    date?: PeriodData;
    exclude?: boolean;
};

export type GetProductsResDto = {
    items?: Array<
        GetProductsResItem0Dto | GetProductsResItem1Dto | GetProductsResItem2Dto
    >;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetProductsResItem0Dto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'tour';
    active: boolean;
    configuration: GetProductsResItem0ConfigurationDto;
    capacity: GetProductsResItem0CapacityDto;
    schedule: GetProductsResItem0ScheduleDto;
    resolved_schedules?: Array<GetProductsResItem0ResolvedSchedulesItemDto>;
    pricing?: GetProductsResItem0PricingDto;
    options?: GetProductsResItem0OptionsDto;
    access: GetProductsResItem0AccessDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    policies?: GetProductsResItem0PoliciesDto;
    route: GetProductsResItem0RouteDto;
    languages: Array<Language>;
};

export type GetProductsResItem0ConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductsResItem0ConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type GetProductsResItem0ConfigurationCutoffDto = {
    items?: Array<GetProductsResItem0ConfigurationCutoffItemDto>;
};

export type GetProductsResItem0ConfigurationCutoffItemDto = {
    id: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type GetProductsResItem0CapacityDto = {
    items: Array<GetProductsResItem0CapacityItemDto>;
};

export type GetProductsResItem0CapacityItemDto = {
    id: string;
    reference: GetProductsResItem0CapacityItemReferenceDto;
};

export type GetProductsResItem0CapacityItemReferenceDto = {
    type: CapacityType;
    id: string;
    name: string;
};

export type GetProductsResItem0ScheduleDto = {
    items: Array<GetProductsResItem0ScheduleItemDto>;
};

export type GetProductsResItem0ScheduleItemDto = {
    id: string;
    duration: GetProductsResItem0ScheduleItemDurationDto;
    reference: GetProductsResItem0ScheduleItemReferenceDto;
};

export type GetProductsResItem0ScheduleItemDurationDto = {
    variable: boolean;
    estimated: TimeOffset;
    deviation?: TimeOffset;
};

export type GetProductsResItem0ScheduleItemReferenceDto = {
    type: ScheduleType;
    id: string;
    name: string;
};

export type GetProductsResItem0ResolvedSchedulesItemDto = {
    type: ScheduleType;
    name: string;
    timezone: TimezoneData;
    start_times?: Array<TimeOffset>;
    any_time?: boolean;
    recurrence?:
        | MonthlyRecurrenceData
        | WeeklyRecurrenceData
        | YearlyRecurrenceData;
    dates: Array<DatePeriodData>;
    access: GetProductsResItem0ResolvedSchedulesItemAccessDto;
};

export type GetProductsResItem0ResolvedSchedulesItemAccessDto = {
    permissions: SchedulePermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessScheduleViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetProductsResItem0PricingDto = {
    items: Array<GetProductsResItem0PricingItemDto>;
    payment_requirements: PaymentRequirementsData;
};

export type GetProductsResItem0PricingItemDto = {
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: GetProductsResItem0PricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type GetProductsResItem0PricingItemDependenciesDto = {
    capacity?: GetProductsResItem0CapacityItemReferenceDto;
    schedule?: GetProductsResItem0ScheduleItemReferenceDto;
    source?:
        | GetProductsResItem0PricingItemDependenciesSource0Dto
        | GetProductsResItem0PricingItemDependenciesSource1Dto;
};

export type GetProductsResItem0PricingItemDependenciesSource0Dto = {
    type: 'direct';
    name: DirectSource;
};

export type GetProductsResItem0PricingItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
    reference:
        | GetTeamsResItemMembersItem1ReferenceDto
        | GetTeamsResItemMembersItem0ReferenceDto;
};

export type GetProductsResItem0OptionsDto = {
    items: Array<GetProductsResItem0OptionsItemDto>;
};

export type GetProductsResItem0OptionsItemDto = {
    id: string;
    references?: Array<
        | ActionByApplicationDto
        | GetProductsResItem0OptionsItemReferencesItem1Dto
    >;
    type: ProductOptionType;
    name: string;
    description: string;
    pricing?: GetProductsResItem0PricingDto;
    mandatory?: boolean;
};

export type GetProductsResItem0OptionsItemReferencesItem1Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type GetProductsResItem0AccessDto = {
    permissions: ProductPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessProductViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetProductsResItem0AttachmentsDto = {
    items: Array<GetProductsResItem0AttachmentsItemDto>;
};

export type GetProductsResItem0AttachmentsItemDto = {
    id: string;
    reference:
        | GetProductsResItem0AttachmentsItemReference0Dto
        | GetProductsResItem0AttachmentsItemReference1Dto;
};

export type GetProductsResItem0AttachmentsItemReference0Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id: string;
    width: number;
    height: number;
};

export type GetProductsResItem0AttachmentsItemReference1Dto = {
    resource_type: 'file';
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    id: string;
};

export type GetProductsResItem0PoliciesDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type GetProductsResItem0RouteDto = {
    items: Array<GetProductsResItem0RouteItemDto>;
    round_trip: boolean;
    distance?: GetProductsResItem0RouteDistanceDto;
    destination?: LocationDataModel;
};

export type GetProductsResItem0RouteItemDto = {
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: GetProductsResItem0RouteItemScheduleDto;
    pinned: boolean;
};

export type GetProductsResItem0RouteItemScheduleDto = {
    arrival_offset: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
    auto?: boolean;
};

export type GetProductsResItem0RouteDistanceDto = {
    km: number;
    mi: number;
};

export type GetProductsResItem1Dto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'transfer';
    active: boolean;
    configuration: GetProductsResItem0ConfigurationDto;
    capacity: GetProductsResItem0CapacityDto;
    schedule: GetProductsResItem0ScheduleDto;
    resolved_schedules?: Array<GetProductsResItem0ResolvedSchedulesItemDto>;
    pricing?: GetProductsResItem0PricingDto;
    options?: GetProductsResItem0OptionsDto;
    access: GetProductsResItem0AccessDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    policies?: GetProductsResItem0PoliciesDto;
    route: GetProductsResItem0RouteDto;
};

export type GetProductsResItem2Dto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'dynamic_package';
    attachments?: GetProductsResItem0AttachmentsDto;
    discount?: DiscountData;
    active: boolean;
    options?: GetProductsResItem0OptionsDto;
    access: GetProductsResItem0AccessDto;
    policies?: GetProductsResItem0PoliciesDto;
    products: Array<GetProductsResItem2ProductsItemDto>;
};

export type GetProductsResItem2ProductsItemDto = {
    day_index: number;
    offset_days: number;
    items: Array<GetProductsResItem2ProductsItemItemDto>;
};

export type GetProductsResItem2ProductsItemItemDto = {
    id: string;
    ref: GetProductsResItem0OptionsItemReferencesItem1Dto;
    order_index: number;
    start_time: TimeOffset;
    buffer_minutes: number;
    pricing?: GetProductsResItem0PricingDto;
    route?: GetProductsResItem0RouteDto;
    schedule?: GetProductsResItem0ScheduleDto;
};

export type CreateProductReqDto = {
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'tour';
    active?: boolean;
    configuration?: CreateProductReqConfigurationDto;
    capacity: CreateProductReqCapacityDto;
    schedule: CreateProductReqScheduleDto;
    pricing?: CreateProductReqPricingDto;
    options?: CreateProductReqOptionsDto;
    access?: CreateProductReqAccessDto;
    attachments?: CreateProductReqAttachmentsDto;
    policies?: CreateProductReqPoliciesDto;
    route: CreateProductReqRouteDto;
    languages: Array<Language>;
};

export type CreateProductReqConfigurationDto = {
    shared?: boolean;
    autoscaled?: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: CreateProductReqConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium?: TransportationMedium;
};

export type CreateProductReqConfigurationCutoffDto = {
    items?: Array<CreateProductReqConfigurationCutoffItemDto>;
};

export type CreateProductReqConfigurationCutoffItemDto = {
    action?: ListItemAction;
    id: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type CreateProductReqCapacityDto = {
    items: Array<CreateProductReqCapacityItemDto>;
};

export type CreateProductReqCapacityItemDto = {
    action?: ListItemAction;
    id: string;
    reference: CreateProductReqCapacityItemReferenceDto;
};

export type CreateProductReqCapacityItemReferenceDto = {
    type: CapacityType;
    id?: string;
    name: string;
};

export type CreateProductReqScheduleDto = {
    items: Array<CreateProductReqScheduleItemDto>;
};

export type CreateProductReqScheduleItemDto = {
    action?: ListItemAction;
    id: string;
    duration: CreateProductReqScheduleItemDurationDto;
    reference: CreateProductReqScheduleItemReferenceDto;
};

export type CreateProductReqScheduleItemDurationDto = {
    variable?: boolean;
    estimated: TimeOffset;
    deviation?: TimeOffset;
};

export type CreateProductReqScheduleItemReferenceDto = {
    type: ScheduleType;
    id?: string;
    name: string;
};

export type CreateProductReqPricingDto = {
    items: Array<CreateProductReqPricingItemDto>;
    payment_requirements: PaymentRequirementsData;
};

export type CreateProductReqPricingItemDto = {
    action?: ListItemAction;
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: CreateProductReqPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type CreateProductReqPricingItemDependenciesDto = {
    capacity?: CreateProductReqCapacityItemReferenceDto;
    schedule?: CreateProductReqScheduleItemReferenceDto;
    source?:
        | CreateProductReqPricingItemDependenciesSource0Dto
        | CreateProductReqPricingItemDependenciesSource1Dto;
};

export type CreateProductReqPricingItemDependenciesSource0Dto = {
    type: 'direct';
    name: DirectSource;
};

export type CreateProductReqPricingItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
};

export type CreateProductReqOptionsDto = {
    items: Array<CreateProductReqOptionsItemDto>;
};

export type CreateProductReqOptionsItemDto = {
    action?: ListItemAction;
    id: string;
    references?: Array<
        | CreateProductReqOptionsItemReferencesItem0Dto
        | CreateProductReqOptionsItemReferencesItem1Dto
    >;
    type: ProductOptionType;
    name: string;
    description: string;
    pricing?: CreateProductReqPricingDto;
    mandatory?: boolean;
};

export type CreateProductReqOptionsItemReferencesItem0Dto = {
    type: 'human';
    id?: string;
    name: PersonNameData;
};

export type CreateProductReqOptionsItemReferencesItem1Dto = {
    type: ProductType;
    id?: string;
    name: string;
};

export type CreateProductReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateProductReqAttachmentsDto = {
    items?: Array<CreateProductReqAttachmentsItemDto>;
};

export type CreateProductReqAttachmentsItemDto = {
    action?: ListItemAction;
    id: string;
    reference?:
        | CreateProductReqAttachmentsItemReference0Dto
        | CreateProductReqAttachmentsItemReference1Dto;
};

export type CreateProductReqAttachmentsItemReference0Dto = {
    type?: FileType;
    content_type?: ContentType;
    b64_encoded?: boolean;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    content: string;
    id?: string;
    width?: number;
    height?: number;
};

export type CreateProductReqAttachmentsItemReference1Dto = {
    type?: FileType;
    content_type?: ContentType;
    b64_encoded?: boolean;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    content: string;
    id?: string;
};

export type CreateProductReqPoliciesDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type CreateProductReqRouteDto = {
    items: Array<CreateProductReqRouteItemDto>;
    round_trip?: boolean;
    distance?: CreateProductReqRouteDistanceDto;
    destination?: LocationDataModel;
};

export type CreateProductReqRouteItemDto = {
    action?: ListItemAction;
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: CreateProductReqRouteItemScheduleDto;
    pinned?: boolean;
};

export type CreateProductReqRouteItemScheduleDto = {
    arrival_offset: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
};

export type CreateProductReqRouteDistanceDto = {
    km?: number;
    mi?: number;
};

export type CreateProductReq1Dto = {
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'transfer';
    active?: boolean;
    configuration?: CreateProductReqConfigurationDto;
    capacity: CreateProductReqCapacityDto;
    schedule: CreateProductReqScheduleDto;
    pricing?: CreateProductReqPricingDto;
    options?: CreateProductReqOptionsDto;
    access?: CreateProductReqAccessDto;
    attachments?: CreateProductReqAttachmentsDto;
    policies?: CreateProductReqPoliciesDto;
    route: CreateProductReqRouteDto;
};

export type CreateProductReq2Dto = {
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'dynamic_package';
    attachments?: CreateProductReqAttachmentsDto;
    discount?: DiscountData;
    active?: boolean;
    options?: CreateProductReqOptionsDto;
    access?: CreateProductReqAccessDto;
    policies?: CreateProductReqPoliciesDto;
    products: Array<CreateProductReqProductsItemDto>;
};

export type CreateProductReqProductsItemDto = {
    day_index: number;
    offset_days: number;
    items: Array<CreateProductReqProductsItemItemDto>;
};

export type CreateProductReqProductsItemItemDto = {
    action?: ListItemAction;
    id: string;
    ref: CreateProductReqOptionsItemReferencesItem1Dto;
    order_index: number;
    start_time: TimeOffset;
    buffer_minutes?: number;
};

export type CreateProductResDto = {
    resource_type: 'product';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'tour';
    active: boolean;
    configuration: CreateProductResConfigurationDto;
    capacity: CreateProductResCapacityDto;
    schedule: CreateProductResScheduleDto;
    pricing?: CreateProductResPricingDto;
    options?: CreateProductResOptionsDto;
    access: CreateProductResAccessDto;
    attachments?: CreateProductResAttachmentsDto;
    policies?: CreateProductResPoliciesDto;
    route: CreateProductResRouteDto;
    languages: Array<Language>;
};

export type CreateProductResConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use: boolean;
    open_hours?: boolean;
    cutoff?: CreateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type CreateProductResConfigurationCutoffDto = {
    items?: Array<CreateProductResConfigurationCutoffItemDto>;
};

export type CreateProductResConfigurationCutoffItemDto = {
    action?: ListItemAction;
    id: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type CreateProductResCapacityDto = {
    items: Array<CreateProductResCapacityItemDto>;
};

export type CreateProductResCapacityItemDto = {
    action?: ListItemAction;
    id: string;
    reference: CreateProductResCapacityItemReferenceDto;
};

export type CreateProductResCapacityItemReferenceDto = {
    type: CapacityType;
    id: string;
    name: string;
};

export type CreateProductResScheduleDto = {
    items: Array<CreateProductResScheduleItemDto>;
};

export type CreateProductResScheduleItemDto = {
    action?: ListItemAction;
    id: string;
    duration: CreateProductResScheduleItemDurationDto;
    reference: CreateProductResScheduleItemReferenceDto;
};

export type CreateProductResScheduleItemDurationDto = {
    variable: boolean;
    estimated: TimeOffset;
    deviation?: TimeOffset;
};

export type CreateProductResScheduleItemReferenceDto = {
    type: ScheduleType;
    id: string;
    name: string;
};

export type CreateProductResPricingDto = {
    items: Array<CreateProductResPricingItemDto>;
    payment_requirements: PaymentRequirementsData;
};

export type CreateProductResPricingItemDto = {
    action?: ListItemAction;
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: CreateProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type CreateProductResPricingItemDependenciesDto = {
    capacity?: CreateProductResCapacityItemReferenceDto;
    schedule?: CreateProductResScheduleItemReferenceDto;
    source?:
        | CreateProductResPricingItemDependenciesSource0Dto
        | CreateProductResPricingItemDependenciesSource1Dto;
};

export type CreateProductResPricingItemDependenciesSource0Dto = {
    type: 'direct';
    name: DirectSource;
};

export type CreateProductResPricingItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
    reference:
        | CreateTeamResMembersItem1ReferenceDto
        | CreateTeamResMembersItem0ReferenceDto;
};

export type CreateProductResOptionsDto = {
    items: Array<CreateProductResOptionsItemDto>;
};

export type CreateProductResOptionsItemDto = {
    action?: ListItemAction;
    id: string;
    references?: Array<
        ActionByApplicationDto | CreateProductResOptionsItemReferencesItem1Dto
    >;
    type: ProductOptionType;
    name: string;
    description: string;
    pricing?: CreateProductResPricingDto;
    mandatory?: boolean;
};

export type CreateProductResOptionsItemReferencesItem1Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type CreateProductResAccessDto = {
    permissions: ProductPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessProductViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type CreateProductResAttachmentsDto = {
    items: Array<CreateProductResAttachmentsItemDto>;
};

export type CreateProductResAttachmentsItemDto = {
    action?: ListItemAction;
    id: string;
    reference:
        | CreateProductResAttachmentsItemReference0Dto
        | CreateProductResAttachmentsItemReference1Dto;
};

export type CreateProductResAttachmentsItemReference0Dto = {
    resource_type: 'file';
    type?: FileType;
    content_type?: ContentType;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    url?: string;
    id?: string;
    width?: number;
    height?: number;
};

export type CreateProductResAttachmentsItemReference1Dto = {
    resource_type: 'file';
    type?: FileType;
    content_type?: ContentType;
    name?: string;
    path?: string;
    size?: number;
    checksum?: string;
    url?: string;
    id?: string;
};

export type CreateProductResPoliciesDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type CreateProductResRouteDto = {
    items: Array<CreateProductResRouteItemDto>;
    round_trip: boolean;
    distance?: CreateProductResRouteDistanceDto;
    destination?: LocationDataModel;
};

export type CreateProductResRouteItemDto = {
    action?: ListItemAction;
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: CreateProductResRouteItemScheduleDto;
    pinned: boolean;
};

export type CreateProductResRouteItemScheduleDto = {
    arrival_offset: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
    auto?: boolean;
};

export type CreateProductResRouteDistanceDto = {
    km: number;
    mi: number;
};

export type CreateProductRes1Dto = {
    resource_type: 'product';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'transfer';
    active: boolean;
    configuration: CreateProductResConfigurationDto;
    capacity: CreateProductResCapacityDto;
    schedule: CreateProductResScheduleDto;
    pricing?: CreateProductResPricingDto;
    options?: CreateProductResOptionsDto;
    access: CreateProductResAccessDto;
    attachments?: CreateProductResAttachmentsDto;
    policies?: CreateProductResPoliciesDto;
    route: CreateProductResRouteDto;
};

export type CreateProductRes2Dto = {
    resource_type: 'product';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'dynamic_package';
    attachments?: CreateProductResAttachmentsDto;
    discount?: DiscountData;
    active: boolean;
    options?: CreateProductResOptionsDto;
    access: CreateProductResAccessDto;
    policies?: CreateProductResPoliciesDto;
    products: Array<CreateProductRes2ProductsItemDto>;
};

export type CreateProductRes2ProductsItemDto = {
    day_index: number;
    offset_days: number;
    items: Array<CreateProductRes2ProductsItemItemDto>;
};

export type CreateProductRes2ProductsItemItemDto = {
    action?: ListItemAction;
    id: string;
    ref: CreateProductResOptionsItemReferencesItem1Dto;
    order_index: number;
    start_time: TimeOffset;
    buffer_minutes: number;
};

export type GetProductFittingCapacitiesResDto = {
    items?: Array<GetProductFittingCapacitiesResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetProductFittingCapacitiesResItemDto = {
    resource_type: 'capacity';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: CapacityType;
    name: string;
    limit: AgebandCapacityData | FlatCapacityData;
    access: GetProductFittingCapacitiesResItemAccessDto;
};

export type GetProductFittingCapacitiesResItemAccessDto = {
    permissions: CapacityPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessCapacityViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetReportsResDto = {
    items?: Array<GetReportsResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetReportsResItemDto = {
    resource_type: 'report';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    report_type: ReportType;
    status: ReportStatus;
    file_reference?: GetProductsResItem0AttachmentsItemReference1Dto;
    access: GetReportsResItemAccessDto;
};

export type GetReportsResItemAccessDto = {
    permissions: ReportPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessReportViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetReportResDto = {
    resource_type: 'report';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    report_type: ReportType;
    status: ReportStatus;
    file_reference?: GetUserResProfileAttachmentsItemReference1Dto;
    access: GetReportResAccessDto;
};

export type GetReportResAccessDto = {
    permissions: ReportPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessReportViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type UpdateProductReqDto = {
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'tour';
    languages: Array<Language>;
};

export type UpdateProductReq1Dto = {
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'transfer';
};

export type UpdateProductReq2Dto = {
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'dynamic_package';
};

export type UpdateProductResDto = {
    resource_type?: 'product';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'tour';
    active?: boolean;
    configuration?: UpdateProductResConfigurationDto;
    capacity?: UpdateProductResCapacityDto;
    schedule?: UpdateProductResScheduleDto;
    pricing?: UpdateProductResPricingDto;
    options?: UpdateProductResOptionsDto;
    access?: UpdateProductResAccessDto;
    attachments?: UpdateUserResProfileAttachmentsDto;
    policies?: UpdateProductResPoliciesDto;
    route?: UpdateProductResRouteDto;
    languages: Array<Language>;
};

export type UpdateProductResConfigurationDto = {
    shared?: boolean;
    autoscaled?: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: UpdateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium?: TransportationMedium;
};

export type UpdateProductResConfigurationCutoffDto = {
    items?: Array<UpdateProductResConfigurationCutoffItemDto>;
};

export type UpdateProductResConfigurationCutoffItemDto = {
    id: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type UpdateProductResCapacityDto = {
    items?: Array<UpdateProductResCapacityItemDto>;
};

export type UpdateProductResCapacityItemDto = {
    id: string;
    reference?: UpdateProductResCapacityItemReferenceDto;
};

export type UpdateProductResCapacityItemReferenceDto = {
    type?: CapacityType;
    id?: string;
    name?: string;
};

export type UpdateProductResScheduleDto = {
    items?: Array<UpdateProductResScheduleItemDto>;
};

export type UpdateProductResScheduleItemDto = {
    id: string;
    duration?: UpdateProductResScheduleItemDurationDto;
    reference?: UpdateProductResScheduleItemReferenceDto;
};

export type UpdateProductResScheduleItemDurationDto = {
    variable?: boolean;
    estimated?: TimeOffset;
    deviation?: TimeOffset;
};

export type UpdateProductResScheduleItemReferenceDto = {
    type?: ScheduleType;
    id?: string;
    name?: string;
};

export type UpdateProductResPricingDto = {
    items?: Array<UpdateProductResPricingItemDto>;
    payment_requirements?: PaymentRequirementsData;
};

export type UpdateProductResPricingItemDto = {
    id: string;
    type?: PricingType;
    currency?: Currency;
    dependencies?: UpdateProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price?: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type UpdateProductResPricingItemDependenciesDto = {
    capacity?: UpdateProductResCapacityItemReferenceDto;
    schedule?: UpdateProductResScheduleItemReferenceDto;
    source?:
        | UpdateProductResPricingItemDependenciesSource0Dto
        | UpdateProductResPricingItemDependenciesSource1Dto;
};

export type UpdateProductResPricingItemDependenciesSource0Dto = {
    type?: 'direct';
    name?: DirectSource;
};

export type UpdateProductResPricingItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
    reference:
        | UpdateMembersTeamsResMembersItem1ReferenceDto
        | UpdateMembersTeamsResMembersItem0ReferenceDto;
};

export type UpdateProductResOptionsDto = {
    items?: Array<UpdateProductResOptionsItemDto>;
};

export type UpdateProductResOptionsItemDto = {
    id: string;
    references?: Array<
        ActionByApplicationDto | UpdateProductResOptionsItemReferencesItem1Dto
    >;
    type?: ProductOptionType;
    name?: string;
    description?: string;
    pricing?: UpdateProductResPricingDto;
    mandatory?: boolean;
};

export type UpdateProductResOptionsItemReferencesItem1Dto = {
    type?: ProductType;
    id?: string;
    name?: string;
};

export type UpdateProductResAccessDto = {
    permissions: ProductPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessProductViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type UpdateProductResPoliciesDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type UpdateProductResRouteDto = {
    items?: Array<UpdateProductResRouteItemDto>;
    round_trip?: boolean;
    distance?: UpdateProductResRouteDistanceDto;
    destination?: LocationDataModel;
};

export type UpdateProductResRouteItemDto = {
    id: string;
    type?: RouteItemType;
    location?: LocationDataModel;
    schedule?: UpdateProductResRouteItemScheduleDto;
    pinned?: boolean;
};

export type UpdateProductResRouteItemScheduleDto = {
    arrival_offset?: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
    auto?: boolean;
};

export type UpdateProductResRouteDistanceDto = {
    km: number;
    mi: number;
};

export type UpdateProductRes1Dto = {
    resource_type?: 'product';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'transfer';
    active?: boolean;
    configuration?: UpdateProductResConfigurationDto;
    capacity?: UpdateProductResCapacityDto;
    schedule?: UpdateProductResScheduleDto;
    pricing?: UpdateProductResPricingDto;
    options?: UpdateProductResOptionsDto;
    access?: UpdateProductResAccessDto;
    attachments?: UpdateUserResProfileAttachmentsDto;
    policies?: UpdateProductResPoliciesDto;
    route?: UpdateProductResRouteDto;
};

export type UpdateProductRes2Dto = {
    resource_type?: 'product';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name?: string;
    description?: string;
    tags?: Array<ProductTag>;
    type?: 'dynamic_package';
    attachments?: UpdateUserResProfileAttachmentsDto;
    discount?: DiscountData;
    active?: boolean;
    options?: UpdateProductResOptionsDto;
    access?: UpdateProductResAccessDto;
    policies?: UpdateProductResPoliciesDto;
    products?: Array<UpdateProductRes2ProductsItemDto>;
};

export type UpdateProductRes2ProductsItemDto = {
    day_index?: number;
    offset_days?: number;
    items?: Array<UpdateProductRes2ProductsItemItemDto>;
};

export type UpdateProductRes2ProductsItemItemDto = {
    id: string;
    ref?: UpdateProductResOptionsItemReferencesItem1Dto;
    order_index?: number;
    start_time?: TimeOffset;
    buffer_minutes?: number;
};

export type UpdatePackageDiscountReqDto = {
    type: DiscountType;
    amount: number;
};

export type UpdateProductRoutesReqDto = {
    items?: Array<UpdateProductRoutesReqItemDto>;
    round_trip?: boolean;
    distance?: UpdateProductRoutesReqDistanceDto;
    destination?: LocationDataModel;
};

export type UpdateProductRoutesReqItemDto = {
    action: ListItemAction;
    id?: string;
    type?: RouteItemType;
    location?: LocationDataModel;
    schedule?: UpdateProductRoutesReqItemScheduleDto;
    pinned?: boolean;
};

export type UpdateProductRoutesReqItemScheduleDto = {
    arrival_offset?: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
};

export type UpdateProductRoutesReqDistanceDto = {
    km: number;
    mi: number;
};

export type UpdateProductRoutesReq1Dto = {
    items?: Array<UpdateProductRoutesReqItemDto>;
    round_trip?: boolean;
    distance?: UpdateProductRoutesReqDistanceDto;
    destination?: LocationDataModel;
};

export type UpdateProductCapacitiesReqDto = {
    items?: Array<UpdateProductCapacitiesReqItemDto>;
};

export type UpdateProductCapacitiesReqItemDto = {
    action: ListItemAction;
    id?: string;
    reference?: UpdateProductCapacitiesReqItemReferenceDto;
};

export type UpdateProductCapacitiesReqItemReferenceDto = {
    type?: CapacityType;
    id?: string;
    name?: string;
};

export type UpdateProductScheduleReqDto = {
    items?: Array<UpdateProductScheduleReqItemDto>;
};

export type UpdateProductScheduleReqItemDto = {
    action: ListItemAction;
    id?: string;
    duration?: UpdateProductScheduleReqItemDurationDto;
    reference?: UpdateProductScheduleReqItemReferenceDto;
};

export type UpdateProductScheduleReqItemDurationDto = {
    variable?: boolean;
    estimated?: TimeOffset;
    deviation?: TimeOffset;
};

export type UpdateProductScheduleReqItemReferenceDto = {
    type?: ScheduleType;
    id?: string;
    name?: string;
};

export type UpdateProductPricingReqDto = {
    items?: Array<UpdateProductPricingReqItemDto>;
    payment_requirements?: PaymentRequirementsData;
};

export type UpdateProductPricingReqItemDto = {
    action: ListItemAction;
    id?: string;
    type?: PricingType;
    currency?: Currency;
    dependencies?: UpdateProductPricingReqItemDependenciesDto;
    cost?: DualCurrencyData;
    price?: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type UpdateProductPricingReqItemDependenciesDto = {
    capacity?: UpdateProductCapacitiesReqItemReferenceDto;
    schedule?: UpdateProductScheduleReqItemReferenceDto;
    source?:
        | UpdateProductPricingReqItemDependenciesSource0Dto
        | UpdateProductPricingReqItemDependenciesSource1Dto;
};

export type UpdateProductPricingReqItemDependenciesSource0Dto = {
    type?: 'direct';
    name?: DirectSource;
};

export type UpdateProductPricingReqItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
};

export type UpdateProductOptionsReqDto = {
    items?: Array<UpdateProductOptionsReqItemDto>;
};

export type UpdateProductOptionsReqItemDto = {
    action: ListItemAction;
    id?: string;
    references?: Array<
        | UpdateProductOptionsReqItemReferencesItem0Dto
        | UpdateProductOptionsReqItemReferencesItem1Dto
    >;
    type?: ProductOptionType;
    name?: string;
    description?: string;
    pricing?: UpdateProductPricingReqDto;
    mandatory?: boolean;
};

export type UpdateProductOptionsReqItemReferencesItem0Dto = {
    type?: 'human';
    id?: string;
    name?: PersonNameData;
};

export type UpdateProductOptionsReqItemReferencesItem1Dto = {
    id?: string;
};

export type UpdateProductConfigurationReqDto = {
    shared?: boolean;
    autoscaled?: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: UpdateProductConfigurationReqCutoffDto;
    sell_via_widget?: boolean;
};

export type UpdateProductConfigurationReqCutoffDto = {
    items?: Array<UpdateProductConfigurationReqCutoffItemDto>;
};

export type UpdateProductConfigurationReqCutoffItemDto = {
    action: ListItemAction;
    id?: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type GetProductResDto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'tour';
    active: boolean;
    configuration: GetProductResConfigurationDto;
    capacity: GetProductResCapacityDto;
    schedule: GetProductResScheduleDto;
    resolved_schedules?: Array<GetProductResResolvedSchedulesItemDto>;
    similar_products?: Array<GetProductResSimilarProductsItemDto>;
    pricing?: GetProductResPricingDto;
    options?: GetProductResOptionsDto;
    access: GetProductResAccessDto;
    attachments?: GetUserResProfileAttachmentsDto;
    policies?: GetProductResPoliciesDto;
    route: GetProductResRouteDto;
    languages: Array<Language>;
};

export type GetProductResConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type GetProductResConfigurationCutoffDto = {
    items?: Array<GetProductResConfigurationCutoffItemDto>;
};

export type GetProductResConfigurationCutoffItemDto = {
    id: string;
    threshold?: TimeOffset;
    start_time?: TimeOffset;
};

export type GetProductResCapacityDto = {
    items: Array<GetProductResCapacityItemDto>;
};

export type GetProductResCapacityItemDto = {
    id: string;
    reference: GetProductResCapacityItemReferenceDto;
};

export type GetProductResCapacityItemReferenceDto = {
    type: CapacityType;
    id: string;
    name: string;
};

export type GetProductResScheduleDto = {
    items: Array<GetProductResScheduleItemDto>;
};

export type GetProductResScheduleItemDto = {
    id: string;
    duration: GetProductResScheduleItemDurationDto;
    reference: GetProductResScheduleItemReferenceDto;
};

export type GetProductResScheduleItemDurationDto = {
    variable: boolean;
    estimated: TimeOffset;
    deviation?: TimeOffset;
};

export type GetProductResScheduleItemReferenceDto = {
    type: ScheduleType;
    id: string;
    name: string;
};

export type GetProductResResolvedSchedulesItemDto = {
    type: ScheduleType;
    name: string;
    timezone: TimezoneData;
    start_times?: Array<TimeOffset>;
    any_time?: boolean;
    recurrence?:
        | MonthlyRecurrenceData
        | WeeklyRecurrenceData
        | YearlyRecurrenceData;
    dates: Array<DatePeriodData>;
    access: GetProductResResolvedSchedulesItemAccessDto;
};

export type GetProductResResolvedSchedulesItemAccessDto = {
    permissions: SchedulePermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessScheduleViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetProductResSimilarProductsItemDto = {
    id: string;
    name: string;
    attachments?: GetUserResProfileAttachmentsDto;
};

export type GetProductResPricingDto = {
    items: Array<GetProductResPricingItemDto>;
    payment_requirements: PaymentRequirementsData;
};

export type GetProductResPricingItemDto = {
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: GetProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
};

export type GetProductResPricingItemDependenciesDto = {
    capacity?: GetProductResCapacityItemReferenceDto;
    schedule?: GetProductResScheduleItemReferenceDto;
    source?:
        | GetProductResPricingItemDependenciesSource0Dto
        | GetProductResPricingItemDependenciesSource1Dto;
};

export type GetProductResPricingItemDependenciesSource0Dto = {
    type: 'direct';
    name: DirectSource;
};

export type GetProductResPricingItemDependenciesSource1Dto = {
    type: 'referral';
    member_id?: string;
    reference:
        | GetTeamResMembersItem1ReferenceDto
        | GetTeamResMembersItem0ReferenceDto;
};

export type GetProductResOptionsDto = {
    items: Array<GetProductResOptionsItemDto>;
};

export type GetProductResOptionsItemDto = {
    id: string;
    references?: Array<
        ActionByApplicationDto | GetProductResOptionsItemReferencesItem1Dto
    >;
    type: ProductOptionType;
    name: string;
    description: string;
    pricing?: GetProductResPricingDto;
    mandatory?: boolean;
};

export type GetProductResOptionsItemReferencesItem1Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type GetProductResAccessDto = {
    permissions: ProductPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessProductViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetProductResPoliciesDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type GetProductResRouteDto = {
    items: Array<GetProductResRouteItemDto>;
    round_trip: boolean;
    distance?: GetProductResRouteDistanceDto;
    destination?: LocationDataModel;
};

export type GetProductResRouteItemDto = {
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: GetProductResRouteItemScheduleDto;
    pinned: boolean;
};

export type GetProductResRouteItemScheduleDto = {
    arrival_offset: TimeOffset;
    stop_duration?: TimeOffset;
    date?: PeriodData;
    auto?: boolean;
};

export type GetProductResRouteDistanceDto = {
    km: number;
    mi: number;
};

export type GetProductRes1Dto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'transfer';
    active: boolean;
    configuration: GetProductResConfigurationDto;
    capacity: GetProductResCapacityDto;
    schedule: GetProductResScheduleDto;
    resolved_schedules?: Array<GetProductResResolvedSchedulesItemDto>;
    similar_products?: Array<GetProductResSimilarProductsItemDto>;
    pricing?: GetProductResPricingDto;
    options?: GetProductResOptionsDto;
    access: GetProductResAccessDto;
    attachments?: GetUserResProfileAttachmentsDto;
    policies?: GetProductResPoliciesDto;
    route: GetProductResRouteDto;
};

export type GetProductRes2Dto = {
    resource_type: 'product';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    name: string;
    description: string;
    tags?: Array<ProductTag>;
    type: 'dynamic_package';
    attachments?: GetUserResProfileAttachmentsDto;
    discount?: DiscountData;
    active: boolean;
    options?: GetProductResOptionsDto;
    access: GetProductResAccessDto;
    policies?: GetProductResPoliciesDto;
    products: Array<GetProductRes2ProductsItemDto>;
};

export type GetProductRes2ProductsItemDto = {
    day_index: number;
    offset_days: number;
    items: Array<GetProductRes2ProductsItemItemDto>;
};

export type GetProductRes2ProductsItemItemDto = {
    id: string;
    ref: GetProductResOptionsItemReferencesItem1Dto;
    order_index: number;
    start_time: TimeOffset;
    buffer_minutes: number;
};

export type UpdateProductPoliciesReqDto = {
    items?: Array<ProductCancellationPolicy>;
};

export type GetOtaProductVariantsResDto = {
    items?: Array<
        GetOtaProductVariantsResItem0Dto | GetOtaProductVariantsResItem1Dto
    >;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetOtaProductVariantsResItem0Dto = {
    resource_type: 'product_variant';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    active: boolean;
    product:
        | GetOtaProductVariantsResItem0Product0Dto
        | GetOtaProductVariantsResItem0Product1Dto;
    capacity: GetProductsResItem0CapacityItemDto;
    options?: GetProductsResItem0OptionsDto;
    access: GetProductsResItem0AccessDto;
    integrations?: GetOtaProductVariantsResItem0IntegrationsDto;
};

export type GetOtaProductVariantsResItem0Product0Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type GetOtaProductVariantsResItem0Product1Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type GetOtaProductVariantsResItem0IntegrationsDto = {
    items?: Array<GetOtaProductVariantsResItem0IntegrationsItemDto>;
};

export type GetOtaProductVariantsResItem0IntegrationsItemDto = {
    id: string;
    name: OtaName;
};

export type GetOtaProductVariantsResItem1Dto = {
    resource_type: 'product_variant';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    active: boolean;
    product:
        | GetOtaProductVariantsResItem0Product0Dto
        | GetOtaProductVariantsResItem0Product1Dto;
    capacity: GetProductsResItem0CapacityItemDto;
    options?: GetProductsResItem0OptionsDto;
    access: GetProductsResItem0AccessDto;
    integrations?: GetOtaProductVariantsResItem0IntegrationsDto;
};

export type CreateProductVariantReqDto = {
    active?: boolean;
    product_id: string;
    capacity_option_id: string;
    product_option_ids?: Array<string>;
    access?: CreateProductReqAccessDto;
    integrations?: CreateProductVariantReqIntegrationsDto;
};

export type CreateProductVariantReqIntegrationsDto = {
    items?: Array<CreateProductVariantReqIntegrationsItemDto>;
};

export type CreateProductVariantReqIntegrationsItemDto = {
    action?: ListItemAction;
    id: string;
    name: OtaName;
};

export type CreateProductVariantReq1Dto = {
    active?: boolean;
    product_id: string;
    capacity_option_id: string;
    product_option_ids?: Array<string>;
    access?: CreateProductReqAccessDto;
    integrations?: CreateProductVariantReqIntegrationsDto;
};

export type CreateProductVariantResDto = {
    resource_type: 'product_variant';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    active: boolean;
    product:
        | CreateProductVariantResProduct0Dto
        | CreateProductVariantResProduct1Dto;
    capacity: CreateProductResCapacityItemDto;
    options?: CreateProductResOptionsDto;
    access: CreateProductResAccessDto;
    integrations?: CreateProductVariantResIntegrationsDto;
};

export type CreateProductVariantResProduct0Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type CreateProductVariantResProduct1Dto = {
    type: ProductType;
    id: string;
    name: string;
};

export type CreateProductVariantResIntegrationsDto = {
    items?: Array<CreateProductVariantResIntegrationsItemDto>;
};

export type CreateProductVariantResIntegrationsItemDto = {
    action?: ListItemAction;
    id: string;
    name: OtaName;
};

export type CreateProductVariantRes1Dto = {
    resource_type: 'product_variant';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    active: boolean;
    product:
        | CreateProductVariantResProduct0Dto
        | CreateProductVariantResProduct1Dto;
    capacity: CreateProductResCapacityItemDto;
    options?: CreateProductResOptionsDto;
    access: CreateProductResAccessDto;
    integrations?: CreateProductVariantResIntegrationsDto;
};

export type GetEventsResDto = {
    items?: Array<GetEventsResItem0Dto | GetEventsResItem1Dto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetEventsResItem0Dto = {
    resource_type: 'event';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    locked: boolean;
    product: GetEventsResItem0ProductDto;
    date: PeriodData;
    operations?: GetEventsResItem0OperationsDto;
    notes?: GetEventsResItem0NotesDto;
    status: EventStatus;
    access: GetEventsResItem0AccessDto;
    bookings: Array<
        GetEventsResItem0BookingsItem0Dto | GetEventsResItem0BookingsItem1Dto
    >;
};

export type GetEventsResItem0ProductDto = {
    type: ProductType;
    id: string;
    name: string;
    capacity: GetProductsResItem0CapacityItemDto;
    configuration: GetEventsResItem0ProductConfigurationDto;
};

export type GetEventsResItem0ProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductsResItem0ConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type GetEventsResItem0OperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<GetEventsResItem0OperationsProductOptionsItemDto>;
    route?: GetProductsResItem0RouteDto;
    staff?: GetEventsResItem0OperationsStaffDto;
    assets?: GetEventsResItem0OperationsAssetsDto;
};

export type GetEventsResItem0OperationsProductOptionsItemDto = {
    type: ProductOptionType;
    id: string;
    name: string;
    pax: PaxData;
};

export type GetEventsResItem0OperationsStaffDto = {
    items: Array<GetEventsResItem0OperationsStaffItemDto>;
};

export type GetEventsResItem0OperationsStaffItemDto = {
    id: string;
    reference?: GetTeamsResItemMembersItem0ReferenceDto;
    position: TourEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventsResItem0OperationsAssetsDto = {
    items?: Array<GetEventsResItem0OperationsAssetsItemDto>;
};

export type GetEventsResItem0OperationsAssetsItemDto = {
    id: string;
    type?: TourEventAssetType;
    reference?: GetEventsResItem0OperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventsResItem0OperationsAssetsItemReferenceDto = {
    type: string;
    id: string;
    assignee?: GetTeamsResItemMembersItem0Dto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    license_plate?: string;
    max_passengers: number;
    year?: number;
    engine_type?: VehicleEngineType;
};

export type GetEventsResItem0NotesDto = {
    items: Array<GetEventsResItem0NotesItemDto>;
};

export type GetEventsResItem0NotesItemDto = {
    id: string;
    visibility: NoteVisibility;
    content: string;
    by_staff?: boolean;
};

export type GetEventsResItem0AccessDto = {
    permissions: EventPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessEventViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetEventsResItem0BookingsItem0Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    source:
        | GetProductsResItem0PricingItemDependenciesSource0Dto
        | GetProductsResItem0PricingItemDependenciesSource1Dto;
    product: GetEventsResItem0BookingsItem0ProductDto;
    event?: GetEventsResItem0BookingsItem0EventDto;
    order: GetEventsResItem0BookingsItem0OrderDto;
    transactions?: GetEventsResItem0BookingsItem0TransactionsDto;
    financials: GetEventsResItem0BookingsItem0FinancialsDto;
    notes?: GetEventsResItem0NotesDto;
    status: BookingStatus;
    access: GetEventsResItem0BookingsItem0AccessDto;
    integration?:
        | GetEventsResItem0BookingsItem0Integration0Dto
        | GetEventsResItem0BookingsItem0Integration1Dto;
    package?: GetEventsResItem0BookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetEventsResItem0BookingsItem0ProductDto = {
    type: 'tour';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: GetEventsResItem0BookingsItem0ProductCustomersDto;
    pricing: GetEventsResItem0BookingsItem0ProductPricingDto;
    options?: GetEventsResItem0BookingsItem0ProductOptionsDto;
    configuration?: GetEventsResItem0BookingsItem0ProductConfigurationDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    policies?: GetProductsResItem0PoliciesDto;
};

export type GetEventsResItem0BookingsItem0ProductCustomersDto = {
    items: Array<GetEventsResItem0BookingsItem0ProductCustomersItemDto>;
    pax: PaxData;
};

export type GetEventsResItem0BookingsItem0ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: GetEventsResItem0BookingsItem0ProductCustomersItemPickupDto;
};

export type GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto = {
    type: 'person';
    id: string;
    contact_details?: GetTeamsResItemMembersItem0ReferenceContactDetailsDto;
    name: PersonNameData;
    languages?: Array<Language>;
    organization?: GetTeamsResItemMembersItem0ReferenceOrganizationDto;
};

export type GetEventsResItem0BookingsItem0ProductCustomersItemPickupDto = {
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: GetProductsResItem0RouteItemScheduleDto;
    pinned: boolean;
};

export type GetEventsResItem0BookingsItem0ProductPricingDto = {
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: GetProductsResItem0PricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
    payment_requirements: PaymentRequirementsData;
    discount?: DiscountData;
};

export type GetEventsResItem0BookingsItem0ProductOptionsDto = {
    items: Array<GetEventsResItem0BookingsItem0ProductOptionsItemDto>;
};

export type GetEventsResItem0BookingsItem0ProductOptionsItemDto = {
    type: ProductOptionType;
    id: string;
    name: string;
    description?: string;
    customers: GetEventsResItem0BookingsItem0ProductOptionsItemCustomersDto;
    pricing?: GetEventsResItem0BookingsItem0ProductPricingDto;
    sync_pricing?: boolean;
    mandatory?: boolean;
};

export type GetEventsResItem0BookingsItem0ProductOptionsItemCustomersDto = {
    items: Array<GetEventsResItem0BookingsItem0ProductOptionsItemCustomersItemDto>;
    pax: PaxData;
};

export type GetEventsResItem0BookingsItem0ProductOptionsItemCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
};

export type GetEventsResItem0BookingsItem0ProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductsResItem0ConfigurationCutoffDto;
    sell_via_widget?: boolean;
};

export type GetEventsResItem0BookingsItem0EventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
    operations?: GetEventsResItem0BookingsItem0EventOperationsDto;
};

export type GetEventsResItem0BookingsItem0EventOperationsDto = {
    route?: GetProductsResItem0RouteDto;
};

export type GetEventsResItem0BookingsItem0OrderDto = {
    id: string;
    number: string;
    customer: GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto;
};

export type GetEventsResItem0BookingsItem0TransactionsDto = {
    items: Array<GetEventsResItem0BookingsItem0TransactionsItemDto>;
    paid?: DualCurrencyData;
    refunded?: DualCurrencyData;
    waived?: DualCurrencyData;
};

export type GetEventsResItem0BookingsItem0TransactionsItemDto = {
    id: string;
    type: TransactionType;
    method: TransactionMethod;
    amount: DualCurrencyData;
    created: Action;
    discarded?: Action;
};

export type GetEventsResItem0BookingsItem0FinancialsDto = {
    cost?: DualCurrencyData;
    subtotal: DualCurrencyData;
    total: DualCurrencyData;
    debt: DualCurrencyData;
};

export type GetEventsResItem0BookingsItem0AccessDto = {
    permissions: BookingPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessBookingViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetEventsResItem0BookingsItem0Integration0Dto = {
    gygBookingReference: string;
    gygActivityReference?: string;
    reservationReference: string;
    bookingReference?: string;
    cancelledBookingReference?: string;
    tickets?: Array<GetEventsResItem0BookingsItem0Integration0TicketsItemDto>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type GetEventsResItem0BookingsItem0Integration0TicketsItemDto = {
    category?: BookingItemCategory;
    ticketCodeType?: string;
    ticketCode?: string;
};

export type GetEventsResItem0BookingsItem0Integration1Dto = {
    name: OtaName;
    metadata?: {
        [key: string]: unknown;
    };
    reference: string;
};

export type GetEventsResItem0BookingsItem0PackageDto = {
    group_id: string;
    package_product_id: string;
    day_index: number;
    order_index: number;
    discount?: {
        [key: string]: unknown;
    };
    policies?: GetProductsResItem0PoliciesDto;
};

export type GetEventsResItem0BookingsItem1Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    source:
        | GetProductsResItem0PricingItemDependenciesSource0Dto
        | GetProductsResItem0PricingItemDependenciesSource1Dto;
    product: GetEventsResItem0BookingsItem1ProductDto;
    event?: GetEventsResItem0BookingsItem1EventDto;
    order: GetEventsResItem0BookingsItem0OrderDto;
    transactions?: GetEventsResItem0BookingsItem0TransactionsDto;
    financials: GetEventsResItem0BookingsItem0FinancialsDto;
    notes?: GetEventsResItem0NotesDto;
    status: BookingStatus;
    access: GetEventsResItem0BookingsItem0AccessDto;
    integration?:
        | GetEventsResItem0BookingsItem0Integration0Dto
        | GetEventsResItem0BookingsItem0Integration1Dto;
    package?: GetEventsResItem0BookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetEventsResItem0BookingsItem1ProductDto = {
    type: 'transfer';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: GetEventsResItem0BookingsItem1ProductCustomersDto;
    pricing: GetEventsResItem0BookingsItem0ProductPricingDto;
    options?: GetEventsResItem0BookingsItem0ProductOptionsDto;
    configuration?: GetEventsResItem0BookingsItem0ProductConfigurationDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    policies?: GetProductsResItem0PoliciesDto;
};

export type GetEventsResItem0BookingsItem1ProductCustomersDto = {
    items: Array<GetEventsResItem0BookingsItem1ProductCustomersItemDto>;
    pax: PaxData;
};

export type GetEventsResItem0BookingsItem1ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: GetEventsResItem0BookingsItem0ProductCustomersItemPickupDto;
};

export type GetEventsResItem0BookingsItem1EventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
    operations?: GetEventsResItem0BookingsItem1EventOperationsDto;
};

export type GetEventsResItem0BookingsItem1EventOperationsDto = {
    route?: GetProductsResItem0RouteDto;
};

export type GetEventsResItem1Dto = {
    resource_type: 'event';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    locked: boolean;
    product: GetEventsResItem0ProductDto;
    date: PeriodData;
    operations: GetEventsResItem1OperationsDto;
    notes?: GetEventsResItem0NotesDto;
    status: EventStatus;
    access: GetEventsResItem0AccessDto;
    bookings: Array<
        GetEventsResItem0BookingsItem0Dto | GetEventsResItem0BookingsItem1Dto
    >;
};

export type GetEventsResItem1OperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<GetEventsResItem0OperationsProductOptionsItemDto>;
    route?: GetProductsResItem0RouteDto;
    staff?: GetEventsResItem1OperationsStaffDto;
    assets?: GetEventsResItem1OperationsAssetsDto;
};

export type GetEventsResItem1OperationsStaffDto = {
    items: Array<GetEventsResItem1OperationsStaffItemDto>;
};

export type GetEventsResItem1OperationsStaffItemDto = {
    id: string;
    reference?: GetTeamsResItemMembersItem0ReferenceDto;
    position: TransferEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventsResItem1OperationsAssetsDto = {
    items?: Array<GetEventsResItem1OperationsAssetsItemDto>;
};

export type GetEventsResItem1OperationsAssetsItemDto = {
    id: string;
    type?: TransferEventAssetType;
    reference?: GetEventsResItem0OperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type CreateEventReqDto = {
    product: CreateEventReqProductDto;
    date: PeriodData;
    notes?: CreateEventReqNotesDto;
    status?: EventStatus;
    access?: CreateEventReqAccessDto;
};

export type CreateEventReqProductDto = {
    id: string;
    capacity_id: string;
};

export type CreateEventReqNotesDto = {
    items: Array<CreateEventReqNotesItemDto>;
};

export type CreateEventReqNotesItemDto = {
    action?: ListItemAction;
    id: string;
    visibility?: NoteVisibility;
    content: string;
    by_staff?: boolean;
};

export type CreateEventReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateEventReq1Dto = {
    product: CreateEventReqProductDto;
    date: PeriodData;
    notes?: CreateEventReqNotesDto;
    status?: EventStatus;
    access?: CreateEventReqAccessDto;
};

export type CreateEventResDto = {
    resource_type: 'event';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    locked: boolean;
    product: CreateEventResProductDto;
    date: PeriodData;
    operations?: CreateEventResOperationsDto;
    notes?: CreateEventResNotesDto;
    status: EventStatus;
    access: CreateEventResAccessDto;
};

export type CreateEventResProductDto = {
    type: ProductType;
    id: string;
    name: string;
    capacity: CreateProductResCapacityItemDto;
    configuration: CreateEventResProductConfigurationDto;
};

export type CreateEventResProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use: boolean;
    open_hours?: boolean;
    cutoff?: CreateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type CreateEventResOperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<CreateEventResOperationsProductOptionsItemDto>;
    route?: CreateProductResRouteDto;
    staff?: CreateEventResOperationsStaffDto;
    assets?: CreateEventResOperationsAssetsDto;
};

export type CreateEventResOperationsProductOptionsItemDto = {
    id: string;
};

export type CreateEventResOperationsStaffDto = {
    items: Array<CreateEventResOperationsStaffItemDto>;
};

export type CreateEventResOperationsStaffItemDto = {
    action?: ListItemAction;
    id: string;
    reference?: CreateTeamResMembersItem0ReferenceDto;
    position: TourEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type CreateEventResOperationsAssetsDto = {
    items: Array<CreateEventResOperationsAssetsItemDto>;
};

export type CreateEventResOperationsAssetsItemDto = {
    action?: ListItemAction;
    id: string;
    type: TourEventAssetType;
    reference?: CreateEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type CreateEventResOperationsAssetsItemReferenceDto = {
    type: string;
    id: string;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    license_plate?: string;
    max_passengers: number;
    year?: number;
    engine_type?: VehicleEngineType;
};

export type CreateEventResNotesDto = {
    items: Array<CreateEventResNotesItemDto>;
};

export type CreateEventResNotesItemDto = {
    action?: ListItemAction;
    id: string;
    visibility: NoteVisibility;
    content: string;
    by_staff?: boolean;
};

export type CreateEventResAccessDto = {
    permissions: EventPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessEventViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type CreateEventRes1Dto = {
    resource_type: 'event';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    locked: boolean;
    product: CreateEventResProductDto;
    date: PeriodData;
    operations: CreateEventRes1OperationsDto;
    notes?: CreateEventResNotesDto;
    status: EventStatus;
    access: CreateEventResAccessDto;
};

export type CreateEventRes1OperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<CreateEventResOperationsProductOptionsItemDto>;
    route?: CreateProductResRouteDto;
    staff?: CreateEventRes1OperationsStaffDto;
    assets?: CreateEventRes1OperationsAssetsDto;
};

export type CreateEventRes1OperationsStaffDto = {
    items: Array<CreateEventRes1OperationsStaffItemDto>;
};

export type CreateEventRes1OperationsStaffItemDto = {
    action?: ListItemAction;
    id: string;
    reference?: CreateTeamResMembersItem0ReferenceDto;
    position: TransferEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type CreateEventRes1OperationsAssetsDto = {
    items: Array<CreateEventRes1OperationsAssetsItemDto>;
};

export type CreateEventRes1OperationsAssetsItemDto = {
    action?: ListItemAction;
    id: string;
    type: TransferEventAssetType;
    reference?: CreateEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventResDto = {
    resource_type: 'event';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    locked: boolean;
    product: GetEventResProductDto;
    date: PeriodData;
    operations?: GetEventResOperationsDto;
    notes?: GetEventResNotesDto;
    status: EventStatus;
    access: GetEventResAccessDto;
    bookings: Array<GetEventResBookingsItem0Dto | GetEventResBookingsItem1Dto>;
};

export type GetEventResProductDto = {
    type: ProductType;
    id: string;
    name: string;
    capacity: GetProductResCapacityItemDto;
    configuration: GetEventResProductConfigurationDto;
};

export type GetEventResProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type GetEventResOperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<GetEventResOperationsProductOptionsItemDto>;
    route?: GetProductResRouteDto;
    staff?: GetEventResOperationsStaffDto;
    assets?: GetEventResOperationsAssetsDto;
};

export type GetEventResOperationsProductOptionsItemDto = {
    type: ProductOptionType;
    id: string;
    name: string;
    pax: PaxData;
};

export type GetEventResOperationsStaffDto = {
    items: Array<GetEventResOperationsStaffItemDto>;
};

export type GetEventResOperationsStaffItemDto = {
    id: string;
    reference?: GetTeamResMembersItem0ReferenceDto;
    position: TourEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventResOperationsAssetsDto = {
    items?: Array<GetEventResOperationsAssetsItemDto>;
};

export type GetEventResOperationsAssetsItemDto = {
    id: string;
    type?: TourEventAssetType;
    reference?: GetEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventResOperationsAssetsItemReferenceDto = {
    type: string;
    id: string;
    assignee?: GetTeamResMembersItem0Dto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    license_plate?: string;
    max_passengers: number;
    year?: number;
    engine_type?: VehicleEngineType;
};

export type GetEventResNotesDto = {
    items: Array<GetEventResNotesItemDto>;
};

export type GetEventResNotesItemDto = {
    id: string;
    visibility: NoteVisibility;
    content: string;
    by_staff?: boolean;
};

export type GetEventResAccessDto = {
    permissions: EventPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessEventViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetEventResBookingsItem0Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source:
        | GetProductResPricingItemDependenciesSource0Dto
        | GetProductResPricingItemDependenciesSource1Dto;
    product: GetEventResBookingsItem0ProductDto;
    event?: GetEventResBookingsItem0EventDto;
    order: GetEventResBookingsItem0OrderDto;
    transactions?: GetEventResBookingsItem0TransactionsDto;
    financials: GetEventResBookingsItem0FinancialsDto;
    notes?: GetEventResNotesDto;
    status: BookingStatus;
    access: GetEventResBookingsItem0AccessDto;
    integration?:
        | GetEventResBookingsItem0Integration0Dto
        | GetEventResBookingsItem0Integration1Dto;
    package?: GetEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetEventResBookingsItem0ProductDto = {
    type: 'tour';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: GetEventResBookingsItem0ProductCustomersDto;
    pricing: GetEventResBookingsItem0ProductPricingDto;
    options?: GetEventResBookingsItem0ProductOptionsDto;
    configuration?: GetEventResBookingsItem0ProductConfigurationDto;
    attachments?: GetUserResProfileAttachmentsDto;
    policies?: GetProductResPoliciesDto;
};

export type GetEventResBookingsItem0ProductCustomersDto = {
    items: Array<GetEventResBookingsItem0ProductCustomersItemDto>;
    pax: PaxData;
};

export type GetEventResBookingsItem0ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: GetEventResBookingsItem0ProductCustomersItemPickupDto;
};

export type GetEventResBookingsItem0ProductCustomersItemReferenceDto = {
    type: 'person';
    id: string;
    contact_details?: GetUserResProfileContactDetailsDto;
    name: PersonNameData;
    languages?: Array<Language>;
    organization?: GetUserResProfileOrganizationDto;
};

export type GetEventResBookingsItem0ProductCustomersItemPickupDto = {
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: GetProductResRouteItemScheduleDto;
    pinned: boolean;
};

export type GetEventResBookingsItem0ProductPricingDto = {
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: GetProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
    payment_requirements: PaymentRequirementsData;
    discount?: DiscountData;
};

export type GetEventResBookingsItem0ProductOptionsDto = {
    items: Array<GetEventResBookingsItem0ProductOptionsItemDto>;
};

export type GetEventResBookingsItem0ProductOptionsItemDto = {
    type: ProductOptionType;
    id: string;
    name: string;
    description?: string;
    customers: GetEventResBookingsItem0ProductOptionsItemCustomersDto;
    pricing?: GetEventResBookingsItem0ProductPricingDto;
    sync_pricing?: boolean;
    mandatory?: boolean;
};

export type GetEventResBookingsItem0ProductOptionsItemCustomersDto = {
    items: Array<GetEventResBookingsItem0ProductOptionsItemCustomersItemDto>;
    pax: PaxData;
};

export type GetEventResBookingsItem0ProductOptionsItemCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
};

export type GetEventResBookingsItem0ProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: GetProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
};

export type GetEventResBookingsItem0EventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
    operations?: GetEventResBookingsItem0EventOperationsDto;
};

export type GetEventResBookingsItem0EventOperationsDto = {
    route?: GetProductResRouteDto;
};

export type GetEventResBookingsItem0OrderDto = {
    id: string;
    number: string;
    customer: GetEventResBookingsItem0ProductCustomersItemReferenceDto;
};

export type GetEventResBookingsItem0TransactionsDto = {
    items: Array<GetEventResBookingsItem0TransactionsItemDto>;
    paid?: DualCurrencyData;
    refunded?: DualCurrencyData;
    waived?: DualCurrencyData;
};

export type GetEventResBookingsItem0TransactionsItemDto = {
    id: string;
    type: TransactionType;
    method: TransactionMethod;
    amount: DualCurrencyData;
    created: Action;
    discarded?: Action;
};

export type GetEventResBookingsItem0FinancialsDto = {
    cost?: DualCurrencyData;
    subtotal: DualCurrencyData;
    total: DualCurrencyData;
    debt: DualCurrencyData;
};

export type GetEventResBookingsItem0AccessDto = {
    permissions: BookingPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessBookingViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetEventResBookingsItem0Integration0Dto = {
    gygBookingReference: string;
    gygActivityReference?: string;
    reservationReference: string;
    bookingReference?: string;
    cancelledBookingReference?: string;
    tickets?: Array<GetEventResBookingsItem0Integration0TicketsItemDto>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type GetEventResBookingsItem0Integration0TicketsItemDto = {
    category?: BookingItemCategory;
    ticketCodeType?: string;
    ticketCode?: string;
};

export type GetEventResBookingsItem0Integration1Dto = {
    name: OtaName;
    metadata?: {
        [key: string]: unknown;
    };
    reference: string;
};

export type GetEventResBookingsItem0PackageDto = {
    group_id: string;
    package_product_id: string;
    day_index: number;
    order_index: number;
    discount?: {
        [key: string]: unknown;
    };
    policies?: GetProductResPoliciesDto;
};

export type GetEventResBookingsItem1Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source:
        | GetProductResPricingItemDependenciesSource0Dto
        | GetProductResPricingItemDependenciesSource1Dto;
    product: GetEventResBookingsItem1ProductDto;
    event?: GetEventResBookingsItem1EventDto;
    order: GetEventResBookingsItem0OrderDto;
    transactions?: GetEventResBookingsItem0TransactionsDto;
    financials: GetEventResBookingsItem0FinancialsDto;
    notes?: GetEventResNotesDto;
    status: BookingStatus;
    access: GetEventResBookingsItem0AccessDto;
    integration?:
        | GetEventResBookingsItem0Integration0Dto
        | GetEventResBookingsItem0Integration1Dto;
    package?: GetEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetEventResBookingsItem1ProductDto = {
    type: 'transfer';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: GetEventResBookingsItem1ProductCustomersDto;
    pricing: GetEventResBookingsItem0ProductPricingDto;
    options?: GetEventResBookingsItem0ProductOptionsDto;
    configuration?: GetEventResBookingsItem0ProductConfigurationDto;
    attachments?: GetUserResProfileAttachmentsDto;
    policies?: GetProductResPoliciesDto;
};

export type GetEventResBookingsItem1ProductCustomersDto = {
    items: Array<GetEventResBookingsItem1ProductCustomersItemDto>;
    pax: PaxData;
};

export type GetEventResBookingsItem1ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference: GetEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: GetEventResBookingsItem0ProductCustomersItemPickupDto;
};

export type GetEventResBookingsItem1EventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
    operations?: GetEventResBookingsItem1EventOperationsDto;
};

export type GetEventResBookingsItem1EventOperationsDto = {
    route?: GetProductResRouteDto;
};

export type GetEventRes1Dto = {
    resource_type: 'event';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    locked: boolean;
    product: GetEventResProductDto;
    date: PeriodData;
    operations: GetEventRes1OperationsDto;
    notes?: GetEventResNotesDto;
    status: EventStatus;
    access: GetEventResAccessDto;
    bookings: Array<GetEventResBookingsItem0Dto | GetEventResBookingsItem1Dto>;
};

export type GetEventRes1OperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<GetEventResOperationsProductOptionsItemDto>;
    route?: GetProductResRouteDto;
    staff?: GetEventRes1OperationsStaffDto;
    assets?: GetEventRes1OperationsAssetsDto;
};

export type GetEventRes1OperationsStaffDto = {
    items: Array<GetEventRes1OperationsStaffItemDto>;
};

export type GetEventRes1OperationsStaffItemDto = {
    id: string;
    reference?: GetTeamResMembersItem0ReferenceDto;
    position: TransferEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type GetEventRes1OperationsAssetsDto = {
    items?: Array<GetEventRes1OperationsAssetsItemDto>;
};

export type GetEventRes1OperationsAssetsItemDto = {
    id: string;
    type?: TransferEventAssetType;
    reference?: GetEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type CancelEventReqDto = {
    message: string;
};

export type CancelEventResDto = {
    resource_type?: 'event';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    locked?: boolean;
    product?: CancelEventResProductDto;
    date?: PeriodData;
    operations?: CancelEventResOperationsDto;
    notes?: CancelEventResNotesDto;
    status: EventStatus;
    access?: CancelEventResAccessDto;
    bookings?: Array<
        CancelEventResBookingsItem0Dto | CancelEventResBookingsItem1Dto
    >;
};

export type CancelEventResProductDto = {
    type?: ProductType;
    id?: string;
    name?: string;
    capacity?: UpdateProductResCapacityItemDto;
    configuration?: CancelEventResProductConfigurationDto;
};

export type CancelEventResProductConfigurationDto = {
    shared: boolean;
    autoscaled?: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: UpdateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
    transportation_medium: TransportationMedium;
};

export type CancelEventResOperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<CancelEventResOperationsProductOptionsItemDto>;
    route?: UpdateProductResRouteDto;
    staff?: CancelEventResOperationsStaffDto;
    assets?: CancelEventResOperationsAssetsDto;
};

export type CancelEventResOperationsProductOptionsItemDto = {
    type: ProductOptionType;
    id?: string;
    name: string;
    pax: PaxData;
};

export type CancelEventResOperationsStaffDto = {
    items?: Array<CancelEventResOperationsStaffItemDto>;
};

export type CancelEventResOperationsStaffItemDto = {
    id: string;
    reference?: UpdateMembersTeamsResMembersItem0ReferenceDto;
    position?: TourEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type CancelEventResOperationsAssetsDto = {
    items?: Array<CancelEventResOperationsAssetsItemDto>;
};

export type CancelEventResOperationsAssetsItemDto = {
    id: string;
    type?: TourEventAssetType;
    reference?: CancelEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type CancelEventResOperationsAssetsItemReferenceDto = {
    type?: string;
    id?: string;
    vehicle_type?: VehicleType;
    make?: string;
    model?: string;
    license_plate?: string;
    max_passengers?: number;
    year?: number;
    engine_type?: VehicleEngineType;
};

export type CancelEventResNotesDto = {
    items?: Array<CancelEventResNotesItemDto>;
};

export type CancelEventResNotesItemDto = {
    id: string;
    visibility: NoteVisibility;
    content?: string;
    by_staff?: boolean;
};

export type CancelEventResAccessDto = {
    permissions: EventPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessEventViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type CancelEventResBookingsItem0Dto = {
    resource_type?: 'booking';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source?:
        | UpdateProductResPricingItemDependenciesSource0Dto
        | UpdateProductResPricingItemDependenciesSource1Dto;
    product?: CancelEventResBookingsItem0ProductDto;
    event?: CancelEventResBookingsItem0EventDto;
    order: CancelEventResBookingsItem0OrderDto;
    transactions?: CancelEventResBookingsItem0TransactionsDto;
    financials?: CancelEventResBookingsItem0FinancialsDto;
    notes?: CancelEventResNotesDto;
    status: BookingStatus;
    access?: CancelEventResBookingsItem0AccessDto;
    integration?:
        | CancelEventResBookingsItem0Integration0Dto
        | CancelEventResBookingsItem0Integration1Dto;
    package?: CancelEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type CancelEventResBookingsItem0ProductDto = {
    type?: 'tour';
    id?: string;
    name?: string;
    description?: string;
    capacity_option_id?: string;
    customers?: CancelEventResBookingsItem0ProductCustomersDto;
    pricing?: CancelEventResBookingsItem0ProductPricingDto;
    options?: CancelEventResBookingsItem0ProductOptionsDto;
    configuration?: CancelEventResBookingsItem0ProductConfigurationDto;
};

export type CancelEventResBookingsItem0ProductCustomersDto = {
    items?: Array<CancelEventResBookingsItem0ProductCustomersItemDto>;
    pax?: PaxData;
};

export type CancelEventResBookingsItem0ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference?: CancelEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x?: number;
    pickup?: CancelEventResBookingsItem0ProductCustomersItemPickupDto;
};

export type CancelEventResBookingsItem0ProductCustomersItemReferenceDto = {
    type?: 'person';
    id?: string;
    contact_details?: UpdateUserResProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: UpdateUserResProfileOrganizationDto;
};

export type CancelEventResBookingsItem0ProductCustomersItemPickupDto = {
    id: string;
    type?: RouteItemType;
    location?: LocationDataModel;
    schedule?: UpdateProductResRouteItemScheduleDto;
    pinned?: boolean;
};

export type CancelEventResBookingsItem0ProductPricingDto = {
    id?: string;
    type?: PricingType;
    currency?: Currency;
    dependencies?: UpdateProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price?: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
    payment_requirements?: PaymentRequirementsData;
    discount?: DiscountData;
};

export type CancelEventResBookingsItem0ProductOptionsDto = {
    items?: Array<CancelEventResBookingsItem0ProductOptionsItemDto>;
};

export type CancelEventResBookingsItem0ProductOptionsItemDto = {
    type?: ProductOptionType;
    id: string;
    name?: string;
    description?: string;
    customers?: CancelEventResBookingsItem0ProductOptionsItemCustomersDto;
    pricing?: CancelEventResBookingsItem0ProductPricingDto;
    mandatory?: boolean;
};

export type CancelEventResBookingsItem0ProductOptionsItemCustomersDto = {
    items?: Array<CancelEventResBookingsItem0ProductOptionsItemCustomersItemDto>;
    pax?: PaxData;
};

export type CancelEventResBookingsItem0ProductOptionsItemCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference?: CancelEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x?: number;
};

export type CancelEventResBookingsItem0ProductConfigurationDto = {
    shared?: boolean;
    autoscaled?: boolean;
    single_use?: boolean;
    open_hours?: boolean;
    cutoff?: UpdateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
};

export type CancelEventResBookingsItem0EventDto = {
    id?: string;
    date?: PeriodData;
    status?: EventStatus;
    operations?: CancelEventResBookingsItem0EventOperationsDto;
};

export type CancelEventResBookingsItem0EventOperationsDto = {
    route?: UpdateProductResRouteDto;
};

export type CancelEventResBookingsItem0OrderDto = {
    id?: string;
    number: string;
    customer?: CancelEventResBookingsItem0ProductCustomersItemReferenceDto;
};

export type CancelEventResBookingsItem0TransactionsDto = {
    items?: Array<CancelEventResBookingsItem0TransactionsItemDto>;
    paid?: DualCurrencyData;
    refunded?: DualCurrencyData;
    waived?: DualCurrencyData;
};

export type CancelEventResBookingsItem0TransactionsItemDto = {
    id: string;
    type?: TransactionType;
    method?: TransactionMethod;
    amount?: DualCurrencyData;
    created?: Action;
    discarded?: Action;
};

export type CancelEventResBookingsItem0FinancialsDto = {
    cost?: DualCurrencyData;
    subtotal: DualCurrencyData;
    total: DualCurrencyData;
    debt: DualCurrencyData;
};

export type CancelEventResBookingsItem0AccessDto = {
    permissions: BookingPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessBookingViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type CancelEventResBookingsItem0Integration0Dto = {
    reservationReference?: string;
    bookingReference?: string;
    cancelledBookingReference?: string;
    tickets?: Array<CancelEventResBookingsItem0Integration0TicketsItemDto>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type CancelEventResBookingsItem0Integration0TicketsItemDto = {
    category?: BookingItemCategory;
    ticketCodeType?: string;
    ticketCode?: string;
};

export type CancelEventResBookingsItem0Integration1Dto = {
    metadata?: {
        [key: string]: unknown;
    };
    reference?: string;
};

export type CancelEventResBookingsItem0PackageDto = {
    group_id?: string;
    package_product_id?: string;
    day_index?: number;
    order_index?: number;
    discount?: {
        [key: string]: unknown;
    };
};

export type CancelEventResBookingsItem1Dto = {
    resource_type?: 'booking';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source?:
        | UpdateProductResPricingItemDependenciesSource0Dto
        | UpdateProductResPricingItemDependenciesSource1Dto;
    product?: CancelEventResBookingsItem1ProductDto;
    event?: CancelEventResBookingsItem1EventDto;
    order: CancelEventResBookingsItem0OrderDto;
    transactions?: CancelEventResBookingsItem0TransactionsDto;
    financials?: CancelEventResBookingsItem0FinancialsDto;
    notes?: CancelEventResNotesDto;
    status: BookingStatus;
    access?: CancelEventResBookingsItem0AccessDto;
    integration?:
        | CancelEventResBookingsItem0Integration0Dto
        | CancelEventResBookingsItem0Integration1Dto;
    package?: CancelEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type CancelEventResBookingsItem1ProductDto = {
    type?: 'transfer';
    id?: string;
    name?: string;
    description?: string;
    capacity_option_id?: string;
    customers?: CancelEventResBookingsItem1ProductCustomersDto;
    pricing?: CancelEventResBookingsItem0ProductPricingDto;
    options?: CancelEventResBookingsItem0ProductOptionsDto;
    configuration?: CancelEventResBookingsItem0ProductConfigurationDto;
};

export type CancelEventResBookingsItem1ProductCustomersDto = {
    items?: Array<CancelEventResBookingsItem1ProductCustomersItemDto>;
    pax?: PaxData;
};

export type CancelEventResBookingsItem1ProductCustomersItemDto = {
    id: string;
    attendance?: Action;
    reference?: CancelEventResBookingsItem0ProductCustomersItemReferenceDto;
    plus_x?: number;
    pickup?: CancelEventResBookingsItem0ProductCustomersItemPickupDto;
};

export type CancelEventResBookingsItem1EventDto = {
    id?: string;
    date?: PeriodData;
    status?: EventStatus;
    operations?: CancelEventResBookingsItem1EventOperationsDto;
};

export type CancelEventResBookingsItem1EventOperationsDto = {
    route?: UpdateProductResRouteDto;
};

export type CancelEventRes1Dto = {
    resource_type?: 'event';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    locked?: boolean;
    product?: CancelEventResProductDto;
    date?: PeriodData;
    operations?: CancelEventRes1OperationsDto;
    notes?: CancelEventResNotesDto;
    status: EventStatus;
    access?: CancelEventResAccessDto;
    bookings?: Array<
        CancelEventResBookingsItem0Dto | CancelEventResBookingsItem1Dto
    >;
};

export type CancelEventRes1OperationsDto = {
    pax: PaxData;
    vacant?: number;
    overbooked?: number;
    product_options?: Array<CancelEventResOperationsProductOptionsItemDto>;
    route?: UpdateProductResRouteDto;
    staff?: CancelEventRes1OperationsStaffDto;
    assets?: CancelEventRes1OperationsAssetsDto;
};

export type CancelEventRes1OperationsStaffDto = {
    items?: Array<CancelEventRes1OperationsStaffItemDto>;
};

export type CancelEventRes1OperationsStaffItemDto = {
    id: string;
    reference?: UpdateMembersTeamsResMembersItem0ReferenceDto;
    position?: TransferEventStaffMemberPosition;
    assigned?: Action;
    pinned: boolean;
};

export type CancelEventRes1OperationsAssetsDto = {
    items?: Array<CancelEventRes1OperationsAssetsItemDto>;
};

export type CancelEventRes1OperationsAssetsItemDto = {
    id: string;
    type?: TransferEventAssetType;
    reference?: CancelEventResOperationsAssetsItemReferenceDto;
    assigned?: Action;
    pinned: boolean;
};

export type UpdateEventStaffReqDto = {
    items?: Array<UpdateEventStaffReqItemDto>;
    type: 'tour';
};

export type UpdateEventStaffReqItemDto = {
    action: ListItemAction;
    id?: string;
    reference?: UpdateMembersTeamsReqItem0ReferenceDto;
    position?: TransferEventStaffMemberPosition;
    assigned?: UpdateEventStaffReqItemAssignedDto;
    pinned?: boolean;
};

export type UpdateEventStaffReqItemAssignedDto = {
    [key: string]: unknown;
};

export type UpdateEventStaffReq1Dto = {
    items?: Array<UpdateEventStaffReqItemDto>;
    type: 'transfer';
};

export type UpdateEventAssetsReqDto = {
    items?: Array<UpdateEventAssetsReqItemDto>;
    type: 'tour';
};

export type UpdateEventAssetsReqItemDto = {
    action: ListItemAction;
    id?: string;
    type?: TransferEventAssetType;
    reference?: UpdateEventAssetsReqItemReferenceDto;
    assigned?: UpdateUserReqAccountMembershipsItem0InvitedDto;
    pinned?: boolean;
};

export type UpdateEventAssetsReqItemReferenceDto = {
    type?: string;
    id?: string;
    vehicle_type?: VehicleType;
    make?: string;
    model?: string;
    license_plate?: string;
    max_passengers?: number;
    year?: number;
    engine_type?: VehicleEngineType;
};

export type UpdateEventAssetsReq1Dto = {
    items?: Array<UpdateEventAssetsReqItemDto>;
    type: 'transfer';
};

export type UpdateEventNotesReqDto = {
    items?: Array<UpdateEventNotesReqItemDto>;
};

export type UpdateEventNotesReqItemDto = {
    action: ListItemAction;
    id?: string;
    visibility?: NoteVisibility;
    content?: string;
    by_staff?: boolean;
};

export type GetCapacitiesResDto = {
    items?: Array<GetProductFittingCapacitiesResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type CreateManyCapacitiesReqDto = {
    items?: Array<CreateManyCapacitiesReqItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type CreateManyCapacitiesReqItemDto = {
    type: CapacityType;
    name: string;
    limit: AgebandCapacityData | FlatCapacityData;
};

export type CreateManyCapacitiesResDto = {
    items?: Array<GetProductFittingCapacitiesResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetCapacityResDto = {
    resource_type: 'capacity';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type: CapacityType;
    name: string;
    limit: AgebandCapacityData | FlatCapacityData;
    access: GetCapacityResAccessDto;
};

export type GetCapacityResAccessDto = {
    permissions: CapacityPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessCapacityViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetSchedulesResDto = {
    items?: Array<GetSchedulesResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetSchedulesResItemDto = {
    resource_type: 'schedule';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: ScheduleType;
    name: string;
    timezone: TimezoneData;
    start_times?: Array<TimeOffset>;
    any_time?: boolean;
    recurrence?:
        | MonthlyRecurrenceData
        | WeeklyRecurrenceData
        | YearlyRecurrenceData;
    dates: Array<DatePeriodData>;
    access: GetProductsResItem0ResolvedSchedulesItemAccessDto;
};

export type CreateManySchedulesReqDto = {
    items?: Array<CreateManySchedulesReqItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type CreateManySchedulesReqItemDto = {
    type: ScheduleType;
    name: string;
    timezone: TimezoneData;
    start_times?: Array<TimeOffset>;
    any_time?: boolean;
    recurrence?:
        | MonthlyRecurrenceData
        | WeeklyRecurrenceData
        | YearlyRecurrenceData;
    dates: Array<DatePeriodData>;
};

export type CreateManySchedulesResDto = {
    items?: Array<GetSchedulesResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetAssetsResDto = {
    items?: Array<GetAssetsResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetAssetsResItemDto = {
    resource_type: 'asset';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: 'vehicle';
    owner?: GetAssetsResItemOwnerDto;
    usage?: Array<GetAssetsResItemUsageItemDto>;
    access: GetAssetsResItemAccessDto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    year: number;
    license_plate?: string;
    max_passengers: number;
    engine_type?: VehicleEngineType;
    mileage: GetAssetsResItemUsageItemMileageDto;
};

export type GetAssetsResItemOwnerDto = {
    contact_details?: GetTeamsResItemMembersItem0ReferenceContactDetailsDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: GetTeamsResItemMembersItem0ReferenceOrganizationDto;
    reference: GetAssetsResItemOwnerReferenceDto;
};

export type GetAssetsResItemOwnerReferenceDto = {
    type: 'human';
    id?: string;
    name?: PersonNameData;
};

export type GetAssetsResItemUsageItemDto = {
    assignee?: GetTeamsResItemMembersItem0Dto;
    period: PeriodData;
    event?: GetAssetsResItemUsageItemEventDto;
    mileage?: GetAssetsResItemUsageItemMileageDto;
};

export type GetAssetsResItemUsageItemEventDto = {
    type: ProductType;
    id: string;
    date: PeriodData;
};

export type GetAssetsResItemUsageItemMileageDto = {
    km: number;
    mi: number;
};

export type GetAssetsResItemAccessDto = {
    permissions: BookingPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessBookingViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type CreateAssetReqDto = {
    type: 'vehicle';
    owner?: CreateAssetReqOwnerDto;
    access?: CreateAssetReqAccessDto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    year: number;
    license_plate?: string;
    max_passengers: number;
    engine_type?: VehicleEngineType;
    mileage: CreateAssetReqMileageDto;
};

export type CreateAssetReqOwnerDto = {
    contact_details?: RegisterUsersReqProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: RegisterUsersReqProfileOrganizationDto;
};

export type CreateAssetReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateAssetReqMileageDto = {
    km?: number;
    mi?: number;
};

export type CreateAssetResDto = {
    resource_type: 'asset';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: 'vehicle';
    owner?: CreateAssetResOwnerDto;
    usage?: Array<CreateAssetResUsageItemDto>;
    access: CreateAssetResAccessDto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    year: number;
    license_plate?: string;
    max_passengers: number;
    engine_type?: VehicleEngineType;
    mileage: CreateAssetResUsageItemMileageDto;
};

export type CreateAssetResOwnerDto = {
    contact_details?: RegisterUsersResProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: RegisterUsersResProfileOrganizationDto;
};

export type CreateAssetResUsageItemDto = {
    assignee?: CreateTeamResMembersItem0Dto;
    period?: PeriodData;
    mileage?: CreateAssetResUsageItemMileageDto;
};

export type CreateAssetResUsageItemMileageDto = {
    km: number;
    mi: number;
};

export type CreateAssetResAccessDto = {
    permissions: BookingPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessBookingViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type GetAssetResDto = {
    resource_type: 'asset';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    type: 'vehicle';
    owner?: GetAssetResOwnerDto;
    usage?: Array<GetAssetResUsageItemDto>;
    access: GetAssetResAccessDto;
    vehicle_type: VehicleType;
    make: string;
    model: string;
    year: number;
    license_plate?: string;
    max_passengers: number;
    engine_type?: VehicleEngineType;
    mileage: GetAssetResUsageItemMileageDto;
};

export type GetAssetResOwnerDto = {
    contact_details?: GetUserResProfileContactDetailsDto;
    attachments?: GetUserResProfileAttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: GetUserResProfileOrganizationDto;
    reference: GetAssetResOwnerReferenceDto;
};

export type GetAssetResOwnerReferenceDto = {
    type: 'human';
    id?: string;
    name?: PersonNameData;
};

export type GetAssetResUsageItemDto = {
    assignee?: GetTeamResMembersItem0Dto;
    period: PeriodData;
    event?: GetAssetResUsageItemEventDto;
    mileage?: GetAssetResUsageItemMileageDto;
};

export type GetAssetResUsageItemEventDto = {
    type: ProductType;
    id: string;
    date: PeriodData;
};

export type GetAssetResUsageItemMileageDto = {
    km: number;
    mi: number;
};

export type GetAssetResAccessDto = {
    permissions: BookingPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessBookingViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetBookingsResDto = {
    items?: Array<GetBookingsResItem0Dto | GetBookingsResItem1Dto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetBookingsResItem0Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    source:
        | GetProductsResItem0PricingItemDependenciesSource0Dto
        | GetProductsResItem0PricingItemDependenciesSource1Dto;
    product: GetEventsResItem0BookingsItem0ProductDto;
    event?: GetEventsResItem0BookingsItem0EventDto;
    order: GetEventsResItem0BookingsItem0OrderDto;
    transactions?: GetEventsResItem0BookingsItem0TransactionsDto;
    financials: GetEventsResItem0BookingsItem0FinancialsDto;
    notes?: GetEventsResItem0NotesDto;
    status: BookingStatus;
    access: GetEventsResItem0BookingsItem0AccessDto;
    integration?:
        | GetEventsResItem0BookingsItem0Integration0Dto
        | GetEventsResItem0BookingsItem0Integration1Dto;
    package?: GetEventsResItem0BookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetBookingsResItem1Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    source:
        | GetProductsResItem0PricingItemDependenciesSource0Dto
        | GetProductsResItem0PricingItemDependenciesSource1Dto;
    product: GetEventsResItem0BookingsItem1ProductDto;
    event?: GetEventsResItem0BookingsItem1EventDto;
    order: GetEventsResItem0BookingsItem0OrderDto;
    transactions?: GetEventsResItem0BookingsItem0TransactionsDto;
    financials: GetEventsResItem0BookingsItem0FinancialsDto;
    notes?: GetEventsResItem0NotesDto;
    status: BookingStatus;
    access: GetEventsResItem0BookingsItem0AccessDto;
    integration?:
        | GetEventsResItem0BookingsItem0Integration0Dto
        | GetEventsResItem0BookingsItem0Integration1Dto;
    package?: GetEventsResItem0BookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type CreateBookingReqDto = {
    source:
        | CreateProductReqPricingItemDependenciesSource0Dto
        | CreateProductReqPricingItemDependenciesSource1Dto;
    product: CreateBookingReqProductDto;
    event?: CreateBookingReqEventDto;
    order?: CreateBookingReqOrderDto;
    notes?: CreateEventReqNotesDto;
    status: BookingStatus;
    access?: CreateBookingReqAccessDto;
    integration?:
        | CreateBookingReqIntegration0Dto
        | CreateBookingReqIntegration1Dto;
    package?: CreateBookingReqPackageDto;
    customer_bookings_count?: number;
};

export type CreateBookingReqProductDto = {
    id: string;
    description?: string;
    capacity_option_id?: string;
    date?: PeriodData;
    customers: CreateBookingReqProductCustomersDto;
    pricing?: CreateBookingReqProductPricingDto;
    options?: CreateBookingReqProductOptionsDto;
    source?:
        | CreateProductReqPricingItemDependenciesSource0Dto
        | CreateProductReqPricingItemDependenciesSource1Dto;
};

export type CreateBookingReqProductCustomersDto = {
    items: Array<CreateBookingReqProductCustomersItemDto>;
    pax: PaxData;
};

export type CreateBookingReqProductCustomersItemDto = {
    action?: ListItemAction;
    id: string;
    customer_id: string;
    plus_x?: number;
};

export type CreateBookingReqProductPricingDto = {
    action?: ListItemAction;
    discount?: DiscountData;
};

export type CreateBookingReqProductOptionsDto = {
    items: Array<CreateBookingReqProductOptionsItemDto>;
};

export type CreateBookingReqProductOptionsItemDto = {
    id: string;
    customers?: CreateBookingReqProductOptionsItemCustomersDto;
    mandatory?: boolean;
};

export type CreateBookingReqProductOptionsItemCustomersDto = {
    items: Array<CreateBookingReqProductOptionsItemCustomersItemDto>;
    pax: PaxData;
};

export type CreateBookingReqProductOptionsItemCustomersItemDto = {
    action?: ListItemAction;
    id: string;
    customer_id: string;
    plus_x?: number;
};

export type CreateBookingReqEventDto = {
    id?: string;
};

export type CreateBookingReqOrderDto = {
    id?: string;
};

export type CreateBookingReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateBookingReqIntegration0Dto = {
    gygBookingReference: string;
    gygActivityReference?: string;
    name: OtaName;
    tickets?: Array<CreateBookingReqIntegration0TicketsItemDto>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type CreateBookingReqIntegration0TicketsItemDto = {
    [key: string]: unknown;
};

export type CreateBookingReqIntegration1Dto = {
    name: OtaName;
    metadata?: {
        [key: string]: unknown;
    };
};

export type CreateBookingReqPackageDto = {
    group_id?: string;
    package_product_id?: string;
    day_index?: number;
    order_index?: number;
    discount?: {
        [key: string]: unknown;
    };
};

export type CreateBookingReq1Dto = {
    source:
        | CreateProductReqPricingItemDependenciesSource0Dto
        | CreateProductReqPricingItemDependenciesSource1Dto;
    product: CreateBookingReqProductDto;
    event?: CreateBookingReqEventDto;
    order?: CreateBookingReqOrderDto;
    notes?: CreateEventReqNotesDto;
    status: BookingStatus;
    access?: CreateBookingReqAccessDto;
    integration?:
        | CreateBookingReqIntegration0Dto
        | CreateBookingReqIntegration1Dto;
    package?: CreateBookingReqPackageDto;
    customer_bookings_count?: number;
};

export type CreateBookingResDto = {
    resource_type: 'booking';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    source:
        | CreateProductResPricingItemDependenciesSource0Dto
        | CreateProductResPricingItemDependenciesSource1Dto;
    product: CreateBookingResProductDto;
    event?: CreateBookingResEventDto;
    order: CreateBookingResOrderDto;
    transactions?: CreateBookingResTransactionsDto;
    financials: CreateBookingResFinancialsDto;
    notes?: CreateEventResNotesDto;
    status: BookingStatus;
    access: CreateBookingResAccessDto;
    integration?:
        | CreateBookingResIntegration0Dto
        | CreateBookingResIntegration1Dto;
    package?: CreateBookingResPackageDto;
    customer_bookings_count?: number;
};

export type CreateBookingResProductDto = {
    type: 'tour';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: CreateBookingResProductCustomersDto;
    pricing: CreateBookingResProductPricingDto;
    options?: CreateBookingResProductOptionsDto;
    configuration?: CreateBookingResProductConfigurationDto;
    attachments?: CreateProductResAttachmentsDto;
    policies?: CreateProductResPoliciesDto;
};

export type CreateBookingResProductCustomersDto = {
    items: Array<CreateBookingResProductCustomersItemDto>;
    pax: PaxData;
};

export type CreateBookingResProductCustomersItemDto = {
    action?: ListItemAction;
    id: string;
    reference: CreateBookingResProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: CreateBookingResProductCustomersItemPickupDto;
};

export type CreateBookingResProductCustomersItemReferenceDto = {
    type: 'person';
    id: string;
    contact_details?: RegisterUsersResProfileContactDetailsDto;
    name: PersonNameData;
    languages?: Array<Language>;
    organization?: RegisterUsersResProfileOrganizationDto;
};

export type CreateBookingResProductCustomersItemPickupDto = {
    id: string;
    type: RouteItemType;
    location: LocationDataModel;
    schedule: CreateProductResRouteItemScheduleDto;
    pinned: boolean;
};

export type CreateBookingResProductPricingDto = {
    action?: ListItemAction;
    id: string;
    type: PricingType;
    currency: Currency;
    dependencies?: CreateProductResPricingItemDependenciesDto;
    cost?: DualCurrencyData;
    price: DualCurrencyData;
    inclusions?: Array<string>;
    exclusions?: Array<string>;
    payment_requirements: PaymentRequirementsData;
    discount?: DiscountData;
};

export type CreateBookingResProductOptionsDto = {
    items: Array<CreateBookingResProductOptionsItemDto>;
};

export type CreateBookingResProductOptionsItemDto = {
    type: ProductOptionType;
    id: string;
    name: string;
    description?: string;
    customers: CreateBookingResProductOptionsItemCustomersDto;
    pricing?: CreateBookingResProductPricingDto;
    sync_pricing?: boolean;
    mandatory?: boolean;
};

export type CreateBookingResProductOptionsItemCustomersDto = {
    items: Array<CreateBookingResProductOptionsItemCustomersItemDto>;
    pax: PaxData;
};

export type CreateBookingResProductOptionsItemCustomersItemDto = {
    action?: ListItemAction;
    id: string;
    reference: CreateBookingResProductCustomersItemReferenceDto;
    plus_x: number;
};

export type CreateBookingResProductConfigurationDto = {
    shared: boolean;
    autoscaled: boolean;
    single_use: boolean;
    open_hours?: boolean;
    cutoff?: CreateProductResConfigurationCutoffDto;
    sell_via_widget?: boolean;
};

export type CreateBookingResEventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
};

export type CreateBookingResOrderDto = {
    id: string;
    number: string;
    customer: CreateBookingResProductCustomersItemReferenceDto;
};

export type CreateBookingResTransactionsDto = {
    paid?: DualCurrencyData;
    refunded?: DualCurrencyData;
    waived?: DualCurrencyData;
};

export type CreateBookingResFinancialsDto = {
    cost?: DualCurrencyData;
    subtotal: DualCurrencyData;
    total: DualCurrencyData;
    debt: DualCurrencyData;
};

export type CreateBookingResAccessDto = {
    permissions: BookingPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessBookingViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type CreateBookingResIntegration0Dto = {
    gygBookingReference: string;
    gygActivityReference?: string;
    reservationReference: string;
    tickets?: Array<CreateBookingResIntegration0TicketsItemDto>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type CreateBookingResIntegration0TicketsItemDto = {
    [key: string]: unknown;
};

export type CreateBookingResIntegration1Dto = {
    name: OtaName;
    metadata?: {
        [key: string]: unknown;
    };
    reference: string;
};

export type CreateBookingResPackageDto = {
    group_id: string;
    package_product_id: string;
    day_index: number;
    order_index: number;
    discount?: {
        [key: string]: unknown;
    };
    policies?: CreateProductResPoliciesDto;
};

export type CreateBookingRes1Dto = {
    resource_type: 'booking';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    source:
        | CreateProductResPricingItemDependenciesSource0Dto
        | CreateProductResPricingItemDependenciesSource1Dto;
    product: CreateBookingRes1ProductDto;
    event?: CreateBookingRes1EventDto;
    order: CreateBookingResOrderDto;
    transactions?: CreateBookingResTransactionsDto;
    financials: CreateBookingResFinancialsDto;
    notes?: CreateEventResNotesDto;
    status: BookingStatus;
    access: CreateBookingResAccessDto;
    integration?:
        | CreateBookingResIntegration0Dto
        | CreateBookingResIntegration1Dto;
    package?: CreateBookingResPackageDto;
    customer_bookings_count?: number;
};

export type CreateBookingRes1ProductDto = {
    type: 'transfer';
    id: string;
    name: string;
    description?: string;
    capacity_option_id?: string;
    customers: CreateBookingRes1ProductCustomersDto;
    pricing: CreateBookingResProductPricingDto;
    options?: CreateBookingResProductOptionsDto;
    configuration?: CreateBookingResProductConfigurationDto;
    attachments?: CreateProductResAttachmentsDto;
    policies?: CreateProductResPoliciesDto;
};

export type CreateBookingRes1ProductCustomersDto = {
    items: Array<CreateBookingRes1ProductCustomersItemDto>;
    pax: PaxData;
};

export type CreateBookingRes1ProductCustomersItemDto = {
    action?: ListItemAction;
    id: string;
    reference: CreateBookingResProductCustomersItemReferenceDto;
    plus_x: number;
    pickup?: CreateBookingResProductCustomersItemPickupDto;
};

export type CreateBookingRes1EventDto = {
    id?: string;
    date: PeriodData;
    status: EventStatus;
};

export type CreatePackageBookingsReqDto = {
    package_product_id: string;
    group_id?: string;
    status: BookingStatus;
    source?:
        | CreateProductReqPricingItemDependenciesSource0Dto
        | CreateProductReqPricingItemDependenciesSource1Dto;
    customers: CreateBookingReqProductOptionsItemCustomersDto;
    discount?: {
        [key: string]: unknown;
    };
    items: Array<CreatePackageBookingsReqItemDto>;
    date?: PeriodData;
};

export type CreatePackageBookingsReqItemDto = {
    product: CreateProductReqOptionsItemReferencesItem1Dto;
    day_index: number;
    order_index: number;
    start: number;
    capacity_option_id?: string;
    notes?: CreateEventReqNotesDto;
    options?: CreateBookingReqProductOptionsDto;
};

export type GetBookingResDto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source:
        | GetProductResPricingItemDependenciesSource0Dto
        | GetProductResPricingItemDependenciesSource1Dto;
    product: GetEventResBookingsItem0ProductDto;
    event?: GetEventResBookingsItem0EventDto;
    order: GetEventResBookingsItem0OrderDto;
    transactions?: GetEventResBookingsItem0TransactionsDto;
    financials: GetEventResBookingsItem0FinancialsDto;
    notes?: GetEventResNotesDto;
    status: BookingStatus;
    access: GetEventResBookingsItem0AccessDto;
    integration?:
        | GetEventResBookingsItem0Integration0Dto
        | GetEventResBookingsItem0Integration1Dto;
    package?: GetEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type GetBookingRes1Dto = {
    resource_type: 'booking';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source:
        | GetProductResPricingItemDependenciesSource0Dto
        | GetProductResPricingItemDependenciesSource1Dto;
    product: GetEventResBookingsItem1ProductDto;
    event?: GetEventResBookingsItem1EventDto;
    order: GetEventResBookingsItem0OrderDto;
    transactions?: GetEventResBookingsItem0TransactionsDto;
    financials: GetEventResBookingsItem0FinancialsDto;
    notes?: GetEventResNotesDto;
    status: BookingStatus;
    access: GetEventResBookingsItem0AccessDto;
    integration?:
        | GetEventResBookingsItem0Integration0Dto
        | GetEventResBookingsItem0Integration1Dto;
    package?: GetEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type UpdateEventBookingsReqDto = {
    id?: string;
    date?: PeriodData;
    capacity_option_id?: string;
    status?: EventStatus;
};

export type UpdateEventBookingsResDto = {
    resource_type?: 'booking';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source?:
        | UpdateProductResPricingItemDependenciesSource0Dto
        | UpdateProductResPricingItemDependenciesSource1Dto;
    product?: CancelEventResBookingsItem0ProductDto;
    event?: CancelEventResBookingsItem0EventDto;
    order: CancelEventResBookingsItem0OrderDto;
    transactions?: CancelEventResBookingsItem0TransactionsDto;
    financials?: CancelEventResBookingsItem0FinancialsDto;
    notes?: CancelEventResNotesDto;
    status: BookingStatus;
    access?: CancelEventResBookingsItem0AccessDto;
    integration?:
        | CancelEventResBookingsItem0Integration0Dto
        | CancelEventResBookingsItem0Integration1Dto;
    package?: CancelEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type UpdateEventBookingsRes1Dto = {
    resource_type?: 'booking';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    source?:
        | UpdateProductResPricingItemDependenciesSource0Dto
        | UpdateProductResPricingItemDependenciesSource1Dto;
    product?: CancelEventResBookingsItem1ProductDto;
    event?: CancelEventResBookingsItem1EventDto;
    order: CancelEventResBookingsItem0OrderDto;
    transactions?: CancelEventResBookingsItem0TransactionsDto;
    financials?: CancelEventResBookingsItem0FinancialsDto;
    notes?: CancelEventResNotesDto;
    status: BookingStatus;
    access?: CancelEventResBookingsItem0AccessDto;
    integration?:
        | CancelEventResBookingsItem0Integration0Dto
        | CancelEventResBookingsItem0Integration1Dto;
    package?: CancelEventResBookingsItem0PackageDto;
    customer_bookings_count?: number;
};

export type UpdateCustomersBookingsReqDto = {
    items?: Array<UpdateCustomersBookingsReqItemDto>;
    pax?: PaxData;
};

export type UpdateCustomersBookingsReqItemDto = {
    action: ListItemAction;
    id?: string;
    attendance?: UpdateCustomersBookingsReqItemAttendanceDto;
    customer_id?: string;
    reference?: UpdateCustomersBookingsReqItemReferenceDto;
    plus_x?: number;
    pickup?: UpdateCustomersBookingsReqItemPickupDto;
};

export type UpdateCustomersBookingsReqItemAttendanceDto = {
    type?: AttendanceType;
};

export type UpdateCustomersBookingsReqItemReferenceDto = {
    type?: 'person';
    id?: string;
    contact_details?: UpdateUserReqProfileContactDetailsDto;
    name?: PersonNameData;
    languages?: Array<Language>;
    organization?: UpdateUserReqProfileOrganizationDto;
};

export type UpdateCustomersBookingsReqItemPickupDto = {
    id?: string;
    type?: RouteItemType;
    location?: LocationDataModel;
    schedule?: UpdateProductRoutesReqItemScheduleDto;
    pinned?: boolean;
};

export type UpdateCustomersBookingsReq1Dto = {
    items?: Array<UpdateCustomersBookingsReqItemDto>;
    pax?: PaxData;
};

export type UpdateProductOptionsBookingsReqDto = {
    items?: Array<UpdateProductOptionsBookingsReqItemDto>;
};

export type UpdateProductOptionsBookingsReqItemDto = {
    id?: string;
    action: ListItemAction;
    customers?: UpdateProductOptionsBookingsReqItemCustomersDto;
    sync_pricing?: boolean;
    mandatory?: boolean;
};

export type UpdateProductOptionsBookingsReqItemCustomersDto = {
    items?: Array<UpdateProductOptionsBookingsReqItemCustomersItemDto>;
    pax?: PaxData;
};

export type UpdateProductOptionsBookingsReqItemCustomersItemDto = {
    action: ListItemAction;
    id?: string;
    attendance?: UpdateCustomersBookingsReqItemAttendanceDto;
    customer_id?: string;
    reference?: UpdateCustomersBookingsReqItemReferenceDto;
    plus_x?: number;
};

export type UpdateStatusBookingsReqDto = {
    status: BookingStatus;
    message?: string;
};

export type UpdateTransactionsBookingsReqDto = {
    action: ListItemAction;
    id?: string;
    type?: TransactionType;
    discard?: TransactionDiscardData;
    method?: TransactionMethod;
    amount?: DualCurrencyData;
};

export type ComputePackagePriceBookingsReqDto = {
    package_product_id: string;
    date: PeriodData;
    customers: CreateBookingReqProductOptionsItemCustomersDto;
    pricing?: ComputePackagePriceBookingsReqPricingDto;
    items: Array<ComputePackagePriceBookingsReqItemDto>;
};

export type ComputePackagePriceBookingsReqPricingDto = {
    discount?: DiscountData;
};

export type ComputePackagePriceBookingsReqItemDto = {
    day_index: number;
    order_index: number;
    start: number;
    capacity_option_id: string;
    product: CreateProductReqOptionsItemReferencesItem1Dto;
    options?: CreateBookingReqProductOptionsDto;
};

export type ComputePackagePriceBookingsResDto = {
    financials: CreateBookingResFinancialsDto;
    items: Array<ComputePackagePriceBookingsResItemDto>;
};

export type ComputePackagePriceBookingsResItemDto = {
    product: CreateProductResOptionsItemReferencesItem1Dto;
    financials: CreateBookingResFinancialsDto;
};

export type ExportBookingsExportResDto = {
    resource_type: 'file';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    access: ExportBookingsExportResAccessDto;
    width: number;
    height: number;
};

export type ExportBookingsExportResAccessDto = {
    permissions: FilePermissionsData;
    view?: ExportBookingsExportResAccessViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type ExportBookingsExportResAccessViewDto = {
    projections?: Array<string>;
    exclusions?: {
        [key: string]: unknown;
    };
};

export type ExportBookingsExportRes1Dto = {
    resource_type: 'file';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    access: ExportBookingsExportResAccessDto;
};

export type ExportBookingsExportRes2Dto = {
    resource_type: 'file';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    type: FileType;
    content_type: ContentType;
    name: string;
    path: string;
    size: number;
    checksum: string;
    url?: string;
    access: ExportBookingsExportResAccessDto;
};

export type GetCustomerResDto = {
    items?: Array<GetCustomerResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetCustomerResItemDto = {
    resource_type: 'customer';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    contact_details?: GetTeamsResItemMembersItem0ReferenceContactDetailsDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: GetTeamsResItemMembersItem0ReferenceOrganizationDto;
    remote_id?: string;
    access: GetCustomerResItemAccessDto;
};

export type GetCustomerResItemAccessDto = {
    permissions: CustomerPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessCustomerViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type CreateCustomerReqDto = {
    contact_details?: RegisterUsersReqProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: RegisterUsersReqProfileOrganizationDto;
    remote_id?: string;
    access?: CreateCustomerReqAccessDto;
};

export type CreateCustomerReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateCustomerResDto = {
    resource_type: 'customer';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    contact_details?: RegisterUsersResProfileContactDetailsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: RegisterUsersResProfileOrganizationDto;
    remote_id?: string;
    access: CreateCustomerResAccessDto;
};

export type CreateCustomerResAccessDto = {
    permissions: CustomerPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessCustomerViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type GetCustomer1ResDto = {
    resource_type: 'customer';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    contact_details?: GetUserResProfileContactDetailsDto;
    attachments?: GetUserResProfileAttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: GetUserResProfileOrganizationDto;
    remote_id?: string;
    access: GetCustomer1ResAccessDto;
};

export type GetCustomer1ResAccessDto = {
    permissions: CustomerPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessCustomerViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type UpdateCustomerReqDto = {
    contact_details?: UpdateUserReqProfileContactDetailsDto;
    attachments?: UpdateUserReqProfileAttachmentsDto;
    name?: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: UpdateUserReqProfileOrganizationDto;
    remote_id?: string;
    access?: UpdateCustomerReqAccessDto;
};

export type UpdateCustomerReqAccessDto = {
    groups?: UpdateUserReqAccessGroupsDto;
};

export type UpdateCustomerResDto = {
    resource_type?: 'customer';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    contact_details?: UpdateUserResProfileContactDetailsDto;
    attachments?: UpdateUserResProfileAttachmentsDto;
    name?: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages?: Array<Language>;
    organization?: UpdateUserResProfileOrganizationDto;
    remote_id?: string;
    access?: UpdateCustomerResAccessDto;
};

export type UpdateCustomerResAccessDto = {
    permissions: CustomerPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessCustomerViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type GetOrdersResDto = {
    items?: Array<GetOrdersResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetOrdersResItemDto = {
    resource_type: 'order';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    number: string;
    customer: GetEventsResItem0BookingsItem0ProductCustomersItemReferenceDto;
    price?: GetOrdersResItemPriceDto;
    status: OrderStatus;
    bookings?: Array<
        GetEventsResItem0BookingsItem0Dto | GetEventsResItem0BookingsItem1Dto
    >;
    access: GetOrdersResItemAccessDto;
    summary?: GetOrdersResItemSummaryDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    confirmed_on_checkout?: boolean;
};

export type GetOrdersResItemPriceDto = {
    subtotal: number;
    discount?: DiscountData;
    total: number;
    currency?: Currency;
};

export type GetOrdersResItemAccessDto = {
    permissions: OrderPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessOrderViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetOrdersResItemSummaryDto = {
    counts: GetOrdersResItemSummaryCountsDto;
};

export type GetOrdersResItemSummaryCountsDto = {
    bookings?: number;
    products?: number;
    customers?: number;
};

export type CreateOrderReqDto = {
    customer: CreateOrderReqCustomerDto;
    access?: CreateOrderReqAccessDto;
};

export type CreateOrderReqCustomerDto = {
    type?: 'person';
    id?: string;
    contact_details?: RegisterUsersReqProfileContactDetailsDto;
    name: PersonNameData;
    languages?: Array<Language>;
    organization?: RegisterUsersReqProfileOrganizationDto;
};

export type CreateOrderReqAccessDto = {
    groups?: SetAvatarUsers1ReqAccessGroupsDto;
};

export type CreateOrderResDto = {
    resource_type: 'order';
    id: string;
    created: Action;
    is_deleted: boolean;
    lifecycle: Array<Action>;
    number: string;
    customer: CreateBookingResProductCustomersItemReferenceDto;
    status: OrderStatus;
    access: CreateOrderResAccessDto;
};

export type CreateOrderResAccessDto = {
    permissions: OrderPermissionsData;
    view?: RegisterUsersResAccountMembershipsItem0Role0AccessOrderViewDto;
    groups: RegisterUsersResAccessGroupsDto;
};

export type GetOrderResDto = {
    resource_type: 'order';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    number: string;
    customer: GetEventResBookingsItem0ProductCustomersItemReferenceDto;
    price?: GetOrderResPriceDto;
    status: OrderStatus;
    bookings?: Array<GetEventResBookingsItem0Dto | GetEventResBookingsItem1Dto>;
    access: GetOrderResAccessDto;
    summary?: GetOrderResSummaryDto;
    attachments?: GetUserResProfileAttachmentsDto;
    confirmed_on_checkout?: boolean;
};

export type GetOrderResPriceDto = {
    subtotal: number;
    discount?: DiscountData;
    total: number;
    currency?: Currency;
};

export type GetOrderResAccessDto = {
    permissions: OrderPermissionsData;
    view?: GetUserResAccountMembershipsItem0Role0AccessOrderViewDto;
    groups: GetUserResAccessGroupsDto;
};

export type GetOrderResSummaryDto = {
    counts: GetOrderResSummaryCountsDto;
};

export type GetOrderResSummaryCountsDto = {
    bookings?: number;
    products?: number;
    customers?: number;
};

export type CancelOrdersReqDto = {
    message: string;
};

export type CancelOrdersResDto = {
    resource_type?: 'order';
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle: Array<Action>;
    number?: string;
    customer?: CancelEventResBookingsItem0ProductCustomersItemReferenceDto;
    price?: CancelOrdersResPriceDto;
    status?: OrderStatus;
    bookings?: Array<
        CancelEventResBookingsItem0Dto | CancelEventResBookingsItem1Dto
    >;
    access?: CancelOrdersResAccessDto;
    summary?: CancelOrdersResSummaryDto;
    attachments?: UpdateUserResProfileAttachmentsDto;
    confirmed_on_checkout?: boolean;
};

export type CancelOrdersResPriceDto = {
    discount?: DiscountData;
    currency?: Currency;
};

export type CancelOrdersResAccessDto = {
    permissions: OrderPermissionsData;
    view?: UpdateUserResAccountMembershipsItem0Role0AccessOrderViewDto;
    groups?: UpdateUserResAccessGroupsDto;
};

export type CancelOrdersResSummaryDto = {
    counts: CancelOrdersResSummaryCountsDto;
};

export type CancelOrdersResSummaryCountsDto = {
    bookings?: number;
    products?: number;
    customers?: number;
};

export type GetActivatedOtasResDto = {
    items?: Array<
        | GetActivatedOtasResItem0Dto
        | GetActivatedOtasResItem1Dto
        | GetActivatedOtasResItem2Dto
    >;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetActivatedOtasResItem0Dto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: 'human';
    account: GetActivatedOtasResItem0AccountDto;
    access: GetActivatedOtasResItem0AccessDto;
    profile: GetActivatedOtasResItem0ProfileDto;
    subscription:
        | FreeSubscriptionData
        | ProfessionalSubscriptionData
        | TeamSubscriptionData
        | EnterpriseSubscriptionData;
};

export type GetActivatedOtasResItem0AccountDto = {
    memberships: GetActivatedOtasResItem0AccountMembershipsDto;
    workspaces: GetActivatedOtasResItem0AccountWorkspacesDto;
    settings: GetActivatedOtasResItem0AccountSettingsDto;
};

export type GetActivatedOtasResItem0AccountMembershipsDto = {
    items: Array<
        | GetTeamsResItemMembersItem0Membership0Dto
        | GetTeamsResItemMembersItem0Membership1Dto
    >;
};

export type GetActivatedOtasResItem0AccountWorkspacesDto = {
    items: Array<GetActivatedOtasResItem0AccountWorkspacesItemDto>;
    current: GetActivatedOtasResItem0AccountWorkspacesItemDto;
};

export type GetActivatedOtasResItem0AccountWorkspacesItemDto = {
    id: string;
    name: string;
    membership:
        | GetTeamsResItemMembersItem0Membership0Dto
        | GetTeamsResItemMembersItem0Membership1Dto;
};

export type GetActivatedOtasResItem0AccountSettingsDto = {
    financial: GetTeamsResItemAccountSettingsFinancialDto;
    calendar: GetTeamsResItemAccountSettingsCalendarDto;
    policies?: Array<Policy>;
};

export type GetActivatedOtasResItem0AccessDto = {
    permissions: UserPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessUserViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type GetActivatedOtasResItem0ProfileDto = {
    contact_details?: GetTeamsResItemMembersItem0ReferenceContactDetailsDto;
    attachments?: GetProductsResItem0AttachmentsDto;
    name: PersonNameData;
    birth_details?: BirthDetailsData;
    passport?: Passport;
    languages: Array<Language>;
    organization?: GetTeamsResItemMembersItem0ReferenceOrganizationDto;
    occupation: UserOccupation;
    avatar?: GetProductsResItem0AttachmentsItemReference0Dto;
};

export type GetActivatedOtasResItem1Dto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: 'ota';
    account: GetActivatedOtasResItem1AccountDto;
    name: OtaName;
    supplier_id?: number;
};

export type GetActivatedOtasResItem1AccountDto = {
    memberships: GetActivatedOtasResItem0AccountMembershipsDto;
    workspaces: GetActivatedOtasResItem0AccountWorkspacesDto;
};

export type GetActivatedOtasResItem2Dto = {
    resource_type: ResourceType;
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    type: 'widget';
    account: GetActivatedOtasResItem1AccountDto;
    name: WidgetName;
    active?: boolean;
};

export type GetLocationsResDto = {
    items?: Array<GetLocationsResItemDto>;
    total_count?: number;
    next_id?: string;
    next_page_number?: number;
    page_size?: number;
};

export type GetLocationsResItemDto = {
    resource_type: 'location';
    resource_id?: string;
    id: string;
    created: Action;
    last_updated?: Action;
    deleted?: Action;
    is_deleted: boolean;
    cancelled?: Action;
    lifecycle?: Array<Action>;
    name: string;
    type: RouteItemType;
    access?: GetLocationsResItemAccessDto;
};

export type GetLocationsResItemAccessDto = {
    permissions: LocationPermissionsData;
    view?: GetTeamsResItemMembersItem0Membership0Role0AccessLocationViewDto;
    groups: GetTeamsResItemAccessGroupsDto;
};

export type ActionByHumanDto = {
    type: 'application';
    id: string;
    name: string;
};

export type ActionByApplicationDto = {
    type: 'human';
    id: string;
    name: PersonNameData;
};

export type ActionByOtaDto = {
    type: 'ota';
    id: string;
    name: OtaName;
};

export type ActionByOtaSysDto = {
    type: 'ota_sys';
    id: string;
    name: OtaName;
};

export type UpdatedField = {
    name: string;
    value: unknown;
};

export type Action = {
    type: ActivityType;
    by:
        | ActionByHumanDto
        | ActionByApplicationDto
        | ActionByOtaDto
        | ActionByOtaSysDto
        | RegisterUsersResCreatedBy4Dto;
    at: number;
    updates?: Array<UpdatedField>;
    message?: string;
};

export type GetProjectData = {
    body?: never;
    path: {
        subscription_key: string;
    };
    query?: never;
    url: '/api/v1/project/subscriptions/{subscription_key}';
};

export type GetProjectErrors = {
    422: HttpValidationError;
};

export type GetProjectError = GetProjectErrors[keyof GetProjectErrors];

export type GetProjectResponses = {
    200:
        | FreeSubscriptionData
        | ProfessionalSubscriptionData
        | TeamSubscriptionData
        | EnterpriseSubscriptionData;
};

export type GetProjectResponse = GetProjectResponses[keyof GetProjectResponses];

export type GetManifestData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/project/manifest';
};

export type GetManifestResponses = {
    200: BaseManifestData;
};

export type GetManifestResponse =
    GetManifestResponses[keyof GetManifestResponses];

export type GetCountryCitiesData = {
    body?: never;
    path: {
        country_name: string;
    };
    query?: never;
    url: '/api/v1/project/manifest/{country_name}/cities';
};

export type GetCountryCitiesErrors = {
    422: HttpValidationError;
};

export type GetCountryCitiesError =
    GetCountryCitiesErrors[keyof GetCountryCitiesErrors];

export type GetCountryCitiesResponses = {
    200: unknown;
};

export type RegisterUsersData = {
    body: RegisterUsersReqDto | RegisterUsersReq1Dto | RegisterUsersReq2Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/register';
};

export type RegisterUsersErrors = {
    422: HttpValidationError;
};

export type RegisterUsersError = RegisterUsersErrors[keyof RegisterUsersErrors];

export type RegisterUsersResponses = {
    200: RegisterUsersResDto | RegisterUsersRes1Dto | RegisterUsersRes2Dto;
};

export type RegisterUsersResponse =
    RegisterUsersResponses[keyof RegisterUsersResponses];

export type GetUserData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me';
};

export type GetUserErrors = {
    422: HttpValidationError;
};

export type GetUserError = GetUserErrors[keyof GetUserErrors];

export type GetUserResponses = {
    200: GetUserResDto | GetUserRes1Dto | GetUserRes2Dto;
};

export type GetUserResponse = GetUserResponses[keyof GetUserResponses];

export type UpdateUserData = {
    body: UpdateUserReqDto | UpdateUserReq1Dto | UpdateUserReq2Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me';
};

export type UpdateUserErrors = {
    422: HttpValidationError;
};

export type UpdateUserError = UpdateUserErrors[keyof UpdateUserErrors];

export type UpdateUserResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type UpdateUserResponse = UpdateUserResponses[keyof UpdateUserResponses];

export type DeleteUserAvatarData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/avatar';
};

export type DeleteUserAvatarErrors = {
    422: HttpValidationError;
};

export type DeleteUserAvatarError =
    DeleteUserAvatarErrors[keyof DeleteUserAvatarErrors];

export type DeleteUserAvatarResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type DeleteUserAvatarResponse =
    DeleteUserAvatarResponses[keyof DeleteUserAvatarResponses];

export type SetAvatarUsers1Data = {
    body:
        | SetAvatarUsers1ReqDto
        | SetAvatarUsers1Req1Dto
        | SetAvatarUsers1Req2Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/avatar';
};

export type SetAvatarUsers1Errors = {
    422: HttpValidationError;
};

export type SetAvatarUsers1Error =
    SetAvatarUsers1Errors[keyof SetAvatarUsers1Errors];

export type SetAvatarUsers1Responses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type SetAvatarUsers1Response =
    SetAvatarUsers1Responses[keyof SetAvatarUsers1Responses];

export type UpdateAttachmentsUsersData = {
    body: UpdateUserReqProfileAttachmentsDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/attachments';
};

export type UpdateAttachmentsUsersErrors = {
    422: HttpValidationError;
};

export type UpdateAttachmentsUsersError =
    UpdateAttachmentsUsersErrors[keyof UpdateAttachmentsUsersErrors];

export type UpdateAttachmentsUsersResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type UpdateAttachmentsUsersResponse =
    UpdateAttachmentsUsersResponses[keyof UpdateAttachmentsUsersResponses];

export type UpdateCurrencyUsersData = {
    body: CurrencySetting;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/currency';
};

export type UpdateCurrencyUsersErrors = {
    422: HttpValidationError;
};

export type UpdateCurrencyUsersError =
    UpdateCurrencyUsersErrors[keyof UpdateCurrencyUsersErrors];

export type UpdateCurrencyUsersResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type UpdateCurrencyUsersResponse =
    UpdateCurrencyUsersResponses[keyof UpdateCurrencyUsersResponses];

export type SetCurrentWorkspaceUsersData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        workspace_id: string;
    };
    query?: never;
    url: '/api/v1/users/me/workspace/{workspace_id}';
};

export type SetCurrentWorkspaceUsersErrors = {
    422: HttpValidationError;
};

export type SetCurrentWorkspaceUsersError =
    SetCurrentWorkspaceUsersErrors[keyof SetCurrentWorkspaceUsersErrors];

export type SetCurrentWorkspaceUsersResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type SetCurrentWorkspaceUsersResponse =
    SetCurrentWorkspaceUsersResponses[keyof SetCurrentWorkspaceUsersResponses];

export type AcceptInvitationUsersData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        key: string;
    };
    query?: never;
    url: '/api/v1/users/me/accept_invitation/{key}';
};

export type AcceptInvitationUsersErrors = {
    422: HttpValidationError;
};

export type AcceptInvitationUsersError =
    AcceptInvitationUsersErrors[keyof AcceptInvitationUsersErrors];

export type AcceptInvitationUsersResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type AcceptInvitationUsersResponse =
    AcceptInvitationUsersResponses[keyof AcceptInvitationUsersResponses];

export type UpdateUserPoliciesData = {
    body: Array<Policy>;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/policies';
};

export type UpdateUserPoliciesErrors = {
    422: HttpValidationError;
};

export type UpdateUserPoliciesError =
    UpdateUserPoliciesErrors[keyof UpdateUserPoliciesErrors];

export type UpdateUserPoliciesResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type UpdateUserPoliciesResponse =
    UpdateUserPoliciesResponses[keyof UpdateUserPoliciesResponses];

export type UpdatePaymentGatewayUsersData = {
    body: UpdateUserReqAccountSettingsFinancialPaymentGatewaysDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/me/payment-gateways';
};

export type UpdatePaymentGatewayUsersErrors = {
    422: HttpValidationError;
};

export type UpdatePaymentGatewayUsersError =
    UpdatePaymentGatewayUsersErrors[keyof UpdatePaymentGatewayUsersErrors];

export type UpdatePaymentGatewayUsersResponses = {
    200: UpdateUserResDto | UpdateUserRes1Dto | UpdateUserRes2Dto;
};

export type UpdatePaymentGatewayUsersResponse =
    UpdatePaymentGatewayUsersResponses[keyof UpdatePaymentGatewayUsersResponses];

export type GetTeamsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/teams';
};

export type GetTeamsErrors = {
    422: HttpValidationError;
};

export type GetTeamsError = GetTeamsErrors[keyof GetTeamsErrors];

export type GetTeamsResponses = {
    200: GetTeamsResDto;
};

export type GetTeamsResponse = GetTeamsResponses[keyof GetTeamsResponses];

export type CreateTeamData = {
    body: CreateTeamReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/teams';
};

export type CreateTeamErrors = {
    422: HttpValidationError;
};

export type CreateTeamError = CreateTeamErrors[keyof CreateTeamErrors];

export type CreateTeamResponses = {
    200: CreateTeamResDto;
};

export type CreateTeamResponse = CreateTeamResponses[keyof CreateTeamResponses];

export type DeleteTeamData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: {
        reason?: string;
    };
    url: '/api/v1/teams/{team_id}';
};

export type DeleteTeamErrors = {
    422: HttpValidationError;
};

export type DeleteTeamError = DeleteTeamErrors[keyof DeleteTeamErrors];

export type DeleteTeamResponses = {
    204: void;
};

export type DeleteTeamResponse = DeleteTeamResponses[keyof DeleteTeamResponses];

export type GetTeamData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}';
};

export type GetTeamErrors = {
    422: HttpValidationError;
};

export type GetTeamError = GetTeamErrors[keyof GetTeamErrors];

export type GetTeamResponses = {
    200: GetTeamResDto;
};

export type GetTeamResponse = GetTeamResponses[keyof GetTeamResponses];

export type UpdateMembersTeamsData = {
    body: UpdateMembersTeamsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: {
        no_email?: boolean;
    };
    url: '/api/v1/teams/{team_id}/members';
};

export type UpdateMembersTeamsErrors = {
    422: HttpValidationError;
};

export type UpdateMembersTeamsError =
    UpdateMembersTeamsErrors[keyof UpdateMembersTeamsErrors];

export type UpdateMembersTeamsResponses = {
    200: UpdateMembersTeamsResDto;
};

export type UpdateMembersTeamsResponse =
    UpdateMembersTeamsResponses[keyof UpdateMembersTeamsResponses];

export type UpdateTeamSettingsData = {
    body: UpdateTeamSettingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}/account/settings';
};

export type UpdateTeamSettingsErrors = {
    422: HttpValidationError;
};

export type UpdateTeamSettingsError =
    UpdateTeamSettingsErrors[keyof UpdateTeamSettingsErrors];

export type UpdateTeamSettingsResponses = {
    200: UpdateMembersTeamsResDto;
};

export type UpdateTeamSettingsResponse =
    UpdateTeamSettingsResponses[keyof UpdateTeamSettingsResponses];

export type GetTeams1Data = {
    body: GetTeams1ReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/teams/community_members';
};

export type GetTeams1Errors = {
    422: HttpValidationError;
};

export type GetTeams1Error = GetTeams1Errors[keyof GetTeams1Errors];

export type GetTeams1Responses = {
    200: GetTeamsResItemMembersDto;
};

export type GetTeams1Response = GetTeams1Responses[keyof GetTeams1Responses];

export type InviteMemberTeamsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
        member_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}/members/{member_id}/invite';
};

export type InviteMemberTeamsErrors = {
    422: HttpValidationError;
};

export type InviteMemberTeamsError =
    InviteMemberTeamsErrors[keyof InviteMemberTeamsErrors];

export type InviteMemberTeamsResponses = {
    200: unknown;
};

export type UpdateCurrencyTeamsData = {
    body: CurrencySetting;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}/currency';
};

export type UpdateCurrencyTeamsErrors = {
    422: HttpValidationError;
};

export type UpdateCurrencyTeamsError =
    UpdateCurrencyTeamsErrors[keyof UpdateCurrencyTeamsErrors];

export type UpdateCurrencyTeamsResponses = {
    200: UpdateMembersTeamsResDto;
};

export type UpdateCurrencyTeamsResponse =
    UpdateCurrencyTeamsResponses[keyof UpdateCurrencyTeamsResponses];

export type UpdateTeamPoliciesData = {
    body: Array<Policy>;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}/policies';
};

export type UpdateTeamPoliciesErrors = {
    422: HttpValidationError;
};

export type UpdateTeamPoliciesError =
    UpdateTeamPoliciesErrors[keyof UpdateTeamPoliciesErrors];

export type UpdateTeamPoliciesResponses = {
    200: UpdateMembersTeamsResDto;
};

export type UpdateTeamPoliciesResponse =
    UpdateTeamPoliciesResponses[keyof UpdateTeamPoliciesResponses];

export type UpdatePaymentGatewayTeamsData = {
    body: UpdateUserReqAccountSettingsFinancialPaymentGatewaysDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        team_id: string;
    };
    query?: never;
    url: '/api/v1/teams/{team_id}/payment-gateways';
};

export type UpdatePaymentGatewayTeamsErrors = {
    422: HttpValidationError;
};

export type UpdatePaymentGatewayTeamsError =
    UpdatePaymentGatewayTeamsErrors[keyof UpdatePaymentGatewayTeamsErrors];

export type UpdatePaymentGatewayTeamsResponses = {
    200: UpdateMembersTeamsResDto;
};

export type UpdatePaymentGatewayTeamsResponse =
    UpdatePaymentGatewayTeamsResponses[keyof UpdatePaymentGatewayTeamsResponses];

export type ComputeAvailabilityData = {
    body: ComputeAvailabilityReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/availability';
};

export type ComputeAvailabilityErrors = {
    422: HttpValidationError;
};

export type ComputeAvailabilityError =
    ComputeAvailabilityErrors[keyof ComputeAvailabilityErrors];

export type ComputeAvailabilityResponses = {
    200: unknown;
};

export type GetProductsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        action?: 'created' | 'last_updated' | 'deleted';
        at_start?: number;
        at_end?: number;
        by_id?: string;
        by_name?: string;
        types?: Array<ProductType>;
        text_search?: string;
        references_only?: boolean;
        status?: 'active' | 'inactive' | 'all';
        resolve_schedule?: boolean;
        available_from_ts?: number;
        available_to_ts?: number;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/products';
};

export type GetProductsErrors = {
    422: HttpValidationError;
};

export type GetProductsError = GetProductsErrors[keyof GetProductsErrors];

export type GetProductsResponses = {
    200: ProductReferenceProjectionList | GetProductsResDto;
};

export type GetProductsResponse =
    GetProductsResponses[keyof GetProductsResponses];

export type CreateProductData = {
    body: CreateProductReqDto | CreateProductReq1Dto | CreateProductReq2Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/products';
};

export type CreateProductErrors = {
    422: HttpValidationError;
};

export type CreateProductError = CreateProductErrors[keyof CreateProductErrors];

export type CreateProductResponses = {
    200: CreateProductResDto | CreateProductRes1Dto | CreateProductRes2Dto;
};

export type CreateProductResponse =
    CreateProductResponses[keyof CreateProductResponses];

export type GetProducts1Data = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        types?: Array<ProductType>;
        page_number?: number;
        page_size?: number;
    };
    url: '/api/v1/products/references';
};

export type GetProducts1Errors = {
    422: HttpValidationError;
};

export type GetProducts1Error = GetProducts1Errors[keyof GetProducts1Errors];

export type GetProducts1Responses = {
    200: unknown;
};

export type GetProductFittingCapacitiesData = {
    body: PaxData;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/fitting_capacities';
};

export type GetProductFittingCapacitiesErrors = {
    422: HttpValidationError;
};

export type GetProductFittingCapacitiesError =
    GetProductFittingCapacitiesErrors[keyof GetProductFittingCapacitiesErrors];

export type GetProductFittingCapacitiesResponses = {
    200: GetProductFittingCapacitiesResDto;
};

export type GetProductFittingCapacitiesResponse =
    GetProductFittingCapacitiesResponses[keyof GetProductFittingCapacitiesResponses];

export type GetReportsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        report_type?: ReportType;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/reports';
};

export type GetReportsErrors = {
    422: HttpValidationError;
};

export type GetReportsError = GetReportsErrors[keyof GetReportsErrors];

export type GetReportsResponses = {
    200: GetReportsResDto;
};

export type GetReportsResponse = GetReportsResponses[keyof GetReportsResponses];

export type CreateReportReportsData = {
    body: BookingReport;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/reports';
};

export type CreateReportReportsErrors = {
    422: HttpValidationError;
};

export type CreateReportReportsError =
    CreateReportReportsErrors[keyof CreateReportReportsErrors];

export type CreateReportReportsResponses = {
    200: CreateReportResponse;
};

export type CreateReportReportsResponse =
    CreateReportReportsResponses[keyof CreateReportReportsResponses];

export type GetReportData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        report_id: string;
    };
    query?: never;
    url: '/api/v1/reports/{report_id}';
};

export type GetReportErrors = {
    422: HttpValidationError;
};

export type GetReportError = GetReportErrors[keyof GetReportErrors];

export type GetReportResponses = {
    200: GetReportResDto;
};

export type GetReportResponse = GetReportResponses[keyof GetReportResponses];

export type UpdateProductData = {
    body: UpdateProductReqDto | UpdateProductReq1Dto | UpdateProductReq2Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/details';
};

export type UpdateProductErrors = {
    422: HttpValidationError;
};

export type UpdateProductError = UpdateProductErrors[keyof UpdateProductErrors];

export type UpdateProductResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductResponse =
    UpdateProductResponses[keyof UpdateProductResponses];

export type UpdatePackageDiscountData = {
    body: UpdatePackageDiscountReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/discount';
};

export type UpdatePackageDiscountErrors = {
    422: HttpValidationError;
};

export type UpdatePackageDiscountError =
    UpdatePackageDiscountErrors[keyof UpdatePackageDiscountErrors];

export type UpdatePackageDiscountResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdatePackageDiscountResponse =
    UpdatePackageDiscountResponses[keyof UpdatePackageDiscountResponses];

export type UpdateProductRoutesData = {
    body: UpdateProductRoutesReqDto | UpdateProductRoutesReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/route';
};

export type UpdateProductRoutesErrors = {
    422: HttpValidationError;
};

export type UpdateProductRoutesError =
    UpdateProductRoutesErrors[keyof UpdateProductRoutesErrors];

export type UpdateProductRoutesResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductRoutesResponse =
    UpdateProductRoutesResponses[keyof UpdateProductRoutesResponses];

export type UpdateProductCapacitiesData = {
    body: UpdateProductCapacitiesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/capacity';
};

export type UpdateProductCapacitiesErrors = {
    422: HttpValidationError;
};

export type UpdateProductCapacitiesError =
    UpdateProductCapacitiesErrors[keyof UpdateProductCapacitiesErrors];

export type UpdateProductCapacitiesResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductCapacitiesResponse =
    UpdateProductCapacitiesResponses[keyof UpdateProductCapacitiesResponses];

export type UpdateProductScheduleData = {
    body: UpdateProductScheduleReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/schedule';
};

export type UpdateProductScheduleErrors = {
    422: HttpValidationError;
};

export type UpdateProductScheduleError =
    UpdateProductScheduleErrors[keyof UpdateProductScheduleErrors];

export type UpdateProductScheduleResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductScheduleResponse =
    UpdateProductScheduleResponses[keyof UpdateProductScheduleResponses];

export type UpdateProductPricingData = {
    body: UpdateProductPricingReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/pricing';
};

export type UpdateProductPricingErrors = {
    422: HttpValidationError;
};

export type UpdateProductPricingError =
    UpdateProductPricingErrors[keyof UpdateProductPricingErrors];

export type UpdateProductPricingResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductPricingResponse =
    UpdateProductPricingResponses[keyof UpdateProductPricingResponses];

export type UpdateProductOptionsData = {
    body: UpdateProductOptionsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/options';
};

export type UpdateProductOptionsErrors = {
    422: HttpValidationError;
};

export type UpdateProductOptionsError =
    UpdateProductOptionsErrors[keyof UpdateProductOptionsErrors];

export type UpdateProductOptionsResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductOptionsResponse =
    UpdateProductOptionsResponses[keyof UpdateProductOptionsResponses];

export type UpdateProductConfigurationData = {
    body: UpdateProductConfigurationReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/configuration';
};

export type UpdateProductConfigurationErrors = {
    422: HttpValidationError;
};

export type UpdateProductConfigurationError =
    UpdateProductConfigurationErrors[keyof UpdateProductConfigurationErrors];

export type UpdateProductConfigurationResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductConfigurationResponse =
    UpdateProductConfigurationResponses[keyof UpdateProductConfigurationResponses];

export type ActivateProductData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/activate';
};

export type ActivateProductErrors = {
    422: HttpValidationError;
};

export type ActivateProductError =
    ActivateProductErrors[keyof ActivateProductErrors];

export type ActivateProductResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type ActivateProductResponse =
    ActivateProductResponses[keyof ActivateProductResponses];

export type DeactivateProductData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/deactivate';
};

export type DeactivateProductErrors = {
    422: HttpValidationError;
};

export type DeactivateProductError =
    DeactivateProductErrors[keyof DeactivateProductErrors];

export type DeactivateProductResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type DeactivateProductResponse =
    DeactivateProductResponses[keyof DeactivateProductResponses];

export type UpdateProductAttachmentsData = {
    body: UpdateUserReqProfileAttachmentsDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/attachments';
};

export type UpdateProductAttachmentsErrors = {
    422: HttpValidationError;
};

export type UpdateProductAttachmentsError =
    UpdateProductAttachmentsErrors[keyof UpdateProductAttachmentsErrors];

export type UpdateProductAttachmentsResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductAttachmentsResponse =
    UpdateProductAttachmentsResponses[keyof UpdateProductAttachmentsResponses];

export type UpdateAvailabilityProductsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query: {
        start_timestamp: number;
        end_timestamp?: number;
        available?: boolean;
        restore?: boolean;
    };
    url: '/api/v1/products/{product_id}/availability';
};

export type UpdateAvailabilityProductsErrors = {
    422: HttpValidationError;
};

export type UpdateAvailabilityProductsError =
    UpdateAvailabilityProductsErrors[keyof UpdateAvailabilityProductsErrors];

export type UpdateAvailabilityProductsResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateAvailabilityProductsResponse =
    UpdateAvailabilityProductsResponses[keyof UpdateAvailabilityProductsResponses];

export type DeleteProductData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}';
};

export type DeleteProductErrors = {
    422: HttpValidationError;
};

export type DeleteProductError = DeleteProductErrors[keyof DeleteProductErrors];

export type DeleteProductResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type DeleteProductResponse =
    DeleteProductResponses[keyof DeleteProductResponses];

export type GetProductData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}';
};

export type GetProductErrors = {
    422: HttpValidationError;
};

export type GetProductError = GetProductErrors[keyof GetProductErrors];

export type GetProductResponses = {
    200: GetProductResDto | GetProductRes1Dto | GetProductRes2Dto;
};

export type GetProductResponse = GetProductResponses[keyof GetProductResponses];

export type GenerateProductNameData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/products/generate_name';
};

export type GenerateProductNameErrors = {
    422: HttpValidationError;
};

export type GenerateProductNameError =
    GenerateProductNameErrors[keyof GenerateProductNameErrors];

export type GenerateProductNameResponses = {
    200: unknown;
};

export type UpdateProductPoliciesData = {
    body: UpdateProductPoliciesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_id: string;
    };
    query?: never;
    url: '/api/v1/products/{product_id}/policies';
};

export type UpdateProductPoliciesErrors = {
    422: HttpValidationError;
};

export type UpdateProductPoliciesError =
    UpdateProductPoliciesErrors[keyof UpdateProductPoliciesErrors];

export type UpdateProductPoliciesResponses = {
    200: UpdateProductResDto | UpdateProductRes1Dto | UpdateProductRes2Dto;
};

export type UpdateProductPoliciesResponse =
    UpdateProductPoliciesResponses[keyof UpdateProductPoliciesResponses];

export type GetOtaProductVariantsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        integrations?: Array<OtaName>;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/product_variants';
};

export type GetOtaProductVariantsErrors = {
    422: HttpValidationError;
};

export type GetOtaProductVariantsError =
    GetOtaProductVariantsErrors[keyof GetOtaProductVariantsErrors];

export type GetOtaProductVariantsResponses = {
    200: GetOtaProductVariantsResDto;
};

export type GetOtaProductVariantsResponse =
    GetOtaProductVariantsResponses[keyof GetOtaProductVariantsResponses];

export type CreateProductVariantData = {
    body: CreateProductVariantReqDto | CreateProductVariantReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/product_variants';
};

export type CreateProductVariantErrors = {
    422: HttpValidationError;
};

export type CreateProductVariantError =
    CreateProductVariantErrors[keyof CreateProductVariantErrors];

export type CreateProductVariantResponses = {
    200: CreateProductVariantResDto | CreateProductVariantRes1Dto;
};

export type CreateProductVariantResponse =
    CreateProductVariantResponses[keyof CreateProductVariantResponses];

export type DeleteOtaProductVariantData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        product_variant_id: string;
    };
    query?: never;
    url: '/api/v1/product_variants/{product_variant_id}';
};

export type DeleteOtaProductVariantErrors = {
    422: HttpValidationError;
};

export type DeleteOtaProductVariantError =
    DeleteOtaProductVariantErrors[keyof DeleteOtaProductVariantErrors];

export type DeleteOtaProductVariantResponses = {
    200: unknown;
};

export type GetEventsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        action?: 'created' | 'last_updated' | 'deleted';
        at_start?: number;
        at_end?: number;
        by_id?: string;
        by_name?: string;
        types?: Array<string>;
        statuses?: Array<EventStatus>;
        start_ts?: number;
        end_ts?: number;
        text_search?: string;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
        bookings?: boolean;
    };
    url: '/api/v1/events';
};

export type GetEventsErrors = {
    422: HttpValidationError;
};

export type GetEventsError = GetEventsErrors[keyof GetEventsErrors];

export type GetEventsResponses = {
    200: GetEventsResDto;
};

export type GetEventsResponse = GetEventsResponses[keyof GetEventsResponses];

export type CreateEventData = {
    body: CreateEventReqDto | CreateEventReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/events';
};

export type CreateEventErrors = {
    422: HttpValidationError;
};

export type CreateEventError = CreateEventErrors[keyof CreateEventErrors];

export type CreateEventResponses = {
    200: CreateEventResDto | CreateEventRes1Dto;
};

export type CreateEventResponse =
    CreateEventResponses[keyof CreateEventResponses];

export type GetEventData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}';
};

export type GetEventErrors = {
    422: HttpValidationError;
};

export type GetEventError = GetEventErrors[keyof GetEventErrors];

export type GetEventResponses = {
    200: GetEventResDto | GetEventRes1Dto;
};

export type GetEventResponse = GetEventResponses[keyof GetEventResponses];

export type CancelEventData = {
    body: CancelEventReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/events/{event_id}/cancel';
};

export type CancelEventErrors = {
    422: HttpValidationError;
};

export type CancelEventError = CancelEventErrors[keyof CancelEventErrors];

export type CancelEventResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type CancelEventResponse =
    CancelEventResponses[keyof CancelEventResponses];

export type UpdateEventDateData = {
    body: PeriodData;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}/date';
};

export type UpdateEventDateErrors = {
    422: HttpValidationError;
};

export type UpdateEventDateError =
    UpdateEventDateErrors[keyof UpdateEventDateErrors];

export type UpdateEventDateResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateEventDateResponse =
    UpdateEventDateResponses[keyof UpdateEventDateResponses];

export type UpdateEventStaffData = {
    body: UpdateEventStaffReqDto | UpdateEventStaffReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}/staff';
};

export type UpdateEventStaffErrors = {
    422: HttpValidationError;
};

export type UpdateEventStaffError =
    UpdateEventStaffErrors[keyof UpdateEventStaffErrors];

export type UpdateEventStaffResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateEventStaffResponse =
    UpdateEventStaffResponses[keyof UpdateEventStaffResponses];

export type UpdateEventAssetsData = {
    body: UpdateEventAssetsReqDto | UpdateEventAssetsReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}/assets';
};

export type UpdateEventAssetsErrors = {
    422: HttpValidationError;
};

export type UpdateEventAssetsError =
    UpdateEventAssetsErrors[keyof UpdateEventAssetsErrors];

export type UpdateEventAssetsResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateEventAssetsResponse =
    UpdateEventAssetsResponses[keyof UpdateEventAssetsResponses];

export type UpdateCapacityEventsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
        capacity_id: string;
    };
    query?: {
        sync_bookings?: boolean;
    };
    url: '/api/v1/events/{event_id}/capacity/{capacity_id}';
};

export type UpdateCapacityEventsErrors = {
    422: HttpValidationError;
};

export type UpdateCapacityEventsError =
    UpdateCapacityEventsErrors[keyof UpdateCapacityEventsErrors];

export type UpdateCapacityEventsResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateCapacityEventsResponse =
    UpdateCapacityEventsResponses[keyof UpdateCapacityEventsResponses];

export type UpdateEventNotesData = {
    body: UpdateEventNotesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}/notes';
};

export type UpdateEventNotesErrors = {
    422: HttpValidationError;
};

export type UpdateEventNotesError =
    UpdateEventNotesErrors[keyof UpdateEventNotesErrors];

export type UpdateEventNotesResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateEventNotesResponse =
    UpdateEventNotesResponses[keyof UpdateEventNotesResponses];

export type UpdateLockEventsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query: {
        locked: boolean;
    };
    url: '/api/v1/events/{event_id}/lock';
};

export type UpdateLockEventsErrors = {
    422: HttpValidationError;
};

export type UpdateLockEventsError =
    UpdateLockEventsErrors[keyof UpdateLockEventsErrors];

export type UpdateLockEventsResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type UpdateLockEventsResponse =
    UpdateLockEventsResponses[keyof UpdateLockEventsResponses];

export type FinishEventsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        event_id: string;
    };
    query?: never;
    url: '/api/v1/events/{event_id}/finish';
};

export type FinishEventsErrors = {
    422: HttpValidationError;
};

export type FinishEventsError = FinishEventsErrors[keyof FinishEventsErrors];

export type FinishEventsResponses = {
    200: CancelEventResDto | CancelEventRes1Dto;
};

export type FinishEventsResponse =
    FinishEventsResponses[keyof FinishEventsResponses];

export type GetCapacitiesData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        ids?: Array<string>;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/capacities';
};

export type GetCapacitiesErrors = {
    422: HttpValidationError;
};

export type GetCapacitiesError = GetCapacitiesErrors[keyof GetCapacitiesErrors];

export type GetCapacitiesResponses = {
    200: GetCapacitiesResDto;
};

export type GetCapacitiesResponse =
    GetCapacitiesResponses[keyof GetCapacitiesResponses];

export type CreateManyCapacitiesData = {
    body: CreateManyCapacitiesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/capacities';
};

export type CreateManyCapacitiesErrors = {
    422: HttpValidationError;
};

export type CreateManyCapacitiesError =
    CreateManyCapacitiesErrors[keyof CreateManyCapacitiesErrors];

export type CreateManyCapacitiesResponses = {
    200: CreateManyCapacitiesResDto;
};

export type CreateManyCapacitiesResponse =
    CreateManyCapacitiesResponses[keyof CreateManyCapacitiesResponses];

export type GetCapacityData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        capacity_id: string;
    };
    query?: never;
    url: '/api/v1/capacities/{capacity_id}';
};

export type GetCapacityErrors = {
    422: HttpValidationError;
};

export type GetCapacityError = GetCapacityErrors[keyof GetCapacityErrors];

export type GetCapacityResponses = {
    200: GetCapacityResDto;
};

export type GetCapacityResponse =
    GetCapacityResponses[keyof GetCapacityResponses];

export type GetSchedulesData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        ids?: Array<string>;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/schedules';
};

export type GetSchedulesErrors = {
    422: HttpValidationError;
};

export type GetSchedulesError = GetSchedulesErrors[keyof GetSchedulesErrors];

export type GetSchedulesResponses = {
    200: GetSchedulesResDto;
};

export type GetSchedulesResponse =
    GetSchedulesResponses[keyof GetSchedulesResponses];

export type CreateManySchedulesData = {
    body: CreateManySchedulesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/schedules';
};

export type CreateManySchedulesErrors = {
    422: HttpValidationError;
};

export type CreateManySchedulesError =
    CreateManySchedulesErrors[keyof CreateManySchedulesErrors];

export type CreateManySchedulesResponses = {
    200: CreateManySchedulesResDto;
};

export type CreateManySchedulesResponse =
    CreateManySchedulesResponses[keyof CreateManySchedulesResponses];

export type GetBookingStatsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query: {
        granularity: BookingStatsGranularity;
        start_timestamp: number;
        end_timestamp?: number;
    };
    url: '/api/v1/stats/booking';
};

export type GetBookingStatsErrors = {
    422: HttpValidationError;
};

export type GetBookingStatsError =
    GetBookingStatsErrors[keyof GetBookingStatsErrors];

export type GetBookingStatsResponses = {
    200: StatsData;
};

export type GetBookingStatsResponse =
    GetBookingStatsResponses[keyof GetBookingStatsResponses];

export type GetAssetsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        text_search?: string;
    };
    url: '/api/v1/assets';
};

export type GetAssetsErrors = {
    422: HttpValidationError;
};

export type GetAssetsError = GetAssetsErrors[keyof GetAssetsErrors];

export type GetAssetsResponses = {
    200: GetAssetsResDto;
};

export type GetAssetsResponse = GetAssetsResponses[keyof GetAssetsResponses];

export type CreateAssetData = {
    body: CreateAssetReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/assets';
};

export type CreateAssetErrors = {
    422: HttpValidationError;
};

export type CreateAssetError = CreateAssetErrors[keyof CreateAssetErrors];

export type CreateAssetResponses = {
    200: CreateAssetResDto;
};

export type CreateAssetResponse =
    CreateAssetResponses[keyof CreateAssetResponses];

export type GetAssetData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        asset_id: string;
    };
    query?: never;
    url: '/api/v1/assets/{asset_id}';
};

export type GetAssetErrors = {
    422: HttpValidationError;
};

export type GetAssetError = GetAssetErrors[keyof GetAssetErrors];

export type GetAssetResponses = {
    200: GetAssetResDto;
};

export type GetAssetResponse = GetAssetResponses[keyof GetAssetResponses];

export type GetBookingsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        action?: 'created' | 'last_updated' | 'deleted';
        at_start?: number;
        at_end?: number;
        by_id?: string;
        by_name?: string;
        product_types?: Array<string>;
        statuses?: Array<BookingStatus>;
        order_number?: string;
        event_id?: string;
        start_ts?: number;
        end_ts?: number;
        source_type?: BookingSourceType;
        source_name?: string;
        source_email?: unknown;
        text_search?: string;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
        package_group_id?: string;
    };
    url: '/api/v1/bookings';
};

export type GetBookingsErrors = {
    422: HttpValidationError;
};

export type GetBookingsError = GetBookingsErrors[keyof GetBookingsErrors];

export type GetBookingsResponses = {
    200: GetBookingsResDto;
};

export type GetBookingsResponse =
    GetBookingsResponses[keyof GetBookingsResponses];

export type CreateBookingData = {
    body: CreateBookingReqDto | CreateBookingReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings';
};

export type CreateBookingErrors = {
    422: HttpValidationError;
};

export type CreateBookingError = CreateBookingErrors[keyof CreateBookingErrors];

export type CreateBookingResponses = {
    200: CreateBookingResDto | CreateBookingRes1Dto;
};

export type CreateBookingResponse =
    CreateBookingResponses[keyof CreateBookingResponses];

export type CreatePackageBookingsData = {
    body: CreatePackageBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings/package';
};

export type CreatePackageBookingsErrors = {
    422: HttpValidationError;
};

export type CreatePackageBookingsError =
    CreatePackageBookingsErrors[keyof CreatePackageBookingsErrors];

export type CreatePackageBookingsResponses = {
    200: Array<CreateBookingResDto | CreateBookingRes1Dto>;
};

export type CreatePackageBookingsResponse =
    CreatePackageBookingsResponses[keyof CreatePackageBookingsResponses];

export type GetBookingData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{booking_id}';
};

export type GetBookingErrors = {
    422: HttpValidationError;
};

export type GetBookingError = GetBookingErrors[keyof GetBookingErrors];

export type GetBookingResponses = {
    200: GetBookingResDto | GetBookingRes1Dto;
};

export type GetBookingResponse = GetBookingResponses[keyof GetBookingResponses];

export type UpdateEventBookingsData = {
    body: UpdateEventBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: {
        sync_pricing?: boolean;
        superuser?: boolean;
    };
    url: '/api/v1/bookings/{booking_id}/event';
};

export type UpdateEventBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateEventBookingsError =
    UpdateEventBookingsErrors[keyof UpdateEventBookingsErrors];

export type UpdateEventBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateEventBookingsResponse =
    UpdateEventBookingsResponses[keyof UpdateEventBookingsResponses];

export type UpdateCustomersBookingsData = {
    body: UpdateCustomersBookingsReqDto | UpdateCustomersBookingsReq1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings/{booking_id}/customers';
};

export type UpdateCustomersBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateCustomersBookingsError =
    UpdateCustomersBookingsErrors[keyof UpdateCustomersBookingsErrors];

export type UpdateCustomersBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateCustomersBookingsResponse =
    UpdateCustomersBookingsResponses[keyof UpdateCustomersBookingsResponses];

export type UpdateProductOptionsBookingsData = {
    body: UpdateProductOptionsBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{booking_id}/product_options';
};

export type UpdateProductOptionsBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateProductOptionsBookingsError =
    UpdateProductOptionsBookingsErrors[keyof UpdateProductOptionsBookingsErrors];

export type UpdateProductOptionsBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateProductOptionsBookingsResponse =
    UpdateProductOptionsBookingsResponses[keyof UpdateProductOptionsBookingsResponses];

export type UpdateStatusBookingsData = {
    body: UpdateStatusBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings/{booking_id}/status';
};

export type UpdateStatusBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateStatusBookingsError =
    UpdateStatusBookingsErrors[keyof UpdateStatusBookingsErrors];

export type UpdateStatusBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateStatusBookingsResponse =
    UpdateStatusBookingsResponses[keyof UpdateStatusBookingsResponses];

export type UpdateBookingSourceBookingsData = {
    body:
        | UpdateProductPricingReqItemDependenciesSource0Dto
        | UpdateProductPricingReqItemDependenciesSource1Dto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings/{booking_id}/source';
};

export type UpdateBookingSourceBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateBookingSourceBookingsError =
    UpdateBookingSourceBookingsErrors[keyof UpdateBookingSourceBookingsErrors];

export type UpdateBookingSourceBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateBookingSourceBookingsResponse =
    UpdateBookingSourceBookingsResponses[keyof UpdateBookingSourceBookingsResponses];

export type UpdateTransactionsBookingsData = {
    body: UpdateTransactionsBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{booking_id}/transactions';
};

export type UpdateTransactionsBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateTransactionsBookingsError =
    UpdateTransactionsBookingsErrors[keyof UpdateTransactionsBookingsErrors];

export type UpdateTransactionsBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateTransactionsBookingsResponse =
    UpdateTransactionsBookingsResponses[keyof UpdateTransactionsBookingsResponses];

export type UpdateBookingNotesBookingsData = {
    body: UpdateEventNotesReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: never;
    url: '/api/v1/bookings/{booking_id}/notes';
};

export type UpdateBookingNotesBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateBookingNotesBookingsError =
    UpdateBookingNotesBookingsErrors[keyof UpdateBookingNotesBookingsErrors];

export type UpdateBookingNotesBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateBookingNotesBookingsResponse =
    UpdateBookingNotesBookingsResponses[keyof UpdateBookingNotesBookingsResponses];

export type UpdateDiscountBookingsData = {
    body: DiscountData;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        booking_id: string;
    };
    query?: {
        superuser?: boolean;
    };
    url: '/api/v1/bookings/{booking_id}/discount';
};

export type UpdateDiscountBookingsErrors = {
    422: HttpValidationError;
};

export type UpdateDiscountBookingsError =
    UpdateDiscountBookingsErrors[keyof UpdateDiscountBookingsErrors];

export type UpdateDiscountBookingsResponses = {
    200: UpdateEventBookingsResDto | UpdateEventBookingsRes1Dto;
};

export type UpdateDiscountBookingsResponse =
    UpdateDiscountBookingsResponses[keyof UpdateDiscountBookingsResponses];

export type ComputePriceBookingsData = {
    body: CreateBookingReqProductDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/bookings/compute_price';
};

export type ComputePriceBookingsErrors = {
    422: HttpValidationError;
};

export type ComputePriceBookingsError =
    ComputePriceBookingsErrors[keyof ComputePriceBookingsErrors];

export type ComputePriceBookingsResponses = {
    200: CreateBookingResFinancialsDto;
};

export type ComputePriceBookingsResponse =
    ComputePriceBookingsResponses[keyof ComputePriceBookingsResponses];

export type ComputePackagePriceBookingsData = {
    body: ComputePackagePriceBookingsReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/bookings/package/compute_price';
};

export type ComputePackagePriceBookingsErrors = {
    422: HttpValidationError;
};

export type ComputePackagePriceBookingsError =
    ComputePackagePriceBookingsErrors[keyof ComputePackagePriceBookingsErrors];

export type ComputePackagePriceBookingsResponses = {
    200: ComputePackagePriceBookingsResDto;
};

export type ComputePackagePriceBookingsResponse =
    ComputePackagePriceBookingsResponses[keyof ComputePackagePriceBookingsResponses];

export type ExportBookingsExportData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query: {
        filetype?: 'xlsx';
        filename: string;
        action?: 'created' | 'last_updated' | 'deleted';
        at_start?: number;
        at_end?: number;
        by_id?: string;
        by_name?: string;
        product_types?: Array<string>;
        statuses?: Array<BookingStatus>;
        order_number?: string;
        event_id?: string;
        start_ts?: number;
        end_ts?: number;
        source_type?: BookingSourceType;
        source_name?: string;
        source_email?: unknown;
        text_search?: string;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/export/bookings';
};

export type ExportBookingsExportErrors = {
    422: HttpValidationError;
};

export type ExportBookingsExportError =
    ExportBookingsExportErrors[keyof ExportBookingsExportErrors];

export type ExportBookingsExportResponses = {
    200:
        | ExportBookingsExportResDto
        | ExportBookingsExportRes1Dto
        | ExportBookingsExportRes2Dto;
};

export type ExportBookingsExportResponse =
    ExportBookingsExportResponses[keyof ExportBookingsExportResponses];

export type GetCustomerData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        name?: string;
        email?: string;
        phone_number?: string;
        text_search?: string;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/customers';
};

export type GetCustomerErrors = {
    422: HttpValidationError;
};

export type GetCustomerError = GetCustomerErrors[keyof GetCustomerErrors];

export type GetCustomerResponses = {
    200: GetCustomerResDto;
};

export type GetCustomerResponse =
    GetCustomerResponses[keyof GetCustomerResponses];

export type CreateCustomerData = {
    body: CreateCustomerReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/customers';
};

export type CreateCustomerErrors = {
    422: HttpValidationError;
};

export type CreateCustomerError =
    CreateCustomerErrors[keyof CreateCustomerErrors];

export type CreateCustomerResponses = {
    200: CreateCustomerResDto;
};

export type CreateCustomerResponse =
    CreateCustomerResponses[keyof CreateCustomerResponses];

export type GetCustomer1Data = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        customer_id: string;
    };
    query?: never;
    url: '/api/v1/customers/{customer_id}';
};

export type GetCustomer1Errors = {
    422: HttpValidationError;
};

export type GetCustomer1Error = GetCustomer1Errors[keyof GetCustomer1Errors];

export type GetCustomer1Responses = {
    200: GetCustomer1ResDto;
};

export type GetCustomer1Response =
    GetCustomer1Responses[keyof GetCustomer1Responses];

export type UpdateCustomerData = {
    body: UpdateCustomerReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        customer_id: string;
    };
    query?: never;
    url: '/api/v1/customers/{customer_id}';
};

export type UpdateCustomerErrors = {
    422: HttpValidationError;
};

export type UpdateCustomerError =
    UpdateCustomerErrors[keyof UpdateCustomerErrors];

export type UpdateCustomerResponses = {
    200: UpdateCustomerResDto;
};

export type UpdateCustomerResponse =
    UpdateCustomerResponses[keyof UpdateCustomerResponses];

export type UpdateAttachmentsCustomersData = {
    body: UpdateUserReqProfileAttachmentsDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        customer_id: string;
    };
    query?: never;
    url: '/api/v1/customers/{customer_id}/attachments';
};

export type UpdateAttachmentsCustomersErrors = {
    422: HttpValidationError;
};

export type UpdateAttachmentsCustomersError =
    UpdateAttachmentsCustomersErrors[keyof UpdateAttachmentsCustomersErrors];

export type UpdateAttachmentsCustomersResponses = {
    200: UpdateCustomerResDto;
};

export type UpdateAttachmentsCustomersResponse =
    UpdateAttachmentsCustomersResponses[keyof UpdateAttachmentsCustomersResponses];

export type GetOrdersData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        action?: 'created' | 'last_updated' | 'deleted';
        at_start?: number;
        at_end?: number;
        by_id?: string;
        by_name?: string;
        statuses?: Array<OrderStatus>;
        text_search?: string;
        bookings?: boolean;
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/orders';
};

export type GetOrdersErrors = {
    422: HttpValidationError;
};

export type GetOrdersError = GetOrdersErrors[keyof GetOrdersErrors];

export type GetOrdersResponses = {
    200: GetOrdersResDto;
};

export type GetOrdersResponse = GetOrdersResponses[keyof GetOrdersResponses];

export type CreateOrderData = {
    body: CreateOrderReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/orders';
};

export type CreateOrderErrors = {
    422: HttpValidationError;
};

export type CreateOrderError = CreateOrderErrors[keyof CreateOrderErrors];

export type CreateOrderResponses = {
    200: CreateOrderResDto;
};

export type CreateOrderResponse =
    CreateOrderResponses[keyof CreateOrderResponses];

export type GetOrderData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        order_id: string;
    };
    query?: never;
    url: '/api/v1/orders/{order_id}';
};

export type GetOrderErrors = {
    422: HttpValidationError;
};

export type GetOrderError = GetOrderErrors[keyof GetOrderErrors];

export type GetOrderResponses = {
    200: GetOrderResDto;
};

export type GetOrderResponse = GetOrderResponses[keyof GetOrderResponses];

export type CancelOrdersData = {
    body: CancelOrdersReqDto;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        order_id: string;
    };
    query?: never;
    url: '/api/v1/orders/{order_id}/cancel';
};

export type CancelOrdersErrors = {
    422: HttpValidationError;
};

export type CancelOrdersError = CancelOrdersErrors[keyof CancelOrdersErrors];

export type CancelOrdersResponses = {
    200: CancelOrdersResDto;
};

export type CancelOrdersResponse =
    CancelOrdersResponses[keyof CancelOrdersResponses];

export type ExportDetailsOrdersData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        order_id: string;
    };
    query?: never;
    url: '/api/v1/orders/{order_id}/export';
};

export type ExportDetailsOrdersErrors = {
    422: HttpValidationError;
};

export type ExportDetailsOrdersError =
    ExportDetailsOrdersErrors[keyof ExportDetailsOrdersErrors];

export type ExportDetailsOrdersResponses = {
    200: unknown;
};

export type SendOrderCheckoutUrlData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        order_id: string;
    };
    query?: {
        send_email?: boolean;
    };
    url: '/api/v1/orders/{order_id}/checkout_url';
};

export type SendOrderCheckoutUrlErrors = {
    422: HttpValidationError;
};

export type SendOrderCheckoutUrlError =
    SendOrderCheckoutUrlErrors[keyof SendOrderCheckoutUrlErrors];

export type SendOrderCheckoutUrlResponses = {
    200: unknown;
};

export type UpdateOtaStatusData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path: {
        ota_name: OtaName;
    };
    query?: {
        supplier_id?: string;
        activate?: boolean;
    };
    url: '/api/v1/otas/{ota_name}';
};

export type UpdateOtaStatusErrors = {
    422: HttpValidationError;
};

export type UpdateOtaStatusError =
    UpdateOtaStatusErrors[keyof UpdateOtaStatusErrors];

export type UpdateOtaStatusResponses = {
    200: unknown;
};

export type GetActivatedOtasData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/otas';
};

export type GetActivatedOtasErrors = {
    422: HttpValidationError;
};

export type GetActivatedOtasError =
    GetActivatedOtasErrors[keyof GetActivatedOtasErrors];

export type GetActivatedOtasResponses = {
    200: GetActivatedOtasResDto;
};

export type GetActivatedOtasResponse =
    GetActivatedOtasResponses[keyof GetActivatedOtasResponses];

export type FetchTokenWidgetsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        name?: string;
    };
    url: '/api/v1/widgets/token';
};

export type FetchTokenWidgetsErrors = {
    422: HttpValidationError;
};

export type FetchTokenWidgetsError =
    FetchTokenWidgetsErrors[keyof FetchTokenWidgetsErrors];

export type FetchTokenWidgetsResponses = {
    200: unknown;
};

export type GetFxData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/fx/latest';
};

export type GetFxErrors = {
    422: HttpValidationError;
};

export type GetFxError = GetFxErrors[keyof GetFxErrors];

export type GetFxResponses = {
    200: RatesResponse;
};

export type GetFxResponse = GetFxResponses[keyof GetFxResponses];

export type GetLocationsData = {
    body?: never;
    headers?: {
        'X-API-Key'?: string;
    };
    path?: never;
    query?: {
        page_number?: number;
        page_size?: number;
        start_at_id?: string;
    };
    url: '/api/v1/locations';
};

export type GetLocationsErrors = {
    422: HttpValidationError;
};

export type GetLocationsError = GetLocationsErrors[keyof GetLocationsErrors];

export type GetLocationsResponses = {
    200: GetLocationsResDto;
};

export type GetLocationsResponse =
    GetLocationsResponses[keyof GetLocationsResponses];
